export default [
  { id: "19", stamnummer: "1", naam: "R Antwerp FC", taal: "nl" },
  { id: "13", stamnummer: "3", naam: "Club Brugge KV", taal: "nl" },
  { id: "20", stamnummer: "4", naam: "RFC De Liege", taal: "fr" },
  { id: "148", stamnummer: "5", naam: "R Leopold FC", taal: "fr" },
  { id: "1892", stamnummer: "6", naam: "KFC Rhodienne-de Hoek", taal: "" },
  { id: "4", stamnummer: "7", naam: "KAA Gent", taal: "nl" },
  { id: "11210", stamnummer: "9", naam: "R Union Limbourg FC", taal: "" },
  { id: "38", stamnummer: "10", naam: "R Union St-gilloise", taal: "fr" },
  { id: "39", stamnummer: "11", naam: "Racing Club Gent", taal: "nl" },
  { id: "3", stamnummer: "12", naam: "Cercle Brugge KSV", taal: "nl" },
  { id: "149", stamnummer: "14", naam: "RAF Franchimontois", taal: "fr" },
  { id: "2", stamnummer: "16", naam: "R Standard De Liege", taal: "fr" },
  { id: "5", stamnummer: "19", naam: "KV Kortrijk", taal: "nl" },
  {
    id: "7",
    stamnummer: "22",
    naam: "Sporting Du Pays De Charleroi",
    taal: "fr",
  },
  { id: "55", stamnummer: "24", naam: "KRC Mechelen", taal: "nl" },
  { id: "10", stamnummer: "25", naam: "Yellow Red KV Mechelen", taal: "nl" },
  { id: "21", stamnummer: "26", naam: "RFC Tournai", taal: "fr" },
  { id: "85", stamnummer: "28", naam: "K Berchem Sport 2004", taal: "nl" },
  { id: "22", stamnummer: "30", naam: "K Lierse SK", taal: "nl" },
  { id: "23", stamnummer: "31", naam: "KV Oostende", taal: "nl" },
  { id: "150", stamnummer: "32", naam: "R Herve FC", taal: "fr" },
  {
    id: "151",
    stamnummer: "33",
    naam: "Racing Club Star Verviers",
    taal: "fr",
  },
  { id: "1", stamnummer: "35", naam: "RSC Anderlecht", taal: "fr" },
  { id: "24", stamnummer: "38", naam: "KSK Ronse", taal: "nl" },
  { id: "1233", stamnummer: "39", naam: "FC Borght-humbeek", taal: "" },
  { id: "152", stamnummer: "40", naam: "RUS Gold Star Liege", taal: "fr" },
  { id: "10987", stamnummer: "41", naam: "KFC Diest", taal: "" },
  { id: "10276", stamnummer: "42", naam: "R Ixelles SC", taal: "fr" },
  { id: "56", stamnummer: "43", naam: "R Cappellen FC", taal: "nl" },
  { id: "6", stamnummer: "44", naam: "RAEC Mons", taal: "fr" },
  { id: "1234", stamnummer: "48", naam: "KSC Blankenberge", taal: "" },
  { id: "57", stamnummer: "54", naam: "K Sportklub Tongeren", taal: "nl" },
  { id: "1235", stamnummer: "55", naam: "KCVV Elewijt", taal: "" },
  { id: "153", stamnummer: "56", naam: "SCT Menen", taal: "nl" },
  { id: "154", stamnummer: "57", naam: "KAV Dendermonde", taal: "nl" },
  { id: "117", stamnummer: "60", naam: "R Spa FC", taal: "fr" },
  { id: "86", stamnummer: "64", naam: "K Tubantia Borgerhout VK", taal: "nl" },
  { id: "155", stamnummer: "69", naam: "R Gosselies Sports", taal: "fr" },
  { id: "1236", stamnummer: "74", naam: "RFC Croatia  Wandre", taal: "" },
  { id: "156", stamnummer: "75", naam: "RCS Brainois", taal: "fr" },
  { id: "118", stamnummer: "76", naam: "RFC Huy", taal: "fr" },
  { id: "158", stamnummer: "79", naam: "R Wavre Limal", taal: "fr" },
  { id: "159", stamnummer: "80", naam: "KSV Veurne", taal: "nl" },
  { id: "40", stamnummer: "81", naam: "KSV Oudenaarde", taal: "nl" },
  { id: "160", stamnummer: "82", naam: "FC Herstal", taal: "fr" },
  { id: "10691", stamnummer: "7741", naam: "SK Pepingen-halle", taal: "" },
  { id: "1237", stamnummer: "89", naam: "Hodimont", taal: "" },
  { id: "41", stamnummer: "90", naam: "SC Eendracht Aalst", taal: "nl" },
  { id: "69", stamnummer: "94", naam: "Raal La Louviere", taal: "fr" },
  { id: "162", stamnummer: "95", naam: "Rfc Wetteren", taal: "nl" },
  { id: "70", stamnummer: "100", naam: "KVK Westhoek", taal: "nl" },
  { id: "163", stamnummer: "101", naam: "R Knokke FC", taal: "nl" },
  { id: "164", stamnummer: "125", naam: "K Boechoutse VV", taal: "nl" },
  { id: "1238", stamnummer: "126", naam: "RCS Stavelotain", taal: "" },
  {
    id: "11756",
    stamnummer: "127",
    naam: "R. Entente Sambreville",
    taal: "fr",
  },
  { id: "165", stamnummer: "128", naam: "R Etoile Sp Dalhemoise", taal: "fr" },
  { id: "166", stamnummer: "129", naam: "RLC Hornu", taal: "fr" },
  { id: "167", stamnummer: "130", naam: "R Ougree FC", taal: "fr" },
  { id: "168", stamnummer: "131", naam: "KRC De Panne", taal: "nl" },
  { id: "25", stamnummer: "132", naam: "KVK Tienen", taal: "nl" },
  { id: "169", stamnummer: "133", naam: "RSC Templeuvois", taal: "fr" },
  { id: "17", stamnummer: "134", naam: "KSV Roeselare", taal: "nl" },
  { id: "170", stamnummer: "137", naam: "RSC Wasmes", taal: "fr" },
  { id: "1239", stamnummer: "142", naam: "KFC Avenir Lembeek", taal: "" },
  { id: "59", stamnummer: "148", naam: "Kfc Turnhout", taal: "nl" },
  { id: "1240", stamnummer: "149", naam: "R Ham FC", taal: "" },
  { id: "172", stamnummer: "150", naam: "KFC Poperinge", taal: "nl" },
  { id: "173", stamnummer: "151", naam: "KSV Nieuwpoort", taal: "nl" },
  { id: "87", stamnummer: "155", naam: "Beerschot VA", taal: "nl" },
  {
    id: "26",
    stamnummer: "156",
    naam: "Union Namur Fosses-la-ville",
    taal: "fr",
  },
  { id: "116", stamnummer: "167", naam: "Fc Seraing", taal: "fr" },
  { id: "11006", stamnummer: "171", naam: "RFC Grez-doiceau", taal: "" },
  { id: "1241", stamnummer: "172", naam: "RSC Tilffois", taal: "" },
  { id: "1242", stamnummer: "178", naam: "R La Hulpe SC", taal: "" },
  { id: "174", stamnummer: "179", naam: "Entente Amay", taal: "fr" },
  { id: "119", stamnummer: "188", naam: "RFC Malmundaria 1904", taal: "fr" },
  { id: "175", stamnummer: "189", naam: "KEG Gistel", taal: "nl" },
  { id: "176", stamnummer: "190", naam: "R Stade Waremmien FC", taal: "fr" },
  { id: "10978", stamnummer: "199", naam: "RAS Jodoigne", taal: "fr" },
  { id: "27", stamnummer: "200", naam: "R Excelsior Virton", taal: "fr" },
  {
    id: "177",
    stamnummer: "201",
    naam: "KSC Maccabi-voetbal Antwerp",
    taal: "fr",
  },
  { id: "179", stamnummer: "210", naam: "K Turnhoutse SK HIH", taal: "nl" },
  { id: "28", stamnummer: "211", naam: "KFC Vigor Wuitens Hamme", taal: "nl" },
  { id: "43", stamnummer: "213", naam: "La Louviere Centre", taal: "fr" },
  { id: "120", stamnummer: "215", naam: "RFC Hannutois", taal: "fr" },
  { id: "44", stamnummer: "216", naam: "Royal Excel Mouscron", taal: "fr" },
  { id: "1243", stamnummer: "218", naam: "VV Tielt", taal: "" },
  { id: "45", stamnummer: "225", naam: "SV Sottegem", taal: "nl" },
  { id: "180", stamnummer: "226", naam: "Football Club De Trooz", taal: "fr" },
  { id: "181", stamnummer: "228", naam: "KFC Brasschaat", taal: "nl" },
  { id: "182", stamnummer: "231", naam: "FCE Meetjesland", taal: "nl" },
  { id: "183", stamnummer: "232", naam: "Bilzerse Waltwilder VV", taal: "nl" },
  { id: "184", stamnummer: "234", naam: "R Goutroux Sports", taal: "fr" },
  { id: "185", stamnummer: "236", naam: "R Ent Blegnytoise", taal: "" },
  { id: "29", stamnummer: "246", naam: "Olympic Club Charleroi", taal: "fr" },
  {
    id: "71",
    stamnummer: "248",
    naam: "Es Couvin-mariembourg Fraire",
    taal: "fr",
  },
  { id: "1244", stamnummer: "254", naam: "RSC Athusien", taal: "" },
  { id: "121", stamnummer: "260", naam: "Fcb Sprimont", taal: "fr" },
  { id: "186", stamnummer: "263", naam: "R Elan Dalhem", taal: "" },
  { id: "187", stamnummer: "267", naam: "Juprelle", taal: "" },
  { id: "188", stamnummer: "268", naam: "RCS Florennois", taal: "" },
  { id: "189", stamnummer: "279", naam: "RRC Vottem", taal: "" },
  { id: "12", stamnummer: "282", naam: "KSC Lokeren OVl", taal: "nl" },
  { id: "88", stamnummer: "284", naam: "KFC Duffel", taal: "nl" },
  { id: "191", stamnummer: "290", naam: "KSV Geraardsbergen", taal: "" },
  {
    id: "193",
    stamnummer: "298",
    naam: "A.r.s. De L'entite De Floreffe",
    taal: "",
  },
  { id: "1245", stamnummer: "299", naam: "R Exc FC Lambermontois", taal: "" },
  {
    id: "194",
    stamnummer: "301",
    naam: "Football Couillet Marcinelle",
    taal: "",
  },
  { id: "195", stamnummer: "302", naam: "FC Trois-frontieres", taal: "" },
  {
    id: "122",
    stamnummer: "307",
    naam: "Cercle Sportif Andennais",
    taal: "fr",
  },
  { id: "197", stamnummer: "311", naam: "R.r.c. D'etterbeek", taal: "" },
  { id: "18", stamnummer: "322", naam: "KRC Genk", taal: "nl" },
  { id: "1246", stamnummer: "328", naam: "R Standard FC Bouillon", taal: "" },
  { id: "198", stamnummer: "330", naam: "KVK Beringen", taal: "" },
  { id: "1247", stamnummer: "332", naam: "Vv Vlug En Vrij Stokkem", taal: "" },
  { id: "89", stamnummer: "342", naam: "KSV Bornem", taal: "nl" },
  { id: "200", stamnummer: "343", naam: "R Stade Brainois", taal: "" },
  { id: "201", stamnummer: "349", naam: "R St FC Andrimont", taal: "" },
  { id: "203", stamnummer: "358", naam: "K Wuustwezel FC", taal: "" },
  { id: "205", stamnummer: "367", naam: "KFC Muizen", taal: "" },
  { id: "60", stamnummer: "369", naam: "Vis�", taal: "fr" },
  { id: "206", stamnummer: "370", naam: "R Leopold Club Mesvinois", taal: "" },
  { id: "30", stamnummer: "373", naam: "K St-truidense VV", taal: "nl" },
  { id: "207", stamnummer: "375", naam: "Bel.Edegem", taal: "" },
  { id: "208", stamnummer: "378", naam: "RFC Queue-du-bois", taal: "" },
  { id: "209", stamnummer: "380", naam: "KFC Grobbendonk", taal: "" },
  { id: "10990", stamnummer: "384", naam: "KV Tervuren-duisburg", taal: "" },
  { id: "210", stamnummer: "392", naam: "RES Templiers-nandrin", taal: "" },
  { id: "211", stamnummer: "402", naam: "KVV OG Vorselaar", taal: "" },
  { id: "212", stamnummer: "406", naam: "R Esneux Sp", taal: "" },
  { id: "214", stamnummer: "413", naam: "RAC Leuze-longchamps", taal: "" },
  { id: "215", stamnummer: "431", naam: "FC 1912 Raeren-eynatten", taal: "" },
  { id: "216", stamnummer: "433", naam: "K Europa 90 Kraainem FC", taal: "" },
  { id: "1249", stamnummer: "436", naam: "K Ramsel FC", taal: "" },
  { id: "1250", stamnummer: "442", naam: "K Zandhoven SK", taal: "" },
  { id: "1251", stamnummer: "459", naam: "KFC Heultje", taal: "" },
  { id: "123", stamnummer: "460", naam: "RU Wallonne Ciney", taal: "fr" },
  { id: "217", stamnummer: "474", naam: "RSD Jette", taal: "" },
  { id: "218", stamnummer: "479", naam: "R Exc FC Moustier", taal: "" },
  { id: "10985", stamnummer: "490", naam: "KVC Haacht", taal: "" },
  { id: "1252", stamnummer: "496", naam: "RCS Ent Mosane", taal: "" },
  { id: "220", stamnummer: "500", naam: "Tor Deurne Pirates", taal: "" },
  { id: "1253", stamnummer: "502", naam: "R Entente Mons Nord", taal: "" },
  { id: "1254", stamnummer: "509", naam: "RSA Forchies", taal: "" },
  { id: "221", stamnummer: "525", naam: "Entit� Engis", taal: "" },
  { id: "61", stamnummer: "526", naam: "Rfc Un La Calamine", taal: "fr" },
  { id: "223", stamnummer: "529", naam: "Chaudfontaine", taal: "" },
  { id: "72", stamnummer: "535", naam: "KWS Club Lauwe", taal: "nl" },
  { id: "224", stamnummer: "544", naam: "SC City Pirates Antwerpen", taal: "" },
  { id: "1255", stamnummer: "555", naam: "RCS De La Salm", taal: "" },
  { id: "225", stamnummer: "556", naam: "RRC De Boitsfort", taal: "" },
  { id: "1256", stamnummer: "562", naam: "RUS Leglise", taal: "" },
  { id: "226", stamnummer: "577", naam: "KV Westmalle", taal: "" },
  { id: "227", stamnummer: "579", naam: "KFC Wezembeek-oppem", taal: "" },
  { id: "62", stamnummer: "595", naam: "K Bocholter VV", taal: "nl" },
  { id: "1257", stamnummer: "599", naam: "KFC Lentezon Beerse", taal: "" },
  { id: "63", stamnummer: "606", naam: "KFC Dessel Sport", taal: "nl" },
  { id: "230", stamnummer: "628", naam: "KCS Machelen", taal: "" },
  { id: "231", stamnummer: "646", naam: "RFC Ecaussinnois", taal: "" },
  { id: "232", stamnummer: "658", naam: "Zwartberg FC", taal: "" },
  { id: "233", stamnummer: "659", naam: "KFC Peutie", taal: "" },
  { id: "234", stamnummer: "662", naam: "KFC Evergem-center", taal: "" },
  { id: "235", stamnummer: "665", naam: "Rochus Deurne", taal: "" },
  { id: "236", stamnummer: "677", naam: "R Racing Club De Waterloo", taal: "" },
  { id: "237", stamnummer: "683", naam: "KFC Herenthout", taal: "" },
  { id: "238", stamnummer: "704", naam: "RFC Houdinois", taal: "" },
  { id: "1258", stamnummer: "708", naam: "US Auvelais", taal: "" },
  { id: "239", stamnummer: "725", naam: "Chatelet-farciennes SC", taal: "" },
  {
    id: "1259",
    stamnummer: "727",
    naam: "Fc St-jozef SK Rijkevorsel",
    taal: "",
  },
  { id: "240", stamnummer: "781", naam: "K Vroenhoven VV", taal: "" },
  { id: "31", stamnummer: "818", naam: "KM SK Deinze", taal: "nl" },
  { id: "73", stamnummer: "822", naam: "Km Torhout", taal: "nl" },
  { id: "64", stamnummer: "844", naam: "FC Wezel Sport", taal: "nl" },
  { id: "241", stamnummer: "852", naam: "KFC Mol", taal: "" },
  { id: "1260", stamnummer: "858", naam: "KMJ FC Zichem", taal: "" },
  { id: "242", stamnummer: "914", naam: "RUFC Ransartoise", taal: "" },
  { id: "1261", stamnummer: "915", naam: "KFC Arendonk Sport", taal: "" },
  {
    id: "74",
    stamnummer: "935",
    naam: "Fc Mu Izegem-ingelmunster",
    taal: "nl",
  },
  { id: "90", stamnummer: "956", naam: "KFC Schoten SK", taal: "nl" },
  { id: "1262", stamnummer: "973", naam: "RES Orgeotoise", taal: "" },
  { id: "243", stamnummer: "981", naam: "KVV Scherpenheuvel Sport", taal: "" },
  { id: "244", stamnummer: "990", naam: "RFC Messancy", taal: "" },
  { id: "245", stamnummer: "1000", naam: "R Oupeye Fc", taal: "" },
  { id: "10986", stamnummer: "1002", naam: "KOVC Sterrebeek", taal: "nl" },
  { id: "91", stamnummer: "1021", naam: "KSC Grimbergen", taal: "nl" },
  { id: "246", stamnummer: "1023", naam: "R Ass Leuze-lignette", taal: "" },
  { id: "92", stamnummer: "1046", naam: "KFC Eendr Zele", taal: "nl" },
  { id: "247", stamnummer: "1050", naam: "K Lanaken VV", taal: "" },
  { id: "248", stamnummer: "1051", naam: "KFCMDHalen", taal: "" },
  { id: "1263", stamnummer: "1060", naam: "Banneux", taal: "" },
  { id: "249", stamnummer: "1065", naam: "KFC Nijlen", taal: "" },
  { id: "993", stamnummer: "9246", naam: "Leeuw Brucom", taal: "" },
  { id: "250", stamnummer: "1085", naam: "K Ternesse VV Wommelgem", taal: "" },
  {
    id: "1265",
    stamnummer: "1086",
    naam: "KFC De Vrede Wechelderzande",
    taal: "",
  },
  { id: "251", stamnummer: "1089", naam: "Schilde SK", taal: "" },
  { id: "252", stamnummer: "1092", naam: "K Wijnegem VC", taal: "" },
  { id: "136", stamnummer: "1124", naam: "KFC Zwarte Leeuw", taal: "nl" },
  { id: "1266", stamnummer: "1140", naam: "K Eendracht FC Zoersel", taal: "" },
  { id: "1267", stamnummer: "1143", naam: "K Antonia FC", taal: "" },
  {
    id: "1268",
    stamnummer: "1167",
    naam: "R Jeunesse Freylangeoise",
    taal: "",
  },
  { id: "253", stamnummer: "1189", naam: "R Jumet SC", taal: "" },
  { id: "1269", stamnummer: "1192", naam: "R Lindbergh Club Givry", taal: "" },
  { id: "254", stamnummer: "1203", naam: "RUS Flobecquoise", taal: "" },
  { id: "255", stamnummer: "1218", naam: "K.S.K. JECORA", taal: "" },
  { id: "1270", stamnummer: "1245", naam: "RCS Halanzy", taal: "" },
  {
    id: "256",
    stamnummer: "1249",
    naam: "R Alliance Melen-micheroux",
    taal: "",
  },
  { id: "257", stamnummer: "1255", naam: "KFC Meulebeke", taal: "" },
  { id: "101", stamnummer: "1349", naam: "K Olympia SC Wijgmaal", taal: "nl" },
  { id: "258", stamnummer: "1352", naam: "Ursl Vise", taal: "fr" },
  { id: "102", stamnummer: "1357", naam: "KFC St-lenaarts", taal: "nl" },
  { id: "259", stamnummer: "1409", naam: "K St Sv Denderleeuw", taal: "" },
  {
    id: "1272",
    stamnummer: "1422",
    naam: "R Standard Club Oheytois",
    taal: "",
  },
  { id: "1273", stamnummer: "1433", naam: "RES Aubange", taal: "" },
  { id: "260", stamnummer: "1434", naam: "KV Zuun", taal: "" },
  { id: "261", stamnummer: "1453", naam: "KFC Lint", taal: "" },
  { id: "1274", stamnummer: "1456", naam: "KVC Oostmalle Sp", taal: "" },
  { id: "262", stamnummer: "1464", naam: "R Union Rixensartoise", taal: "" },
  { id: "263", stamnummer: "1476", naam: "Exc FC Evelette-jallet", taal: "" },
  { id: "1275", stamnummer: "1479", naam: "KVV Hoeselt", taal: "" },
  { id: "264", stamnummer: "1491", naam: "RUS Ethe Belmont", taal: "" },
  { id: "1276", stamnummer: "1497", naam: "RSC Modave", taal: "" },
  { id: "265", stamnummer: "1556", naam: "RU St-g Sinsin-waillet", taal: "" },
  { id: "1277", stamnummer: "1557", naam: "KSK Oelegem", taal: "" },
  { id: "142", stamnummer: "1574", naam: "Racing Club Harelbeke", taal: "nl" },
  { id: "266", stamnummer: "1590", naam: "RCS Libramontois", taal: "" },
  { id: "267", stamnummer: "1605", naam: "KVC Arbeid Adelt Rekem", taal: "" },
  { id: "1278", stamnummer: "1608", naam: "RSC Anthisnois", taal: "" },
  { id: "268", stamnummer: "1614", naam: "US Rebecquoise", taal: "" },
  { id: "1279", stamnummer: "1619", naam: "R Dottignies Sp", taal: "" },
  { id: "1280", stamnummer: "1634", naam: "KVC Deerlijk Sport", taal: "" },
  { id: "270", stamnummer: "1640", naam: "K Bevel FC", taal: "" },
  { id: "145", stamnummer: "1654", naam: "ES Wanze/bas-oha", taal: "fr" },
  { id: "1281", stamnummer: "1657", naam: "R Dinant FC", taal: "" },
  {
    id: "271",
    stamnummer: "1669",
    naam: "K. Vict. V.v. 's Herenelderen",
    taal: "",
  },
  { id: "272", stamnummer: "1678", naam: "R Soignies Sports", taal: "" },
  { id: "273", stamnummer: "1682", naam: "RFCE Maurage", taal: "" },
  { id: "274", stamnummer: "1690", naam: "R Sougne-remouch Sp", taal: "" },
  {
    id: "11211",
    stamnummer: "1692",
    naam: "R. All. Clavinoise S.c.",
    taal: "",
  },
  { id: "275", stamnummer: "1708", naam: "U St-ghisl Tertre-hautr", taal: "" },
  { id: "1282", stamnummer: "1728", naam: "RFC 1924 St-vith", taal: "" },
  { id: "10696", stamnummer: "1740", naam: "ERC Hoeilaart", taal: "" },
  { id: "1295", stamnummer: "2025", naam: "Olen United", taal: "" },
  { id: "1283", stamnummer: "1772", naam: "RFC Wiersien", taal: "" },
  { id: "277", stamnummer: "1774", naam: "K Verbr Balen", taal: "" },
  { id: "1284", stamnummer: "1775", naam: "K Brecht SK", taal: "" },
  { id: "278", stamnummer: "1784", naam: "KWS Oudenburg", taal: "" },
  { id: "124", stamnummer: "1785", naam: "RFC Bioul 81", taal: "fr" },
  {
    id: "1285",
    stamnummer: "1792",
    naam: "KFC Heidebloem Pulderbos",
    taal: "",
  },
  {
    id: "125",
    stamnummer: "1798",
    naam: "RFC Turkania Faymonville",
    taal: "fr",
  },
  { id: "75", stamnummer: "1801", naam: "RSC Paturageois", taal: "fr" },
  { id: "1286", stamnummer: "1808", naam: "Rcs Xhorisien", taal: "" },
  { id: "279", stamnummer: "1815", naam: "KSK Geluwe", taal: "" },
  { id: "1287", stamnummer: "1848", naam: "RSC Muno", taal: "" },
  { id: "1288", stamnummer: "1855", naam: "R Excelsior Stephanois", taal: "" },
  { id: "280", stamnummer: "1858", naam: "FC Welkenraedt", taal: "" },
  { id: "281", stamnummer: "1869", naam: "KVK Avelgem", taal: "" },
  { id: "1289", stamnummer: "1874", naam: "KFC Putte", taal: "" },
  { id: "1290", stamnummer: "1899", naam: "RCS Condruzien", taal: "" },
  { id: "282", stamnummer: "1913", naam: "FC Paal-tervant", taal: "" },
  { id: "1291", stamnummer: "1918", naam: "Fc Genappe", taal: "" },
  { id: "1292", stamnummer: "1923", naam: "Rrc Trois-ponts", taal: "" },
  { id: "76", stamnummer: "1934", naam: "KVV Coxyde", taal: "nl" },
  { id: "32", stamnummer: "1936", naam: "FCM Brussels S.", taal: "fr" },
  { id: "283", stamnummer: "1943", naam: "KFC Meise", taal: "" },
  { id: "284", stamnummer: "1955", naam: "KSK Vlamertinge", taal: "" },
  { id: "285", stamnummer: "1962", naam: "R All FC Oppagne-weris", taal: "" },
  { id: "77", stamnummer: "1972", naam: "KSV Diksmuide", taal: "nl" },
  { id: "144", stamnummer: "1979", naam: "R Aywaille FC", taal: "fr" },
  { id: "1293", stamnummer: "1985", naam: "KSK Wenduine", taal: "" },
  { id: "1294", stamnummer: "1993", naam: "RUS Stree", taal: "" },
  { id: "14", stamnummer: "2024", naam: "KVC Westerlo", taal: "nl" },
  { id: "1295", stamnummer: "2025", naam: "Olen United", taal: "" },
  { id: "11007", stamnummer: "2030", naam: "FC Averbode-okselaar", taal: "" },
  { id: "287", stamnummer: "2040", naam: "KFC Tongerlo", taal: "" },
  { id: "103", stamnummer: "2065", naam: "K Witgoor Sport Dessel", taal: "nl" },
  { id: "1296", stamnummer: "2078", naam: "K Olsene Sportief", taal: "" },
  { id: "1297", stamnummer: "2081", naam: "K Eendr Club Rotem", taal: "" },
  { id: "289", stamnummer: "2086", naam: "KSV Moorsele", taal: "" },
  { id: "290", stamnummer: "2098", naam: "RFC Orp-noduwez", taal: "" },
  { id: "291", stamnummer: "2100", naam: "R Oreye Union", taal: "" },
  { id: "1298", stamnummer: "2121", naam: "RUS Herseautoise", taal: "" },
  { id: "292", stamnummer: "2123", naam: "RUS Marbehan", taal: "" },
  { id: "1299", stamnummer: "2124", naam: "KSK Zingem", taal: "" },
  { id: "65", stamnummer: "2138", naam: "K Rupel Boom FC", taal: "nl" },
  { id: "294", stamnummer: "2147", naam: "As - Niel United", taal: "" },
  { id: "10015", stamnummer: "2152", naam: "R Un Auderghem", taal: "" },
  { id: "1300", stamnummer: "2155", naam: "KFC Exc Bouwel", taal: "" },
  {
    id: "1301",
    stamnummer: "2164",
    naam: "Alliance Des Hautes Fagnes",
    taal: "",
  },
  { id: "296", stamnummer: "2166", naam: "Vr. Zolder", taal: "" },
  { id: "1302", stamnummer: "2167", naam: "RUS Les Bulles", taal: "" },
  { id: "104", stamnummer: "2169", naam: "AS Verbroedering Geel", taal: "nl" },
  { id: "1303", stamnummer: "2173", naam: "KFC Heusden Sport", taal: "" },
  { id: "1210", stamnummer: "2175", naam: "KVK Wemmel", taal: "nl" },
  { id: "298", stamnummer: "2218", naam: "K Zwaluwen Olmen", taal: "" },
  { id: "299", stamnummer: "2223", naam: "K Blauwvoet Oevel", taal: "nl" },
  { id: "300", stamnummer: "2233", naam: "Sc Chestrolais", taal: "" },
  { id: "301", stamnummer: "2235", naam: "R Gembloux Sports", taal: "" },
  { id: "302", stamnummer: "2239", naam: "RRC Stockay-warfusee", taal: "" },
  { id: "1304", stamnummer: "2247", naam: "RFC Natoye", taal: "" },
  { id: "304", stamnummer: "2255", naam: "KFC Marke", taal: "" },
  { id: "305", stamnummer: "2263", naam: "RLC Bastogne", taal: "" },
  { id: "306", stamnummer: "2271", naam: "KFC Aalbeke Sport", taal: "" },
  { id: "11212", stamnummer: "2291", naam: "R.u.s. St-roch Soy", taal: "" },
  { id: "1305", stamnummer: "2295", naam: "KFC Linda Olen", taal: "" },
  { id: "308", stamnummer: "2298", naam: "R Jespo Comines-warneton", taal: "" },
  { id: "33", stamnummer: "2300", naam: "KSK Beveren", taal: "nl" },
  { id: "309", stamnummer: "2311", naam: "Rfc Baulet", taal: "" },
  { id: "11213", stamnummer: "2323", naam: "K. Rekkem Sport", taal: "" },
  { id: "311", stamnummer: "2364", naam: "RFC Perwez", taal: "" },
  { id: "66", stamnummer: "2366", naam: "Hoogstraten VV", taal: "nl" },
  { id: "1307", stamnummer: "2373", naam: "KVK Ninove", taal: "nl" },
  { id: "312", stamnummer: "2374", naam: "RFC Ouffet-warzee", taal: "" },
  { id: "11214", stamnummer: "2389", naam: "R.u.s. Louftemont", taal: "" },
  { id: "1309", stamnummer: "2391", naam: "KVV Vosselaar", taal: "" },
  { id: "313", stamnummer: "2399", naam: "K HIH Hoepertingen", taal: "" },
  { id: "314", stamnummer: "2401", naam: "RJR Aye FC", taal: "" },
  { id: "315", stamnummer: "2402", naam: "Houthalen VV", taal: "" },
  { id: "316", stamnummer: "2403", naam: "R AllFC Cuesmes", taal: "" },
  { id: "317", stamnummer: "2408", naam: "KFC Ham United", taal: "" },
  { id: "318", stamnummer: "2426", naam: "K Neeroeteren  FC", taal: "" },
  { id: "319", stamnummer: "2428", naam: "KVV Weerstand Koersel", taal: "" },
  { id: "320", stamnummer: "2429", naam: "R Harze FC", taal: "" },
  { id: "1310", stamnummer: "2462", naam: "R Anhee FC", taal: "" },
  { id: "1311", stamnummer: "2472", naam: "RFC Yvoir", taal: "" },
  { id: "321", stamnummer: "2489", naam: "K Stal Sport Koersel", taal: "" },
  { id: "322", stamnummer: "2495", naam: "Retinne", taal: "" },
  { id: "1312", stamnummer: "2498", naam: "K Boorsem Sport", taal: "" },
  { id: "1313", stamnummer: "2500", naam: "KFC St-martinus Halle", taal: "" },
  { id: "1314", stamnummer: "2503", naam: "RCS Hastierois", taal: "" },
  { id: "1315", stamnummer: "2505", naam: "SV Moorslede", taal: "" },
  { id: "1316", stamnummer: "2506", naam: "R Wallonia Libin", taal: "" },
  { id: "1317", stamnummer: "2510", naam: "K Meerle FC", taal: "" },
  { id: "1318", stamnummer: "2518", naam: "RAEC Sclayn", taal: "" },
  { id: "323", stamnummer: "2521", naam: "KSV White Star Adinkerke", taal: "" },
  { id: "324", stamnummer: "2523", naam: "R Soree FC", taal: "" },
  { id: "105", stamnummer: "2529", naam: "FC Esperanza Pelt", taal: "nl" },
  { id: "325", stamnummer: "2531", naam: "VV Koekelare", taal: "" },
  { id: "326", stamnummer: "2532", naam: "Wegnez", taal: "" },
  { id: "327", stamnummer: "2533", naam: "KVV St-denijs Sport", taal: "" },
  { id: "10472", stamnummer: "2552", naam: "KFC Meer", taal: "nl" },
  { id: "34", stamnummer: "2554", naam: "Lommel Sk", taal: "nl" },
  { id: "328", stamnummer: "2564", naam: "KFC Sparta-haacht Statie", taal: "" },
  { id: "1319", stamnummer: "2570", naam: "K Halle VV", taal: "" },
  { id: "329", stamnummer: "2574", naam: "KVC Delta Londerzeel", taal: "" },
  { id: "138", stamnummer: "2583", naam: "SK Bree R", taal: "nl" },
  { id: "1320", stamnummer: "2593", naam: "R Standard FC Bievre", taal: "" },
  { id: "330", stamnummer: "2602", naam: "R Exc De Fouches", taal: "" },
  { id: "331", stamnummer: "2604", naam: "K Bolderberg FC", taal: "" },
  { id: "1321", stamnummer: "2611", naam: "SC Mussy", taal: "" },
  {
    id: "11757",
    stamnummer: "2614",
    naam: "K.beringen-heusden-zolder",
    taal: "nl",
  },
  { id: "10974", stamnummer: "2615", naam: "Sporting Kampenhout", taal: "" },
  { id: "106", stamnummer: "2618", naam: "KFC Lille", taal: "nl" },
  { id: "332", stamnummer: "2621", naam: "KFC Kluisbergen", taal: "" },
  { id: "1322", stamnummer: "2637", naam: "K Sparta Waasmunster", taal: "" },
  { id: "1323", stamnummer: "2639", naam: "KFC Eksel", taal: "" },
  { id: "1324", stamnummer: "2641", naam: "K Berg-op Fc Beerzel", taal: "" },
  { id: "333", stamnummer: "2646", naam: "K Vlimmeren Sport", taal: "" },
  { id: "335", stamnummer: "2648", naam: "K Lanklaarse VV", taal: "" },
  { id: "336", stamnummer: "2656", naam: "RFC Rhisnois", taal: "" },
  { id: "1325", stamnummer: "2657", naam: "RCS Profondeville", taal: "" },
  { id: "337", stamnummer: "2660", naam: "K Steenokkerzeel Vlug-op", taal: "" },
  { id: "338", stamnummer: "2662", naam: "K Hechtel FC", taal: "" },
  { id: "1326", stamnummer: "2666", naam: "KFC Baasrode", taal: "" },
  { id: "1328", stamnummer: "2673", naam: "BSK Retie", taal: "nl" },
  { id: "339", stamnummer: "2679", naam: "K Noordstar VV", taal: "" },
  { id: "340", stamnummer: "2682", naam: "KV Hooikt", taal: "" },
  { id: "1329", stamnummer: "2683", naam: "K Vrijheid Herselt", taal: "" },
  { id: "341", stamnummer: "2686", naam: "K Eendr Gingelom", taal: "" },
  { id: "342", stamnummer: "2695", naam: "R Avenir Fouron FC", taal: "" },
  { id: "343", stamnummer: "2697", naam: "RES Champlonaise", taal: "" },
  { id: "344", stamnummer: "2708", naam: "RUS Ste Ode", taal: "" },
  { id: "345", stamnummer: "2719", naam: "RUS Club Anderlues", taal: "" },
  { id: "346", stamnummer: "2725", naam: "R Ortho Sport", taal: "" },
  {
    id: "347",
    stamnummer: "2727",
    naam: "White Star Schoonbeek-beverst",
    taal: "",
  },
  { id: "348", stamnummer: "2729", naam: "Fc Kerksken-haaltert", taal: "" },
  { id: "349", stamnummer: "2731", naam: "ESC Houffaloise", taal: "" },
  { id: "350", stamnummer: "2753", naam: "K Achel VV", taal: "" },
  { id: "1330", stamnummer: "2754", naam: "RUS Sartoise", taal: "" },
  { id: "351", stamnummer: "2761", naam: "RUS Berismenil", taal: "" },
  { id: "352", stamnummer: "2762", naam: "KVV HO Molenbeersel", taal: "" },
  { id: "353", stamnummer: "2765", naam: "R Exc Cl Beaumontois", taal: "" },
  { id: "354", stamnummer: "2768", naam: "RSC Naastois", taal: "" },
  { id: "355", stamnummer: "2770", naam: "K Lutlommel VV", taal: "" },
  { id: "1331", stamnummer: "2774", naam: "Entente Acren Lessines", taal: "" },
  { id: "356", stamnummer: "2777", naam: "SK Eernegem", taal: "" },
  { id: "357", stamnummer: "2780", naam: "Zonhoven United Fc", taal: "" },
  { id: "1332", stamnummer: "2781", naam: "RCS Aulnoisien", taal: "" },
  { id: "358", stamnummer: "2791", naam: "RUS Glontoise", taal: "" },
  { id: "359", stamnummer: "2794", naam: "SV Eendracht Bazel", taal: "" },
  { id: "1333", stamnummer: "2799", naam: "Union Rochefortoise", taal: "" },
  { id: "1334", stamnummer: "2804", naam: "R Lierneux FC", taal: "" },
  { id: "360", stamnummer: "2811", naam: "R Sp Bosquetia Frameries", taal: "" },
  { id: "1335", stamnummer: "2815", naam: "RJS Olnoise", taal: "" },
  { id: "1336", stamnummer: "2816", naam: "R Aubel FC", taal: "" },
  { id: "362", stamnummer: "2820", naam: "KSK Oosthoven", taal: "" },
  { id: "1337", stamnummer: "2821", naam: "K Kaulille FC", taal: "" },
  { id: "363", stamnummer: "2825", naam: "KVK Wellen", taal: "" },
  { id: "364", stamnummer: "2829", naam: "KFC Jong Vl Kruibeke", taal: "" },
  { id: "365", stamnummer: "2832", naam: "KVV Lummen", taal: "" },
  { id: "366", stamnummer: "2833", naam: "K Woudsport Houthulst", taal: "" },
  { id: "367", stamnummer: "2868", naam: "FC Netezonen Eindhout", taal: "" },
  { id: "1338", stamnummer: "2869", naam: "RUS Montagnarde", taal: "" },
  { id: "1339", stamnummer: "2871", naam: "RCS Verlaine", taal: "" },
  { id: "368", stamnummer: "2874", naam: "Union Flemalloise", taal: "" },
  { id: "1340", stamnummer: "2876", naam: "R Jeunesse Magnetoise", taal: "" },
  {
    id: "370",
    stamnummer: "2887",
    naam: "RUS Jeunesse Wandruzienne",
    taal: "",
  },
  { id: "1342", stamnummer: "2892", naam: "RFC Villers", taal: "" },
  { id: "371", stamnummer: "2894", naam: "KFC Exc Vorst", taal: "" },
  { id: "143", stamnummer: "2899", naam: "R Geants Athois", taal: "fr" },
  { id: "372", stamnummer: "2900", naam: "K Kattenbos Sport", taal: "" },
  { id: "373", stamnummer: "2901", naam: "RAS Lessines-ollignies", taal: "" },
  { id: "1343", stamnummer: "2913", naam: "FC Tilleur", taal: "fr" },
  { id: "375", stamnummer: "2918", naam: "La R Entente Wartet FC", taal: "" },
  { id: "377", stamnummer: "2941", naam: "Fc Landen", taal: "" },
  { id: "378", stamnummer: "2947", naam: "R Union Momalloise", taal: "" },
  { id: "107", stamnummer: "2948", naam: "KSK Heist", taal: "nl" },
  { id: "379", stamnummer: "2960", naam: "RSC Beaufays", taal: "" },
  { id: "380", stamnummer: "2962", naam: "KFC De Jeugd Borgloon", taal: "" },
  { id: "381", stamnummer: "2969", naam: "KVV Rauw Sport Mol", taal: "" },
  { id: "382", stamnummer: "2982", naam: "KFC Molenzonen-hallaar", taal: "" },
  { id: "383", stamnummer: "2990", naam: "KFC Moerbeke", taal: "" },
  { id: "384", stamnummer: "2997", naam: "SV Wevelgem City", taal: "nl" },
  { id: "1345", stamnummer: "3008", naam: "Entente Durbuy", taal: "" },
  { id: "385", stamnummer: "3017", naam: "R Mont FC", taal: "" },
  { id: "386", stamnummer: "3019", naam: "K Groen Rood Katelijne", taal: "" },
  { id: "126", stamnummer: "3020", naam: "R Jeun Aischoise", taal: "fr" },
  { id: "387", stamnummer: "3029", naam: "K Kontich FC", taal: "" },
  { id: "388", stamnummer: "3031", naam: "R Ol FC Stockel", taal: "" },
  { id: "1346", stamnummer: "3032", naam: "KV Cercle Melle", taal: "" },
  { id: "1347", stamnummer: "3033", naam: "ROC Rochois", taal: "" },
  { id: "1348", stamnummer: "3038", naam: "FC Gavere-asper", taal: "" },
  { id: "389", stamnummer: "3057", naam: "K Berg En Dal VV", taal: "" },
  { id: "390", stamnummer: "3062", naam: "K Eendracht De Haan", taal: "" },
  { id: "1349", stamnummer: "3093", naam: "RSC Habay La Neuve", taal: "" },
  { id: "391", stamnummer: "3106", naam: "RCS Escanaffles", taal: "" },
  { id: "392", stamnummer: "3110", naam: "K Heers VV", taal: "" },
  { id: "393", stamnummer: "3111", naam: "K Brielen Sport", taal: "" },
  { id: "67", stamnummer: "3114", naam: "RRC Hamoir", taal: "fr" },
  { id: "1350", stamnummer: "3118", naam: "Kvv Windeke", taal: "" },
  { id: "394", stamnummer: "3121", naam: "RES Melreux-hotton", taal: "" },
  { id: "395", stamnummer: "3123", naam: "K Opitter FC", taal: "" },
  {
    id: "1351",
    stamnummer: "3134",
    naam: "R Rac Athl Florenvillois",
    taal: "",
  },
  { id: "396", stamnummer: "3142", naam: "RLC Warmifontaine", taal: "" },
  { id: "397", stamnummer: "3143", naam: "ES De La Molignee", taal: "" },
  { id: "398", stamnummer: "3154", naam: "RSC Nassogne", taal: "" },
  {
    id: "399",
    stamnummer: "3155",
    naam: "K Hoger Op Wolvertem Merchtem",
    taal: "nl",
  },
  { id: "400", stamnummer: "3158", naam: "RUS Courcelloise", taal: "" },
  { id: "401", stamnummer: "3161", naam: "R Jeunesse Haccourtoise", taal: "" },
  { id: "141", stamnummer: "3172", naam: "BS Westhoek", taal: "nl" },
  { id: "402", stamnummer: "3175", naam: "KFC Herent", taal: "" },
  { id: "403", stamnummer: "3178", naam: "K Kabouters Opglabbeek", taal: "" },
  { id: "1352", stamnummer: "3182", naam: "KSOC Maria-ter-heide", taal: "" },
  { id: "404", stamnummer: "3189", naam: "RRC Longlier", taal: "" },
  { id: "1354", stamnummer: "3194", naam: "KFC Flandria Ravels", taal: "" },
  { id: "46", stamnummer: "3197", naam: "KV Woluwe-zaventem", taal: "nl" },
  { id: "1355", stamnummer: "3201", naam: "ROC Meix Dt-virton", taal: "" },
  { id: "405", stamnummer: "3203", naam: "RAC Saint-mard", taal: "" },
  { id: "1356", stamnummer: "3204", naam: "Overboelare", taal: "" },
  { id: "407", stamnummer: "3217", naam: "K.Ars.Oplinter", taal: "" },
  { id: "408", stamnummer: "3220", naam: "R Exc Bievene", taal: "" },
  { id: "409", stamnummer: "3227", naam: "RUS Gouvy", taal: "" },
  { id: "410", stamnummer: "3244", naam: "SK Herkenrode", taal: "" },
  { id: "108", stamnummer: "3245", naam: "Sp Hasselt", taal: "nl" },
  { id: "411", stamnummer: "3246", naam: "Vc Nokere-kruishoutem", taal: "" },
  { id: "412", stamnummer: "3256", naam: "K Merksplas SK", taal: "" },
  { id: "127", stamnummer: "3262", naam: "RW Walhain CG", taal: "fr" },
  { id: "413", stamnummer: "3264", naam: "SC Hoegaarden-outgaarden", taal: "" },
  { id: "1358", stamnummer: "3271", naam: "Eendracht Moortsele", taal: "" },
  { id: "1359", stamnummer: "3283", naam: "RUS Mean", taal: "" },
  { id: "416", stamnummer: "3286", naam: "KVC Booischot", taal: "" },
  { id: "1360", stamnummer: "3288", naam: "K Excelsior Zedelgem", taal: "" },
  {
    id: "1361",
    stamnummer: "3293",
    naam: "K Stormvogels Drieslinter",
    taal: "",
  },
  { id: "1362", stamnummer: "3296", naam: "ES Harre-manhay", taal: "" },
  { id: "47", stamnummer: "3302", naam: "K Racing Waregem", taal: "nl" },
  { id: "1363", stamnummer: "3307", naam: "RFC Wallonia Thisnes", taal: "" },
  { id: "1364", stamnummer: "3324", naam: "KVC De Toek Borsbeke", taal: "" },
  { id: "1365", stamnummer: "3327", naam: "KSV Oud-turnhout", taal: "" },
  { id: "1366", stamnummer: "3348", naam: "RFC Houmartois", taal: "" },
  {
    id: "1367",
    stamnummer: "3349",
    naam: "RAS Pays Blanc Antoinien",
    taal: "",
  },
  { id: "1368", stamnummer: "3388", naam: "R Stade Gedinnois", taal: "" },
  { id: "1369", stamnummer: "3411", naam: "RFC St-hubert", taal: "" },
  {
    id: "109",
    stamnummer: "3434",
    naam: "K Patro Eisden Maasmechelen",
    taal: "nl",
  },
  { id: "419", stamnummer: "3441", naam: "KVV KL. Kemzeke", taal: "" },
  { id: "1371", stamnummer: "3449", naam: "RUS Ferrieres", taal: "" },
  { id: "1372", stamnummer: "3456", naam: "R Battice FC", taal: "" },
  { id: "1373", stamnummer: "3466", naam: "RUS Tellinoise", taal: "" },
  { id: "421", stamnummer: "3470", naam: "Vielsalm", taal: "" },
  { id: "1374", stamnummer: "3481", naam: "Union Lasne Ohain", taal: "" },
  { id: "1375", stamnummer: "3485", naam: "R Marchin Sport", taal: "" },
  { id: "422", stamnummer: "3497", naam: "K Kalmthout SK", taal: "" },
  { id: "1376", stamnummer: "3500", naam: "Sk Rummen", taal: "" },
  { id: "423", stamnummer: "3508", naam: "K Holleken VC Linkebeek", taal: "" },
  { id: "424", stamnummer: "3514", naam: "K Sint-job FC", taal: "" },
  { id: "1377", stamnummer: "3521", naam: "VC K Zwevegem Sport", taal: "" },
  { id: "425", stamnummer: "3526", naam: "Verbr Hofstade", taal: "" },
  { id: "426", stamnummer: "3531", naam: "WS Linkhout", taal: "" },
  { id: "1378", stamnummer: "3539", naam: "Opont", taal: "" },
  { id: "1379", stamnummer: "3540", naam: "RCS Schaltin", taal: "" },
  { id: "427", stamnummer: "3541", naam: "KVK Svelta Melsele", taal: "nl" },
  { id: "428", stamnummer: "3550", naam: "KFC Klimop Begijnendijk", taal: "" },
  { id: "429", stamnummer: "3551", naam: "KFC Merelbeke", taal: "nl" },
  { id: "1380", stamnummer: "3552", naam: "KV Tremelo", taal: "" },
  { id: "1381", stamnummer: "3554", naam: "Exc FC Essen", taal: "" },
  { id: "1382", stamnummer: "3556", naam: "KRC Boortmeerbeek", taal: "" },
  { id: "1383", stamnummer: "3557", naam: "KFC Werchter", taal: "" },
  { id: "1384", stamnummer: "3560", naam: "RUS Rossart", taal: "" },
  { id: "431", stamnummer: "3580", naam: "RFC Miecret", taal: "" },
  { id: "432", stamnummer: "3591", naam: "R Etoile Rosoutoise", taal: "" },
  {
    id: "1386",
    stamnummer: "3592",
    naam: "Societe Royale JSThudinienne",
    taal: "",
  },
  { id: "433", stamnummer: "3616", naam: "RCS Jalhaytois", taal: "" },
  { id: "434", stamnummer: "3617", naam: "K Eendr Stevoort", taal: "" },
  { id: "435", stamnummer: "3622", naam: "K Borsbeek Sport", taal: "" },
  { id: "140", stamnummer: "3623", naam: "KFC Vrasene", taal: "nl" },
  { id: "436", stamnummer: "3627", naam: "AS Ghlinoise", taal: "" },
  { id: "93", stamnummer: "3630", naam: "K Londerzeel SK", taal: "nl" },
  { id: "1387", stamnummer: "3634", naam: "KAC Betekom", taal: "" },
  { id: "437", stamnummer: "3643", naam: "RSC Rendeux", taal: "" },
  { id: "438", stamnummer: "3660", naam: "KFC Baal", taal: "" },
  {
    id: "110",
    stamnummer: "3671",
    naam: "KVV Thes Sport Tessenderlo",
    taal: "nl",
  },
  { id: "439", stamnummer: "3675", naam: "SC Zonnebeke", taal: "" },
  { id: "440", stamnummer: "3676", naam: "KHO Huizingen", taal: "nl" },
  { id: "441", stamnummer: "3693", naam: "Kvv Ws Sombeke", taal: "" },
  { id: "1389", stamnummer: "3694", naam: "K Eendracht Wervik", taal: "" },
  { id: "1390", stamnummer: "3706", naam: "VCE Huise-ouwegem", taal: "" },
  { id: "442", stamnummer: "3710", naam: "RFC Luingnois", taal: "" },
  { id: "443", stamnummer: "3734", naam: "KSK Kasterlee", taal: "" },
  { id: "444", stamnummer: "3737", naam: "SK Rapid Leest", taal: "" },
  { id: "445", stamnummer: "3738", naam: "Heffen Sk", taal: "" },
  { id: "1391", stamnummer: "3746", naam: "FC Zemst Sportief", taal: "nl" },
  { id: "446", stamnummer: "3748", naam: "KFC Hever", taal: "" },
  { id: "447", stamnummer: "3750", naam: "KV Bonheiden", taal: "" },
  { id: "448", stamnummer: "3794", naam: "KFC Malderen", taal: "" },
  { id: "449", stamnummer: "3806", naam: "AS Morlanwelz", taal: "" },
  { id: "1392", stamnummer: "3811", naam: "VNA Wortel", taal: "" },
  { id: "450", stamnummer: "3816", naam: "RRC Mormont", taal: "" },
  { id: "78", stamnummer: "3821", naam: "KFC Sparta Petegem", taal: "nl" },
  { id: "451", stamnummer: "3823", naam: "KNVLH Keerbergen", taal: "" },
  { id: "452", stamnummer: "3835", naam: "RUS Binche", taal: "" },
  {
    id: "1393",
    stamnummer: "3841",
    naam: "Kv Koksijde Oostduinkerke",
    taal: "",
  },
  { id: "453", stamnummer: "3851", naam: "KVE Drongen", taal: "" },
  { id: "454", stamnummer: "3855", naam: "K. Puurs Exc. RSK", taal: "" },
  { id: "455", stamnummer: "3857", naam: "KVV Vlaamse Ardennen", taal: "" },
  { id: "456", stamnummer: "3858", naam: "KOlFC Rupelmonde", taal: "" },
  { id: "457", stamnummer: "3859", naam: "KEVC Beselare", taal: "" },
  { id: "458", stamnummer: "3861", naam: "Eendr Elene-grotenberge", taal: "" },
  {
    id: "459",
    stamnummer: "3863",
    naam: "Rapide Santos Club Ophasselt S",
    taal: "",
  },
  { id: "460", stamnummer: "3865", naam: "K Gooreind VV", taal: "" },
  { id: "1394", stamnummer: "3874", naam: "Putte SK", taal: "" },
  { id: "461", stamnummer: "3878", naam: "FCSKV Overmere", taal: "" },
  { id: "462", stamnummer: "3879", naam: "Jong Sint-truiden Vv", taal: "" },
  { id: "463", stamnummer: "3880", naam: "KVC Kessel Lo 2000", taal: "" },
  { id: "48", stamnummer: "3887", naam: "K Diegem Sport", taal: "nl" },
  { id: "464", stamnummer: "3888", naam: "K Peerder Sportvrienden", taal: "" },
  { id: "11000", stamnummer: "3889", naam: "HO Bierbeek", taal: "" },
  { id: "10984", stamnummer: "3892", naam: "Stormvogels Haasrode", taal: "" },
  { id: "465", stamnummer: "3895", naam: "Sparta Wortegem", taal: "" },
  { id: "15", stamnummer: "3900", naam: "FCV Dender EH", taal: "nl" },
  { id: "466", stamnummer: "3901", naam: "KFC Olympic Burst", taal: "" },
  { id: "111", stamnummer: "3904", naam: "K Esk Leopoldsburg", taal: "nl" },
  { id: "467", stamnummer: "3905", naam: "R Entente Rechaintoise", taal: "" },
  { id: "1396", stamnummer: "3908", naam: "KFC Rapide Wezemaal", taal: "" },
  {
    id: "10994",
    stamnummer: "3911",
    naam: "KFC Volh Wintam Eikevliet",
    taal: "",
  },
  { id: "468", stamnummer: "3916", naam: "FC Alken", taal: "" },
  { id: "469", stamnummer: "3926", naam: "KFC Verbr Alberta Geel", taal: "" },
  { id: "79", stamnummer: "3939", naam: "JS Taminoise", taal: "fr" },
  { id: "470", stamnummer: "3942", naam: "FC Veldegem", taal: "" },
  { id: "471", stamnummer: "3943", naam: "KSV.Alsemberg", taal: "" },
  { id: "472", stamnummer: "3952", naam: "KSC Oostrozebeke", taal: "" },
  { id: "1397", stamnummer: "3953", naam: "Union Entite Estinnoise", taal: "" },
  { id: "473", stamnummer: "3957", naam: "KVC Jong Lede", taal: "nl" },
  { id: "474", stamnummer: "3958", naam: "KSK Beveren-leie", taal: "" },
  { id: "475", stamnummer: "3959", naam: "FC St-jozef Londerzeel", taal: "" },
  { id: "476", stamnummer: "3962", naam: "KSV Jabbeke", taal: "" },
  { id: "477", stamnummer: "3964", naam: "Fc Voorde-appelterre", taal: "" },
  { id: "1398", stamnummer: "3968", naam: "K Zonnekl Dentergem", taal: "" },
  { id: "135", stamnummer: "3970", naam: "Lierse Kempenzonen", taal: "nl" },
  { id: "1399", stamnummer: "3972", naam: "Hulste Sportief", taal: "" },
  { id: "478", stamnummer: "3976", naam: "KDC Ruddervoorde", taal: "nl" },
  { id: "479", stamnummer: "3978", naam: "ES Mominoise", taal: "" },
  { id: "1400", stamnummer: "4006", naam: "RFC Sart-bernard", taal: "" },
  { id: "1401", stamnummer: "4010", naam: "SK Erembodegem", taal: "" },
  { id: "94", stamnummer: "4013", naam: "SK.Opwijk", taal: "nl" },
  {
    id: "480",
    stamnummer: "4022",
    naam: "Kvv Schelde Serskamp-schelleb",
    taal: "",
  },
  { id: "481", stamnummer: "4048", naam: "Vc Vamos Zandvoorde", taal: "" },
  { id: "482", stamnummer: "4057", naam: "FC Mere", taal: "" },
  {
    id: "35",
    stamnummer: "4068",
    naam: "KV RS Waasland-sk Beveren",
    taal: "nl",
  },
  { id: "483", stamnummer: "4070", naam: "Crossing Schaerbeek", taal: "" },
  { id: "484", stamnummer: "4108", naam: "KSV Maarkedal", taal: "" },
  { id: "485", stamnummer: "4112", naam: "Loenhout SK", taal: "" },
  { id: "1402", stamnummer: "4129", naam: "Ksc De Schr Moorsel", taal: "" },
  {
    id: "1403",
    stamnummer: "4133",
    naam: "Football Club Schaerbeek",
    taal: "",
  },
  { id: "1404", stamnummer: "4138", naam: "KFCMZ Tollembeek", taal: "" },
  { id: "486", stamnummer: "4139", naam: "KFC Hoger Op Kalken", taal: "" },
  { id: "488", stamnummer: "4143", naam: "RAS Monceau", taal: "" },
  { id: "489", stamnummer: "4148", naam: "K Blauwvoet Otegem", taal: "" },
  { id: "490", stamnummer: "4153", naam: "KSK Steenbrugge", taal: "nl" },
  { id: "491", stamnummer: "4157", naam: "KFC Lennik", taal: "" },
  { id: "492", stamnummer: "4162", naam: "KVK Robur Moerzeke", taal: "" },
  { id: "493", stamnummer: "4165", naam: "KVV Zelzate", taal: "nl" },
  { id: "1405", stamnummer: "4168", naam: "K Dosko St-kruis", taal: "" },
  { id: "494", stamnummer: "4170", naam: "RUS Binchoise", taal: "" },
  { id: "1406", stamnummer: "4174", naam: "KFC Heikant Zele", taal: "" },
  { id: "495", stamnummer: "4184", naam: "Dend.Pamel", taal: "" },
  { id: "1407", stamnummer: "4186", naam: "KFC Aarsele", taal: "" },
  { id: "1408", stamnummer: "4190", naam: "KFC Ezaart Sport Mol", taal: "nl" },
  { id: "496", stamnummer: "4194", naam: "Renaissance Mons 44", taal: "" },
  { id: "497", stamnummer: "4196", naam: "Racing Club Lauwe", taal: "" },
  { id: "498", stamnummer: "4201", naam: "Fcw Gijzegem", taal: "nl" },
  { id: "1409", stamnummer: "4209", naam: "RUS De Grand Reng", taal: "" },
  { id: "1410", stamnummer: "4210", naam: "R Arquet FC", taal: "" },
  { id: "1411", stamnummer: "4211", naam: "KSK Klinge", taal: "" },
  { id: "1412", stamnummer: "4213", naam: "KSK Kieldrecht", taal: "" },
  { id: "1413", stamnummer: "4214", naam: "K Rumstse SK", taal: "" },
  { id: "1414", stamnummer: "4215", naam: "KVK Hingene", taal: "" },
  { id: "499", stamnummer: "4218", naam: "KSK Kallo", taal: "" },
  { id: "500", stamnummer: "4219", naam: "R Fraiture FC", taal: "" },
  { id: "10010", stamnummer: "4220", naam: "KSK Maldegem", taal: "nl" },
  { id: "1415", stamnummer: "4221", naam: "RRC Havelange", taal: "" },
  { id: "501", stamnummer: "4234", naam: "KV Eendracht Winnik", taal: "" },
  { id: "502", stamnummer: "4244", naam: "K Sporting FC Haren", taal: "" },
  { id: "503", stamnummer: "4246", naam: "Hoger-op Veltem", taal: "" },
  { id: "504", stamnummer: "4250", naam: "KRC Bissegem", taal: "" },
  { id: "1416", stamnummer: "4252", naam: "KSK Weelde", taal: "" },
  { id: "505", stamnummer: "4253", naam: "KSV Kortrijk", taal: "" },
  { id: "506", stamnummer: "4256", naam: "RES Roux", taal: "" },
  { id: "507", stamnummer: "4257", naam: "KVC Ardooie", taal: "" },
  { id: "508", stamnummer: "4258", naam: "RFC Spy", taal: "" },
  { id: "1417", stamnummer: "4260", naam: "Marloie Sport", taal: "fr" },
  { id: "509", stamnummer: "4262", naam: "KV Sint-gillis", taal: "" },
  { id: "510", stamnummer: "4263", naam: "Olympic  Ledegem", taal: "" },
  { id: "511", stamnummer: "4264", naam: "KFC Verbr Lommel", taal: "" },
  {
    id: "1418",
    stamnummer: "4265",
    naam: "FC Eendr Kapelle O/d Bos",
    taal: "",
  },
  { id: "1419", stamnummer: "4266", naam: "FC Entente Pepine", taal: "" },
  { id: "128", stamnummer: "4267", naam: "Bertrix", taal: "fr" },
  {
    id: "512",
    stamnummer: "4272",
    naam: "KFC Eendr Belzele Evergem",
    taal: "",
  },
  {
    id: "1420",
    stamnummer: "4273",
    naam: "Un R St-louis-saint-leger",
    taal: "",
  },
  { id: "513", stamnummer: "4275", naam: "Gemmenich", taal: "" },
  { id: "36", stamnummer: "4276", naam: "KAS Eupen", taal: "fr" },
  { id: "514", stamnummer: "4278", naam: "Wall Ass Sauveniere", taal: "" },
  { id: "515", stamnummer: "4281", naam: "VC Nazareth-eke", taal: "" },
  {
    id: "11758",
    stamnummer: "4286",
    naam: "Ass Clubs Hemptinne-eghezee",
    taal: "fr",
  },
  { id: "516", stamnummer: "4294", naam: "Willen Is Kunnen Eine", taal: "nl" },
  { id: "95", stamnummer: "4297", naam: "Sc Lokeren-temse", taal: "nl" },
  { id: "1421", stamnummer: "4298", naam: "US Halthier", taal: "" },
  { id: "1423", stamnummer: "4308", naam: "EH Braives", taal: "" },
  { id: "517", stamnummer: "4309", naam: "RFC Wallonia Waimes", taal: "" },
  { id: "1424", stamnummer: "4312", naam: "RFC Heusy Rouheid", taal: "" },
  { id: "518", stamnummer: "4317", naam: "My", taal: "" },
  { id: "519", stamnummer: "4320", naam: "KFC Lichtervelde", taal: "" },
  { id: "520", stamnummer: "4328", naam: "VV Cercle Beernem", taal: "" },
  { id: "1425", stamnummer: "4331", naam: "KVV Dosko Baarle-hertog", taal: "" },
  { id: "1426", stamnummer: "4334", naam: "KV Dosko Beveren", taal: "nl" },
  { id: "521", stamnummer: "4336", naam: "Red Boys Elzestraat", taal: "" },
  { id: "522", stamnummer: "4337", naam: "RFC Xhoffraix", taal: "" },
  { id: "523", stamnummer: "4343", naam: "KV Patronaat Gits", taal: "" },
  { id: "1428", stamnummer: "4360", naam: "R Esp Rossignol", taal: "" },
  { id: "11215", stamnummer: "4375", naam: "K. Kessel F.c.", taal: "" },
  { id: "525", stamnummer: "4383", naam: "Ksk Ekeren Donk", taal: "" },
  { id: "139", stamnummer: "4385", naam: "KFC Sp St-gillis Waas", taal: "nl" },
  { id: "526", stamnummer: "4392", naam: "KFC Exc Balgerhoeke", taal: "" },
  { id: "80", stamnummer: "4395", naam: "RUS Beloeil", taal: "fr" },
  { id: "527", stamnummer: "4396", naam: "SK Staden", taal: "" },
  { id: "1429", stamnummer: "4397", naam: "Auvelais A", taal: "" },
  { id: "528", stamnummer: "4399", naam: "Exc Donk", taal: "" },
  { id: "1430", stamnummer: "4400", naam: "KSV Pittem", taal: "" },
  {
    id: "81",
    stamnummer: "4408",
    naam: "K Sint-eloois-winkel Sport",
    taal: "nl",
  },
  { id: "1431", stamnummer: "4414", naam: "KFC St-joris Sportief", taal: "" },
  { id: "529", stamnummer: "4423", naam: "K Reet SK", taal: "" },
  { id: "530", stamnummer: "4430", naam: "VV Laakdal", taal: "" },
  { id: "532", stamnummer: "4446", naam: "KFC Berendrecht Sp", taal: "" },
  { id: "533", stamnummer: "4453", naam: "KFC Katelijne-waver", taal: "" },
  { id: "534", stamnummer: "4454", naam: "RFC Meux", taal: "" },
  { id: "535", stamnummer: "4460", naam: "KSV Bredene", taal: "" },
  { id: "536", stamnummer: "4461", naam: "Bracquegnies Sp", taal: "" },
  { id: "1432", stamnummer: "4465", naam: "KFC Heist", taal: "" },
  { id: "1433", stamnummer: "4466", naam: "K Massenhoven VC", taal: "" },
  { id: "537", stamnummer: "4467", naam: "KV.St.Gillis", taal: "" },
  {
    id: "538",
    stamnummer: "4469",
    naam: "Kfc De Kempen Tielen-lichtaart",
    taal: "",
  },
  { id: "539", stamnummer: "4471", naam: "KFC Broechem", taal: "" },
  { id: "1434", stamnummer: "4481", naam: "KVC Houtvenne", taal: "" },
  { id: "1436", stamnummer: "4498", naam: "R Sporting Club Lontzen", taal: "" },
  { id: "540", stamnummer: "4504", naam: "RUS Biesme", taal: "" },
  { id: "1437", stamnummer: "4505", naam: "KVC Eendr Nieuwerkerken", taal: "" },
  { id: "1438", stamnummer: "4513", naam: "RAS Risquons-tout", taal: "" },
  { id: "1439", stamnummer: "4514", naam: "KFCE Zelem", taal: "" },
  { id: "1440", stamnummer: "4515", naam: "SK Vliermaalroot", taal: "" },
  { id: "541", stamnummer: "4517", naam: "Fc Maasland Noord Oost", taal: "" },
  { id: "542", stamnummer: "4529", naam: "K Bokrijk Sport", taal: "" },
  { id: "11216", stamnummer: "4534", naam: "R.a.s. Honnelles", taal: "" },
  {
    id: "11208",
    stamnummer: "1824",
    naam: "K.s.k. 's Gravenwezel-schilde",
    taal: "",
  },
  { id: "544", stamnummer: "4548", naam: "KMR Biesen", taal: "" },
  { id: "129", stamnummer: "4549", naam: "Wavre Sports Fc", taal: "fr" },
  { id: "545", stamnummer: "4600", naam: "FC Heur-tongeren", taal: "" },
  { id: "1442", stamnummer: "4609", naam: "K De Noordstar Heule", taal: "" },
  { id: "547", stamnummer: "4655", naam: "KFAC Waarschoot", taal: "" },
  { id: "548", stamnummer: "4704", naam: "KFC Ranst", taal: "" },
  { id: "1443", stamnummer: "4713", naam: "US Du Viroin-treignes", taal: "" },
  { id: "1444", stamnummer: "4718", naam: "RFC Lissewege", taal: "" },
  { id: "549", stamnummer: "4721", naam: "K Hove Sport", taal: "" },
  {
    id: "550",
    stamnummer: "4722",
    naam: "K Zw Fc Wiemismeer Zutendaal",
    taal: "",
  },
  { id: "551", stamnummer: "4732", naam: "KSK De Jeugd Lovendegem", taal: "" },
  { id: "552", stamnummer: "4740", naam: "Evergem 2020", taal: "" },
  { id: "553", stamnummer: "4744", naam: "FC Assenede", taal: "" },
  { id: "1445", stamnummer: "4752", naam: "R Baelen FC", taal: "" },
  { id: "554", stamnummer: "4753", naam: "FC Vurste-Semmerzake", taal: "" },
  { id: "555", stamnummer: "4754", naam: "RRFC Gozeen", taal: "" },
  { id: "556", stamnummer: "4759", naam: "KFC Eppegem", taal: "" },
  { id: "557", stamnummer: "4763", naam: "KV Eendracht Aalter", taal: "" },
  { id: "558", stamnummer: "4776", naam: "RFC Farciennes", taal: "" },
  { id: "559", stamnummer: "4789", naam: "RCS Sugny", taal: "" },
  { id: "1446", stamnummer: "4801", naam: "Exc. Kaart", taal: "" },
  { id: "1447", stamnummer: "4816", naam: "VC Zwijnaarde", taal: "" },
  { id: "560", stamnummer: "4827", naam: "KFC Lendelede Sport", taal: "" },
  { id: "1448", stamnummer: "4839", naam: "KV.Boutersem", taal: "" },
  { id: "1449", stamnummer: "4861", naam: "Fc Damme", taal: "" },
  { id: "1450", stamnummer: "4864", naam: "Horendonk FC", taal: "" },
  { id: "1451", stamnummer: "4871", naam: "KVV Balegem", taal: "" },
  { id: "563", stamnummer: "4878", naam: "RFC De Gilly", taal: "" },
  { id: "1452", stamnummer: "4889", naam: "Azalea", taal: "" },
  { id: "1453", stamnummer: "4892", naam: "KSV Schriek", taal: "" },
  { id: "1454", stamnummer: "4911", naam: "RFC Temploux-suarlee", taal: "" },
  { id: "1455", stamnummer: "4924", naam: "RUS 1947 Emmels", taal: "" },
  { id: "1456", stamnummer: "4926", naam: "K Schelle Sport", taal: "" },
  { id: "564", stamnummer: "4942", naam: "FC Vliermaal", taal: "" },
  { id: "566", stamnummer: "4948", naam: "KWS Desselgem", taal: "" },
  { id: "567", stamnummer: "4949", naam: "Kvv Laarne-kalken", taal: "" },
  { id: "568", stamnummer: "4958", naam: "Flandria Dorne", taal: "" },
  { id: "569", stamnummer: "4980", naam: "KSV De Ruiter Roeselare", taal: "" },
  { id: "572", stamnummer: "5004", naam: "FC Diepenbeek", taal: "" },
  { id: "10708", stamnummer: "5009", naam: "KFC.Strombeek", taal: "" },
  { id: "573", stamnummer: "5015", naam: "VCOG Stasegem", taal: "" },
  { id: "574", stamnummer: "5016", naam: "Union Entite Chapelloise", taal: "" },
  {
    id: "575",
    stamnummer: "5040",
    naam: "Lubbeek St-martinus Sport",
    taal: "",
  },
  { id: "1458", stamnummer: "5044", naam: "Standaard Meerbeek", taal: "" },
  { id: "576", stamnummer: "5049", naam: "FC Herleving St-pauwels", taal: "" },
  { id: "577", stamnummer: "5119", naam: "Kfc Doomkerke", taal: "" },
  { id: "1459", stamnummer: "5120", naam: "KFC Sparta Kolmont", taal: "" },
  { id: "1460", stamnummer: "5128", naam: "RFC La Buissiere", taal: "" },
  { id: "1461", stamnummer: "5142", naam: "KSV Wildert", taal: "" },
  { id: "578", stamnummer: "5154", naam: "KSC Exc Mariakerke", taal: "" },
  { id: "579", stamnummer: "5155", naam: "K Herk-de-stad FC", taal: "" },
  {
    id: "1462",
    stamnummer: "5156",
    naam: "Union Sportive Dinantaise",
    taal: "",
  },
  { id: "580", stamnummer: "5157", naam: "Entente Sommenoise", taal: "" },
  { id: "1463", stamnummer: "5159", naam: "Eendr.Peizegem", taal: "" },
  { id: "581", stamnummer: "5160", naam: "RUS Loyers", taal: "" },
  { id: "582", stamnummer: "5166", naam: "KFC Weywertz", taal: "" },
  { id: "1464", stamnummer: "5173", naam: "KFC Pulle", taal: "" },
  { id: "583", stamnummer: "5176", naam: "K Achterbroek VV", taal: "" },
  { id: "584", stamnummer: "5180", naam: "K Racing Emblem", taal: "" },
  { id: "1465", stamnummer: "5181", naam: "KSV Rumbeke", taal: "" },
  { id: "1466", stamnummer: "5185", naam: "RES Philippeville", taal: "" },
  { id: "585", stamnummer: "5187", naam: "SC Lombardsijde", taal: "" },
  { id: "1467", stamnummer: "5191", naam: "RAC Neuvillers", taal: "" },
  { id: "82", stamnummer: "5192", naam: "Francs Borains", taal: "fr" },
  { id: "587", stamnummer: "5216", naam: "KVC Wingene", taal: "" },
  { id: "588", stamnummer: "5222", naam: "KFC Varsenare", taal: "" },
  { id: "589", stamnummer: "5226", naam: "AL Lisogne-thynes", taal: "" },
  { id: "1468", stamnummer: "5230", naam: "US Beauraing 61", taal: "" },
  { id: "1469", stamnummer: "5312", naam: "Ottignies Lln Sports", taal: "" },
  { id: "590", stamnummer: "5322", naam: "RAS Houyet", taal: "" },
  { id: "591", stamnummer: "5333", naam: "FC Les Cerfs Grandvoir", taal: "" },
  { id: "10991", stamnummer: "5334", naam: "FC Galmaarden", taal: "" },
  { id: "592", stamnummer: "5337", naam: "Tielt-winge 3000", taal: "" },
  { id: "593", stamnummer: "5343", naam: "K Racing Club Bambrugge", taal: "" },
  { id: "594", stamnummer: "5350", naam: "RJS Leignon", taal: "" },
  { id: "1470", stamnummer: "5357", naam: "Excelsior Mariaburg", taal: "nl" },
  { id: "595", stamnummer: "5358", naam: "FC Destelbergen", taal: "" },
  { id: "596", stamnummer: "5360", naam: "K SK Sefa Herentals", taal: "" },
  {
    id: "1472",
    stamnummer: "5361",
    naam: "VV Groene Leeuwen Ruiselede",
    taal: "",
  },
  { id: "1473", stamnummer: "5363", naam: "RJS St-m Wideumont", taal: "" },
  { id: "1474", stamnummer: "5366", naam: "RFC De Goe", taal: "" },
  { id: "96", stamnummer: "5368", naam: "KSK.L.Ternat", taal: "nl" },
  { id: "597", stamnummer: "5372", naam: "FC Halvenweg Zonhoven", taal: "" },
  { id: "1475", stamnummer: "5377", naam: "Hoger-op Testelt", taal: "" },
  { id: "1476", stamnummer: "5379", naam: "R Cornesse FC", taal: "" },
  { id: "9", stamnummer: "5381", naam: "SV Zulte-waregem", taal: "nl" },
  {
    id: "112",
    stamnummer: "5384",
    naam: "Eendracht Mechelen A/d Maas",
    taal: "nl",
  },
  { id: "598", stamnummer: "5386", naam: "KSK Wavria", taal: "" },
  { id: "1477", stamnummer: "5389", naam: "US St-hadelin-haversin", taal: "" },
  {
    id: "599",
    stamnummer: "5394",
    naam: "K Immer-voort FC Voortkapel",
    taal: "",
  },
  { id: "1478", stamnummer: "5403", naam: "Fc Tintifontaine", taal: "" },
  { id: "1479", stamnummer: "5465", naam: "FC Vencimontois", taal: "" },
  {
    id: "600",
    stamnummer: "5470",
    naam: "Bs Sport Berbroek-schulen",
    taal: "",
  },
  { id: "601", stamnummer: "5471", naam: "KVV Aartrijke", taal: "" },
  { id: "1480", stamnummer: "5475", naam: "US Merbesars", taal: "" },
  {
    id: "49",
    stamnummer: "5479",
    naam: "Racing White Daring Molenbeek",
    taal: "nl",
  },
  { id: "1481", stamnummer: "5480", naam: "JS Vivegnis", taal: "" },
  { id: "602", stamnummer: "5483", naam: "SC Mechelen", taal: "" },
  { id: "11217", stamnummer: "5486", naam: "R.f.c. Lobbes", taal: "" },
  { id: "604", stamnummer: "5488", naam: "FC St-joris Sleidinge", taal: "" },
  { id: "1482", stamnummer: "5499", naam: "RFC Butgenbach", taal: "" },
  { id: "1483", stamnummer: "5517", naam: "KVS Branst", taal: "" },
  { id: "605", stamnummer: "5544", naam: "K Sassport Boezinge", taal: "" },
  { id: "83", stamnummer: "5553", naam: "K Olsa Brakel", taal: "nl" },
  { id: "606", stamnummer: "5559", naam: "Vc Bekkevoort", taal: "" },
  { id: "608", stamnummer: "5561", naam: "Juve Hasselt", taal: "" },
  { id: "609", stamnummer: "5571", naam: "RES Frasnoise", taal: "" },
  { id: "1484", stamnummer: "5575", naam: "FC.Jauchois", taal: "" },
  { id: "11001", stamnummer: "5576", naam: "FC Perk", taal: "" },
  { id: "610", stamnummer: "5578", naam: "FC Clermont", taal: "" },
  { id: "612", stamnummer: "5585", naam: "Union Namechoise FC", taal: "" },
  { id: "613", stamnummer: "5588", naam: "Asse-zellik 2002", taal: "nl" },
  { id: "614", stamnummer: "5590", naam: "RES Witry-menufontaine", taal: "" },
  { id: "1485", stamnummer: "5591", naam: "RFC Molenbaix", taal: "" },
  { id: "615", stamnummer: "5600", naam: "RFC Jehaytois", taal: "" },
  { id: "1486", stamnummer: "5614", naam: "UnStAndre Ochamps", taal: "" },
  { id: "1487", stamnummer: "5617", naam: "SK Lochristi", taal: "" },
  { id: "616", stamnummer: "5624", naam: "SC Beauvechain", taal: "" },
  { id: "1488", stamnummer: "5627", naam: "K Nieuwmoer FC", taal: "" },
  { id: "1489", stamnummer: "5628", naam: "K Heibos SV", taal: "" },
  { id: "16", stamnummer: "5632", naam: "AFC Tubize", taal: "fr" },
  { id: "617", stamnummer: "5635", naam: "Union Lovenjoel", taal: "" },
  { id: "618", stamnummer: "5636", naam: "KVC Itna Itterbeek", taal: "" },
  { id: "1490", stamnummer: "5639", naam: "FC Vaux-borset", taal: "" },
  { id: "619", stamnummer: "5641", naam: "KVV Zomergem", taal: "" },
  { id: "620", stamnummer: "5643", naam: "RS Fernelmont-hemptinne", taal: "" },
  { id: "11218", stamnummer: "5645", naam: "K.f.c. Langemark", taal: "" },
  { id: "1491", stamnummer: "5649", naam: "K Sp Tange", taal: "" },
  { id: "624", stamnummer: "5652", naam: "Union Roclenge-wonck", taal: "" },
  { id: "625", stamnummer: "5655", naam: "RUS Pondrome", taal: "" },
  { id: "626", stamnummer: "5656", naam: "K Arsenaal Goetsenhoven", taal: "" },
  { id: "10999", stamnummer: "5659", naam: "FC Melsbroek", taal: "" },
  { id: "628", stamnummer: "5660", naam: "VC Bertem-leefdaal", taal: "" },
  { id: "10697", stamnummer: "5661", naam: "Kfc Wambeek Ternat", taal: "" },
  { id: "1492", stamnummer: "5669", naam: "CS D'Ocquier", taal: "" },
  { id: "1493", stamnummer: "5674", naam: "Winaloise", taal: "" },
  {
    id: "1494",
    stamnummer: "5698",
    naam: "Entente Sportive Ardennaise",
    taal: "",
  },
  { id: "1495", stamnummer: "5699", naam: "USFC Elsenborn", taal: "" },
  { id: "1496", stamnummer: "5704", naam: "RFC Ronquieres-hy 86", taal: "" },
  { id: "1497", stamnummer: "5710", naam: "RCS Nivellois", taal: "" },
  { id: "1498", stamnummer: "5713", naam: "K Uikhoven VC", taal: "" },
  { id: "1499", stamnummer: "5715", naam: "K Godsheide VV", taal: "" },
  { id: "629", stamnummer: "5716", naam: "FC Meensel Kiezegem", taal: "" },
  { id: "630", stamnummer: "5718", naam: "RUS Assesse", taal: "" },
  {
    id: "10975",
    stamnummer: "5719",
    naam: "Fcs Mariekerke-branst",
    taal: "nl",
  },
  { id: "1500", stamnummer: "5723", naam: "US Neufvilloise", taal: "" },
  { id: "631", stamnummer: "5725", naam: "K HO Heide Hasselt", taal: "" },
  {
    id: "1501",
    stamnummer: "5748",
    naam: "Union Sportive St-medard",
    taal: "",
  },
  {
    id: "50",
    stamnummer: "5750",
    naam: "Royal White Star Bruxelles",
    taal: "fr",
  },
  { id: "1502", stamnummer: "5751", naam: "Focant", taal: "" },
  { id: "632", stamnummer: "5757", naam: "Zandvliet Sport", taal: "" },
  { id: "1503", stamnummer: "5759", naam: "RFC Chievres 69", taal: "" },
  { id: "633", stamnummer: "5767", naam: "KVC Langdorp", taal: "" },
  { id: "634", stamnummer: "5769", naam: "R Couthuin Sports", taal: "" },
  { id: "1504", stamnummer: "5770", naam: "EC Oudenhove", taal: "" },
  { id: "635", stamnummer: "5772", naam: "AS Obigies", taal: "" },
  { id: "636", stamnummer: "5774", naam: "Union St Gerard", taal: "" },
  { id: "113", stamnummer: "5775", naam: "Spouwen - Mopertingen", taal: "nl" },
  { id: "637", stamnummer: "5776", naam: "K Vlijtingen VV", taal: "" },
  { id: "638", stamnummer: "5777", naam: "Riemst Vooruit", taal: "" },
  { id: "1505", stamnummer: "5779", naam: "RFC Warnant", taal: "" },
  { id: "1506", stamnummer: "5806", naam: "KVZ Glabbeek-zuurbemde", taal: "" },
  { id: "1507", stamnummer: "5815", naam: "K St-dymphna FC Zammel", taal: "" },
  { id: "641", stamnummer: "5825", naam: "FC.Rillaar Sp.", taal: "" },
  { id: "1508", stamnummer: "5827", naam: "US Martelangeoise", taal: "" },
  { id: "642", stamnummer: "5830", naam: "KVC Ichtegem", taal: "" },
  { id: "1509", stamnummer: "5831", naam: "VK Adegem", taal: "" },
  { id: "643", stamnummer: "5835", naam: "Trazegnies Sports", taal: "" },
  { id: "644", stamnummer: "5840", naam: "Sport Nevok Gruitrode", taal: "" },
  { id: "645", stamnummer: "5842", naam: "FC St-martens-latem", taal: "nl" },
  { id: "97", stamnummer: "5861", naam: "Eendracht Buggenhout", taal: "nl" },
  { id: "1511", stamnummer: "5865", naam: "Sivry Sports", taal: "" },
  { id: "647", stamnummer: "5893", naam: "Zeehaven Zeebrugge", taal: "" },
  { id: "114", stamnummer: "5894", naam: "KVV Heusden - Zolder", taal: "nl" },
  { id: "1512", stamnummer: "5895", naam: "St. Rosmeer", taal: "" },
  { id: "648", stamnummer: "5898", naam: "SK Munsterbilzen", taal: "" },
  { id: "1513", stamnummer: "5905", naam: "Herk Sport Hasselt", taal: "" },
  { id: "1514", stamnummer: "5906", naam: "VK Heindonk", taal: "" },
  { id: "1515", stamnummer: "5908", naam: "RFC Compogne Bertogne", taal: "" },
  { id: "651", stamnummer: "5915", naam: "Toekomst Bunsbeek", taal: "" },
  { id: "652", stamnummer: "5917", naam: "FC Ligny", taal: "" },
  {
    id: "654",
    stamnummer: "5921",
    naam: "K Voetbalvereniging Kester-gooik",
    taal: "",
  },
  { id: "655", stamnummer: "5924", naam: "KSAV St-dymphna Geel", taal: "" },
  { id: "656", stamnummer: "5925", naam: "KFC Beekhoek Sport", taal: "" },
  { id: "1328", stamnummer: "2673", naam: "BSK Retie", taal: "nl" },
  { id: "1516", stamnummer: "5930", naam: "RFC Somzee", taal: "" },
  { id: "1517", stamnummer: "5931", naam: "Royal Fraiture Sports", taal: "" },
  { id: "1518", stamnummer: "5934", naam: "FC Herne", taal: "" },
  { id: "1805", stamnummer: "5935", naam: "SVD Kortemark", taal: "" },
  { id: "1519", stamnummer: "5937", naam: "FC Chevron", taal: "" },
  { id: "658", stamnummer: "5938", naam: "RFC Vyle-tharoul", taal: "" },
  { id: "1520", stamnummer: "5952", naam: "Genker VV", taal: "" },
  { id: "659", stamnummer: "5956", naam: "KVCSV Oostkamp", taal: "" },
  { id: "1521", stamnummer: "6001", naam: "Royal Baileux Sport", taal: "" },
  { id: "662", stamnummer: "6004", naam: "FC Espoir Tarciennois", taal: "" },
  { id: "663", stamnummer: "6014", naam: "K Voorwaarts Hakendover", taal: "" },
  { id: "1522", stamnummer: "6016", naam: "CS Odeigne", taal: "" },
  { id: "664", stamnummer: "6017", naam: "R ES Izier", taal: "" },
  { id: "1523", stamnummer: "6023", naam: "KSC Keerbergen", taal: "" },
  { id: "665", stamnummer: "6025", naam: "JV De Pinte", taal: "" },
  { id: "666", stamnummer: "6027", naam: "AC Lustin", taal: "" },
  { id: "667", stamnummer: "6028", naam: "OZ Bavegem", taal: "" },
  { id: "10014", stamnummer: "6031", naam: "Vc Leeuwk Teralfene", taal: "nl" },
  { id: "669", stamnummer: "6034", naam: "AS Hermalienne", taal: "" },
  {
    id: "670",
    stamnummer: "6039",
    naam: "KSK Voorwaarts Zwevezele",
    taal: "nl",
  },
  { id: "671", stamnummer: "6040", naam: "RAFC Cobreville", taal: "" },
  { id: "1524", stamnummer: "6042", naam: "KFC Olympic Essen", taal: "" },
  { id: "672", stamnummer: "6045", naam: "KFC Helson Helchteren", taal: "" },
  { id: "11139", stamnummer: "6047", naam: "K St Elen", taal: "nl" },
  { id: "1525", stamnummer: "6048", naam: "VC Kesselt", taal: "" },
  { id: "674", stamnummer: "6049", naam: "Haltinne", taal: "" },
  { id: "1526", stamnummer: "6050", naam: "RFC Amonines", taal: "" },
  { id: "1527", stamnummer: "6052", naam: "RFC Surice", taal: "" },
  { id: "1528", stamnummer: "6053", naam: "SK Nossegem", taal: "" },
  { id: "10989", stamnummer: "6109", naam: "SK Steenhuffel", taal: "" },
  { id: "1529", stamnummer: "6111", naam: "K Daring Huvo Jeuk", taal: "" },
  { id: "1530", stamnummer: "6113", naam: "Racing Club Melin", taal: "" },
  { id: "675", stamnummer: "6114", naam: "WS Bellegem", taal: "" },
  { id: "676", stamnummer: "6119", naam: "KFC Moen", taal: "" },
  {
    id: "1531",
    stamnummer: "6120",
    naam: "RE Roy-lignieres-grimbiemont",
    taal: "",
  },
  { id: "1532", stamnummer: "6122", naam: "SV Anzegem", taal: "nl" },
  { id: "1533", stamnummer: "6123", naam: "RFC Grand-leez", taal: "" },
  { id: "1534", stamnummer: "6125", naam: "Ass Sp Nothomb-post", taal: "" },
  { id: "677", stamnummer: "6127", naam: "Merkem Sport", taal: "" },
  { id: "678", stamnummer: "6130", naam: "Fc Pontisse Herstal", taal: "" },
  { id: "680", stamnummer: "6136", naam: "Stormvogels Loppem", taal: "" },
  { id: "681", stamnummer: "6137", naam: "R ES Gesvoise", taal: "" },
  { id: "682", stamnummer: "6138", naam: "FC Paliseulois", taal: "" },
  { id: "37", stamnummer: "6142", naam: "Oud-heverlee Leuven", taal: "nl" },
  {
    id: "683",
    stamnummer: "6144",
    naam: "Sparta Moerbeke-geraardsbergen",
    taal: "",
  },
  { id: "684", stamnummer: "6156", naam: "E Jonkershove", taal: "" },
  { id: "685", stamnummer: "6158", naam: "RAS Saintoise", taal: "" },
  { id: "1535", stamnummer: "6159", naam: "SK Merelbeke", taal: "" },
  {
    id: "687",
    stamnummer: "6210",
    naam: "E Mechelen-bovelingen-opheers",
    taal: "",
  },
  {
    id: "689",
    stamnummer: "6219",
    naam: "Flandria Termolen Zonhoven",
    taal: "",
  },
  { id: "690", stamnummer: "6220", naam: "FC Bande", taal: "" },
  { id: "691", stamnummer: "6224", naam: "Manhay", taal: "" },
  { id: "692", stamnummer: "6225", naam: "R Espoir Minerois", taal: "" },
  { id: "1536", stamnummer: "6232", naam: "RCS Faulx-les-tombes", taal: "" },
  { id: "146", stamnummer: "6237", naam: "RUS Givry", taal: "fr" },
  { id: "1537", stamnummer: "6238", naam: "Union FC Rutten", taal: "" },
  { id: "694", stamnummer: "6240", naam: "KSK Meeuwen", taal: "" },
  { id: "1538", stamnummer: "6247", naam: "FC Petit-han", taal: "" },
  { id: "696", stamnummer: "6252", naam: "Fortuna 56 Smeermaas", taal: "" },
  { id: "1539", stamnummer: "6254", naam: "FC Tildonk", taal: "" },
  { id: "1540", stamnummer: "6258", naam: "KFC Herleving Sinaai", taal: "" },
  { id: "10694", stamnummer: "6259", naam: "EMI Essene", taal: "" },
  {
    id: "1541",
    stamnummer: "6261",
    naam: "Voetbalclub Sparta Bevere",
    taal: "",
  },
  { id: "697", stamnummer: "6263", naam: "VV Eendracht Hansbeke", taal: "" },
  { id: "1542", stamnummer: "6266", naam: "Eendr Henis", taal: "" },
  { id: "1807", stamnummer: "6268", naam: "AS Houtain-milanello", taal: "" },
  { id: "698", stamnummer: "6282", naam: "KFC Olympia Recht", taal: "" },
  { id: "1543", stamnummer: "6301", naam: "Fc Ster-francorchamps", taal: "" },
  { id: "1809", stamnummer: "6310", naam: "RSC Tontelange", taal: "" },
  { id: "699", stamnummer: "6324", naam: "CS Corbion", taal: "" },
  { id: "1811", stamnummer: "6325", naam: "Vc Groot Dilbeek", taal: "nl" },
  { id: "98", stamnummer: "6327", naam: "K Kortessemse VV", taal: "nl" },
  { id: "1812", stamnummer: "6333", naam: "KFC Grun-weiss Amel", taal: "" },
  {
    id: "700",
    stamnummer: "6336",
    naam: "K�niglicher Honsfelder SV",
    taal: "",
  },
  { id: "1814", stamnummer: "6341", naam: "Niel K.S.K.", taal: "" },
  { id: "701", stamnummer: "6348", naam: "OC Nismes", taal: "" },
  { id: "1818", stamnummer: "6352", naam: "KFC Eendracht Hooglede", taal: "" },
  {
    id: "702",
    stamnummer: "6353",
    naam: "Eendracht Mazenzele Opwijk",
    taal: "nl",
  },
  { id: "10695", stamnummer: "6354", naam: "VK Weerde", taal: "" },
  { id: "1819", stamnummer: "6361", naam: "K Zutendaal VV", taal: "" },
  { id: "703", stamnummer: "6366", naam: "Ajs Buvrinnes", taal: "" },
  { id: "1825", stamnummer: "6368", naam: "RFC Rocherath", taal: "" },
  { id: "704", stamnummer: "6369", naam: "CS Lensois", taal: "" },
  { id: "705", stamnummer: "6370", naam: "RC Meldert", taal: "nl" },
  { id: "11219", stamnummer: "6371", naam: "R.f.c. Herinnes", taal: "" },
  { id: "11220", stamnummer: "6373", naam: "Alfa Andenne", taal: "" },
  { id: "1831", stamnummer: "6376", naam: "Jeunesse Bourdon", taal: "" },
  { id: "707", stamnummer: "6379", naam: "FC Zegelsem", taal: "" },
  { id: "708", stamnummer: "6381", naam: "KSC Wielsbeke", taal: "" },
  { id: "51", stamnummer: "6383", naam: "Seraing Athletique RFC", taal: "nl" },
  { id: "709", stamnummer: "6385", naam: "Patro-othee FC", taal: "" },
  { id: "1544", stamnummer: "6386", naam: "VC Jong Neervelp", taal: "" },
  { id: "1545", stamnummer: "6387", naam: "VV St-maria-horebeke", taal: "" },
  { id: "1546", stamnummer: "6421", naam: "R Haut-fays Sport", taal: "" },
  { id: "130", stamnummer: "6424", naam: "RES Vaux", taal: "fr" },
  { id: "1547", stamnummer: "6429", naam: "RJS Anseremmoise", taal: "" },
  { id: "710", stamnummer: "6432", naam: "RUS Ste-marie-sur-semois", taal: "" },
  { id: "711", stamnummer: "6435", naam: "KSK Snaaskerke", taal: "" },
  {
    id: "1209",
    stamnummer: "6439",
    naam: "Bodegem Kapelle United",
    taal: "nl",
  },
  { id: "712", stamnummer: "6440", naam: "KSK Oostnieuwkerke", taal: "" },
  { id: "713", stamnummer: "6447", naam: "FC Doggen Erembodegem", taal: "" },
  { id: "714", stamnummer: "6454", naam: "RCS Bossierois", taal: "" },
  { id: "1549", stamnummer: "6503", naam: "S-r Incourt", taal: "" },
  { id: "715", stamnummer: "6461", naam: "KVV Duffel", taal: "" },
  { id: "716", stamnummer: "6462", naam: "R Ecl Sp Signeulx", taal: "" },
  { id: "717", stamnummer: "6464", naam: "RFC Rapid Symphorinois", taal: "" },
  {
    id: "11221",
    stamnummer: "6466",
    naam: "Wall FC Fays-les-veneurs",
    taal: "",
  },
  { id: "719", stamnummer: "6531", naam: "Verbr Loksbergen", taal: "" },
  { id: "1550", stamnummer: "6532", naam: "RES Vaux-sur-sure", taal: "" },
  { id: "720", stamnummer: "6537", naam: "KFC Poppel", taal: "" },
  { id: "1551", stamnummer: "6545", naam: "Korbeek Sport", taal: "" },
  { id: "1552", stamnummer: "6546", naam: "R.u.s. D'erezee", taal: "" },
  { id: "1553", stamnummer: "6547", naam: "AS Regne", taal: "" },
  { id: "721", stamnummer: "6548", naam: "Et Elsautoise", taal: "" },
  { id: "722", stamnummer: "6549", naam: "RSC Haneffe", taal: "" },
  {
    id: "1554",
    stamnummer: "6553",
    naam: "La Jeunesse Sportive Morialme",
    taal: "",
  },
  { id: "1555", stamnummer: "6554", naam: "SC Villers-dt-orval", taal: "" },
  { id: "723", stamnummer: "6556", naam: "RJS Habaysienne", taal: "" },
  { id: "1556", stamnummer: "6558", naam: "EC Jamoigne-chiny", taal: "" },
  { id: "1557", stamnummer: "6559", naam: "JS Isieroise", taal: "" },
  { id: "724", stamnummer: "6561", naam: "Vrij Arendonk", taal: "" },
  { id: "725", stamnummer: "6563", naam: "Waterloos-voorshoven Vv", taal: "" },
  { id: "1558", stamnummer: "6570", naam: "SK Nevele", taal: "" },
  { id: "1559", stamnummer: "6616", naam: "SC De Nechin", taal: "" },
  { id: "10469", stamnummer: "6623", naam: "KVC Terheide", taal: "" },
  {
    id: "729",
    stamnummer: "6625",
    naam: "Fc Bonanza St-martens-lierde",
    taal: "",
  },
  { id: "730", stamnummer: "6626", naam: "CS Onhaye", taal: "fr" },
  { id: "1206", stamnummer: "6632", naam: "Black Star FC", taal: "nl" },
  { id: "732", stamnummer: "6633", naam: "ES De La Lesse Redu", taal: "" },
  { id: "1560", stamnummer: "6636", naam: "US Saint-remy", taal: "" },
  { id: "1561", stamnummer: "6650", naam: "R Union Club De Bras", taal: "" },
  { id: "1562", stamnummer: "6657", naam: "KFC Eupen 1963", taal: "" },
  { id: "733", stamnummer: "6700", naam: "Union Sportive Hensies", taal: "" },
  { id: "1563", stamnummer: "6701", naam: "AS Mont-saint-andre", taal: "" },
  { id: "1564", stamnummer: "6711", naam: "RDK Gravelo", taal: "" },
  { id: "11222", stamnummer: "6719", naam: "S.k. Nieuwkapelle", taal: "" },
  { id: "1566", stamnummer: "6723", naam: "R Wallonia Club Sibret", taal: "" },
  { id: "735", stamnummer: "6724", naam: "RC Villers La Ville", taal: "" },
  { id: "736", stamnummer: "6726", naam: "VC Eendr Deftinge", taal: "" },
  { id: "737", stamnummer: "6732", naam: "Ass Montkainoise", taal: "" },
  { id: "1568", stamnummer: "6738", naam: "JS Fumaloise", taal: "" },
  { id: "738", stamnummer: "6791", naam: "JS Racour", taal: "" },
  { id: "739", stamnummer: "6795", naam: "Tintigny", taal: "" },
  { id: "1569", stamnummer: "6796", naam: "KE St-anna Bottelare", taal: "" },
  { id: "740", stamnummer: "6803", naam: "FC Torpedo Hasselt", taal: "" },
  { id: "741", stamnummer: "6804", naam: "Royal Tenneville Sports", taal: "" },
  {
    id: "1570",
    stamnummer: "6812",
    naam: "Koninklijk Sporting Wijchmaal",
    taal: "",
  },
  { id: "1571", stamnummer: "6817", naam: "FC Namoussart", taal: "" },
  { id: "1572", stamnummer: "6818", naam: "CS Mont-st-guibert", taal: "" },
  { id: "743", stamnummer: "6820", naam: "VV Nieuwerkerken", taal: "" },
  { id: "744", stamnummer: "6821", naam: "JS Fizoise", taal: "" },
  { id: "1573", stamnummer: "6823", naam: "Jeun Sp De Tavigny", taal: "" },
  { id: "745", stamnummer: "6825", naam: "VS Kortenaken", taal: "" },
  { id: "746", stamnummer: "6827", naam: "OHR Huldenberg", taal: "" },
  { id: "1574", stamnummer: "6830", naam: "ES Heydoise", taal: "" },
  { id: "747", stamnummer: "6831", naam: "VC Houtem-oplinter", taal: "" },
  { id: "750", stamnummer: "6876", naam: "US Solrezienne", taal: "" },
  { id: "751", stamnummer: "6878", naam: "S.C. Donk", taal: "" },
  { id: "1575", stamnummer: "6887", naam: "Vesqueville", taal: "" },
  { id: "1576", stamnummer: "6888", naam: "Slw Maaseik", taal: "nl" },
  { id: "1577", stamnummer: "6890", naam: "Us Etalle", taal: "" },
  { id: "1578", stamnummer: "6891", naam: "KVVE Massemen", taal: "" },
  { id: "1579", stamnummer: "6893", naam: "FC Passendale", taal: "" },
  { id: "753", stamnummer: "6894", naam: "Heidebloem Wijshagen", taal: "" },
  { id: "754", stamnummer: "6895", naam: "US Assenois", taal: "" },
  { id: "755", stamnummer: "6896", naam: "KFC Walem", taal: "" },
  { id: "756", stamnummer: "6897", naam: "VC Rijmenam", taal: "" },
  { id: "1580", stamnummer: "6899", naam: "RSC Rachecourt", taal: "" },
  { id: "1581", stamnummer: "6909", naam: "Sportief Rotselaar", taal: "" },
  { id: "757", stamnummer: "6910", naam: "ES Petigny-frasnes", taal: "" },
  { id: "1582", stamnummer: "6912", naam: "US Carlsbourg-merny", taal: "" },
  { id: "758", stamnummer: "6914", naam: "Crossing Vissenaken", taal: "" },
  { id: "759", stamnummer: "6915", naam: "RES Chaumont", taal: "" },
  { id: "760", stamnummer: "6921", naam: "K Eendr Louwel", taal: "nl" },
  { id: "1583", stamnummer: "6922", naam: "St.Meerbeek", taal: "" },
  { id: "1584", stamnummer: "6923", naam: "ES Wellinoise", taal: "" },
  { id: "1585", stamnummer: "6926", naam: "Gentbrugge", taal: "" },
  { id: "761", stamnummer: "6931", naam: "Hargimont", taal: "" },
  { id: "11223", stamnummer: "6933", naam: "J.s. Solrezienne", taal: "" },
  { id: "762", stamnummer: "6934", naam: "Oignies", taal: "" },
  { id: "764", stamnummer: "6943", naam: "US Emines", taal: "" },
  { id: "1586", stamnummer: "6946", naam: "FC Kaprijke-bentille", taal: "" },
  { id: "1587", stamnummer: "6962", naam: "KFC Park Houthalen", taal: "" },
  { id: "1588", stamnummer: "6963", naam: "RCS Sart Tilman", taal: "" },
  { id: "1589", stamnummer: "7000", naam: "Sp Erps-kwerps", taal: "" },
  { id: "1590", stamnummer: "7002", naam: "Baudour ASC", taal: "" },
  { id: "765", stamnummer: "7008", naam: "Krc Peer", taal: "" },
  { id: "1591", stamnummer: "7009", naam: "VK Knesselare", taal: "" },
  {
    id: "1592",
    stamnummer: "7015",
    naam: "K Rode Duivels Zoutleeuw",
    taal: "",
  },
  { id: "1593", stamnummer: "7019", naam: "Entente Chatelet", taal: "" },
  { id: "1594", stamnummer: "7020", naam: "Sp Budingen", taal: "" },
  { id: "1595", stamnummer: "7021", naam: "Pont-a-celles-buzet", taal: "" },
  { id: "1596", stamnummer: "7025", naam: "WS Schorvoort Turnhout", taal: "" },
  { id: "766", stamnummer: "7026", naam: "KVV Kl Bassevelde", taal: "" },
  { id: "1597", stamnummer: "7027", naam: "KSK Sint-amands", taal: "" },
  { id: "767", stamnummer: "7028", naam: "Bregel Sport", taal: "" },
  { id: "1598", stamnummer: "7029", naam: "RUS Bure", taal: "" },
  { id: "1599", stamnummer: "7030", naam: "FC Esplechin", taal: "" },
  {
    id: "768",
    stamnummer: "7034",
    naam: "K Sporting Club Wiekevorst",
    taal: "",
  },
  { id: "769", stamnummer: "7036", naam: "Baulet Sport", taal: "" },
  { id: "1600", stamnummer: "7037", naam: "FC Lembeke", taal: "" },
  { id: "1601", stamnummer: "7041", naam: "Eendr Verrebroek", taal: "" },
  { id: "1602", stamnummer: "7043", naam: "Ent Sp Viroin-olloy", taal: "" },
  { id: "770", stamnummer: "7045", naam: "KSV Hoeselt", taal: "" },
  { id: "771", stamnummer: "7047", naam: "KFC Petegem Aan Schelde", taal: "" },
  { id: "1603", stamnummer: "7049", naam: "FC Eprave", taal: "" },
  { id: "1604", stamnummer: "7050", naam: "FC Marbaisien", taal: "" },
  { id: "772", stamnummer: "7053", naam: "ES Boninne", taal: "" },
  { id: "1605", stamnummer: "7055", naam: "FC Panters Okegem", taal: "" },
  { id: "1606", stamnummer: "7058", naam: "WS Meerdonk", taal: "" },
  { id: "1607", stamnummer: "7060", naam: "RSC Bovigny", taal: "" },
  { id: "773", stamnummer: "7070", naam: "FC Vurste-Semmerzake", taal: "" },
  { id: "774", stamnummer: "7074", naam: "KSC Dikkelvenne", taal: "" },
  { id: "1608", stamnummer: "7076", naam: "US Vecmont", taal: "" },
  { id: "10016", stamnummer: "7079", naam: "Bonneville Sp", taal: "fr" },
  {
    id: "775",
    stamnummer: "7081",
    naam: "Erpion-lacs De L'eau D'heure",
    taal: "",
  },
  { id: "1609", stamnummer: "7090", naam: "CD Furia Espanola", taal: "" },
  { id: "1610", stamnummer: "7137", naam: "Valencia VC Piringen", taal: "" },
  { id: "1611", stamnummer: "7162", naam: "Rwl Sport", taal: "nl" },
  { id: "1612", stamnummer: "7166", naam: "KSK Grembergen", taal: "" },
  { id: "1613", stamnummer: "7167", naam: "Kluisbergen Sportief", taal: "" },
  { id: "1614", stamnummer: "7168", naam: "FC Sparta Heestert", taal: "" },
  { id: "776", stamnummer: "7169", naam: "RJS Mageretoise", taal: "" },
  { id: "777", stamnummer: "7172", naam: "JB Eigenbilzen", taal: "" },
  { id: "1615", stamnummer: "7180", naam: "SK Bellem", taal: "" },
  { id: "1616", stamnummer: "7182", naam: "ES De Saint-pierre", taal: "" },
  { id: "778", stamnummer: "7183", naam: "RC De Rance", taal: "" },
  { id: "1617", stamnummer: "7185", naam: "St Cl Feschaux", taal: "" },
  { id: "779", stamnummer: "7186", naam: "Sporting Grote-brogel", taal: "" },
  { id: "780", stamnummer: "7187", naam: "SK Lokeren Doorslaar", taal: "" },
  { id: "781", stamnummer: "7188", naam: "ES Chatillon", taal: "" },
  { id: "784", stamnummer: "7195", naam: "AS Baisieux Qui�vrain", taal: "" },
  { id: "785", stamnummer: "7198", naam: "VV Herleving Lippelo", taal: "" },
  { id: "1211", stamnummer: "7201", naam: "RC.Schaerbeek", taal: "Frans" },
  { id: "786", stamnummer: "7202", naam: "KFC Hamont 99", taal: "" },
  {
    id: "1618",
    stamnummer: "7203",
    naam: "KSK Dennenheem Hertsberge",
    taal: "",
  },
  { id: "787", stamnummer: "7205", naam: "K DAVO Westende", taal: "" },
  { id: "788", stamnummer: "7206", naam: "FC Tenstar Melle", taal: "" },
  { id: "789", stamnummer: "7208", naam: "JS Froidchapelloise", taal: "" },
  { id: "1619", stamnummer: "7210", naam: "FC St-kruis-winkel", taal: "" },
  { id: "790", stamnummer: "7216", naam: "K Velm VV", taal: "" },
  { id: "1620", stamnummer: "7217", naam: "Ent Dionaise", taal: "" },
  { id: "792", stamnummer: "7220", naam: "CS Burdinnois", taal: "" },
  { id: "794", stamnummer: "7257", naam: "FC Bullingen", taal: "" },
  { id: "795", stamnummer: "7268", naam: "FC Vacresse", taal: "" },
  { id: "796", stamnummer: "7290", naam: "Sparta Lille", taal: "" },
  { id: "1621", stamnummer: "7292", naam: "Entente Sp Meix-le-tige", taal: "" },
  { id: "1622", stamnummer: "7293", naam: "US Awenne", taal: "" },
  { id: "797", stamnummer: "7294", naam: "R.u.s. D'ophain", taal: "" },
  { id: "798", stamnummer: "7300", naam: "FC Ramsdonk", taal: "" },
  { id: "799", stamnummer: "7301", naam: "SK Oetingen VC", taal: "" },
  { id: "800", stamnummer: "7302", naam: "KSV Aartselaar", taal: "" },
  { id: "1623", stamnummer: "7306", naam: "FC Helkijn", taal: "" },
  { id: "1624", stamnummer: "7308", naam: "FC Nalinnois", taal: "" },
  { id: "802", stamnummer: "7310", naam: "Chevetogne Football", taal: "" },
  { id: "803", stamnummer: "7314", naam: "Gs Bree-beek", taal: "" },
  { id: "804", stamnummer: "7315", naam: "Fc Snef", taal: "" },
  { id: "806", stamnummer: "7321", naam: "Terk.Alken", taal: "" },
  { id: "807", stamnummer: "7322", naam: "K Grimbie 69", taal: "" },
  { id: "808", stamnummer: "7325", naam: "FC Blaasveld", taal: "" },
  { id: "809", stamnummer: "7326", naam: "SV Zaffelare", taal: "" },
  { id: "810", stamnummer: "7327", naam: "SK Herdersem", taal: "" },
  {
    id: "1625",
    stamnummer: "7328",
    naam: "FC Mont-s-marchienne-college",
    taal: "",
  },
  { id: "811", stamnummer: "7330", naam: "KFC Eksaarde", taal: "" },
  { id: "812", stamnummer: "7332", naam: "RFC Soumagne", taal: "" },
  { id: "813", stamnummer: "7334", naam: "FC De Zwaluw Vechmaal", taal: "" },
  { id: "1626", stamnummer: "7336", naam: "SSD Opoeteren", taal: "" },
  { id: "11224", stamnummer: "7347", naam: "S.c. Petit-waret", taal: "" },
  { id: "147", stamnummer: "7358", naam: "US Thy-le-chateau", taal: "fr" },
  { id: "1627", stamnummer: "7411", naam: "Sporting Ellikom", taal: "" },
  { id: "1628", stamnummer: "7419", naam: "RC Ciergnon", taal: "" },
  { id: "1629", stamnummer: "7432", naam: "SG Rapid Oudler", taal: "" },
  { id: "814", stamnummer: "7433", naam: "SC Vance", taal: "" },
  { id: "815", stamnummer: "7434", naam: "Racing Strijpen", taal: "" },
  { id: "1630", stamnummer: "7435", naam: "Runkst V.V.", taal: "" },
  { id: "1631", stamnummer: "7436", naam: "K Minderhout VV", taal: "" },
  { id: "1632", stamnummer: "7437", naam: "Rienne Sports", taal: "" },
  { id: "1633", stamnummer: "7446", naam: "Patro Lensois", taal: "" },
  { id: "1634", stamnummer: "7447", naam: "CS Esp Han-sur-lesse", taal: "" },
  { id: "816", stamnummer: "7449", naam: "FC Boussu-lez-walcourt", taal: "" },
  { id: "1635", stamnummer: "7451", naam: "FC St-martin Pessoux", taal: "" },
  { id: "1636", stamnummer: "7452", naam: "SK Wichelen", taal: "" },
  { id: "817", stamnummer: "7453", naam: "USH Limontoise", taal: "" },
  { id: "1637", stamnummer: "7454", naam: "US Archennes-pecrot", taal: "" },
  { id: "1638", stamnummer: "7457", naam: "FC Gerpinnes", taal: "" },
  { id: "1639", stamnummer: "7459", naam: "CS Forges", taal: "" },
  { id: "818", stamnummer: "7460", naam: "Lindelhoeven VV", taal: "" },
  { id: "819", stamnummer: "7464", naam: "SK Vlierzele", taal: "" },
  { id: "820", stamnummer: "7465", naam: "FC Ellezellois", taal: "" },
  { id: "821", stamnummer: "7468", naam: "VC Osta Meerbeke", taal: "" },
  { id: "1640", stamnummer: "7469", naam: "CS Toernich", taal: "" },
  { id: "822", stamnummer: "7480", naam: "SK Waanrode", taal: "" },
  { id: "823", stamnummer: "7491", naam: "Standard Flawinne FC", taal: "" },
  { id: "1642", stamnummer: "7492", naam: "Wieze", taal: "" },
  {
    id: "1643",
    stamnummer: "7494",
    naam: "Fc Hoogeinde St-gillis-waas",
    taal: "",
  },
  { id: "824", stamnummer: "7495", naam: "ESFC Du Geer", taal: "" },
  {
    id: "1644",
    stamnummer: "7498",
    naam: "CS Bellevaux-ligneuville",
    taal: "",
  },
  { id: "825", stamnummer: "7500", naam: "CS Bollandois", taal: "" },
  {
    id: "1645",
    stamnummer: "7501",
    naam: "Jeunesses Oleyennes Reunies",
    taal: "",
  },
  {
    id: "1646",
    stamnummer: "7502",
    naam: "Sp.Vilvoorde-Koningslo B",
    taal: "",
  },
  { id: "826", stamnummer: "7514", naam: "SK Wachtebeke", taal: "" },
  { id: "827", stamnummer: "7551", naam: "Etoile De Faimes", taal: "" },
  { id: "1647", stamnummer: "7554", naam: "SC Orsmaal", taal: "" },
  { id: "828", stamnummer: "7557", naam: "FC Naninnois", taal: "" },
  { id: "829", stamnummer: "7558", naam: "VK Watervliet", taal: "" },
  { id: "831", stamnummer: "7565", naam: "Sp Tisselt", taal: "" },
  { id: "832", stamnummer: "7569", naam: "FC Ganshoren", taal: "" },
  { id: "1648", stamnummer: "7572", naam: "US De Pesche", taal: "" },
  { id: "833", stamnummer: "7574", naam: "FC Thulin", taal: "" },
  { id: "834", stamnummer: "7575", naam: "J�honville", taal: "" },
  { id: "1212", stamnummer: "7579", naam: "Sporting Eizeringen", taal: "nl" },
  { id: "1649", stamnummer: "7582", naam: "ES Villance", taal: "" },
  { id: "1650", stamnummer: "7584", naam: "ES Petitvoir-tournay", taal: "" },
  { id: "1651", stamnummer: "7585", naam: "Jeunesse Autelbas", taal: "" },
  { id: "1652", stamnummer: "7586", naam: "FC Negenmanneke", taal: "" },
  { id: "1653", stamnummer: "7589", naam: "FC Kleit Maldegem", taal: "" },
  { id: "1654", stamnummer: "7592", naam: "FC Aedec-hyon", taal: "" },
  { id: "836", stamnummer: "7593", naam: "Ass Sp Chimay-virelles", taal: "" },
  { id: "1655", stamnummer: "7597", naam: "KSV Melsen", taal: "" },
  { id: "10979", stamnummer: "7599", naam: "Toekomst Relegem", taal: "" },
  { id: "11225", stamnummer: "7610", naam: "F.c. Bra", taal: "" },
  { id: "11226", stamnummer: "7613", naam: "JSC Brugelette", taal: "" },
  { id: "1656", stamnummer: "7656", naam: "AC Estaimbourg", taal: "" },
  { id: "840", stamnummer: "7698", naam: "US Thumaide", taal: "" },
  { id: "841", stamnummer: "7700", naam: "JS Merdorp", taal: "" },
  { id: "1657", stamnummer: "7717", naam: "Transinne", taal: "" },
  { id: "842", stamnummer: "7719", naam: "FC Zwaneven", taal: "" },
  { id: "1658", stamnummer: "7731", naam: "SK Oudegem", taal: "" },
  { id: "1660", stamnummer: "7740", naam: "All Huppaytoise", taal: "" },
  { id: "10691", stamnummer: "7741", naam: "SK Pepingen-halle", taal: "" },
  { id: "843", stamnummer: "7742", naam: "Heis Sport Bilzen", taal: "" },
  { id: "1662", stamnummer: "7744", naam: "FC Dworp", taal: "" },
  {
    id: "844",
    stamnummer: "7749",
    naam: "Fc Int Jandrain-jandrenouille",
    taal: "",
  },
  { id: "845", stamnummer: "7753", naam: "FC Beigem", taal: "" },
  { id: "1663", stamnummer: "7756", naam: "Huccorgne Sports", taal: "" },
  { id: "1664", stamnummer: "7758", naam: "KDN United", taal: "" },
  { id: "846", stamnummer: "7760", naam: "FC Kerksken", taal: "" },
  { id: "131", stamnummer: "7763", naam: "Fc Arlon", taal: "fr" },
  { id: "1665", stamnummer: "7766", naam: "FC St-germain", taal: "" },
  { id: "11227", stamnummer: "7769", naam: "Athl. Club Le Roeulx", taal: "" },
  { id: "1666", stamnummer: "7770", naam: "Union Cecilienne", taal: "" },
  { id: "848", stamnummer: "7771", naam: "SC Saive", taal: "" },
  { id: "11228", stamnummer: "7772", naam: "ESC Horrues", taal: "" },
  { id: "11229", stamnummer: "7773", naam: "Mellet Sports", taal: "" },
  { id: "1208", stamnummer: "7774", naam: "FC Saint-michel", taal: "Frans" },
  { id: "115", stamnummer: "7776", naam: "K. Lyra-Lierse", taal: "nl" },
  { id: "850", stamnummer: "7777", naam: "Zeveren Sportief", taal: "" },
  { id: "1667", stamnummer: "7778", naam: "JS Falisolle-aisemont", taal: "" },
  { id: "851", stamnummer: "7779", naam: "Et Sp Bourcy", taal: "" },
  { id: "852", stamnummer: "7780", naam: "Jeun Tavietoise", taal: "" },
  { id: "853", stamnummer: "7781", naam: "Boutersem United", taal: "" },
  { id: "1668", stamnummer: "7783", naam: "VK Holsbeek", taal: "" },
  { id: "854", stamnummer: "7784", naam: "SK Meldert", taal: "nl" },
  { id: "1669", stamnummer: "7800", naam: "V.Strijland Gooik", taal: "" },
  { id: "855", stamnummer: "7813", naam: "FC Punt-larum", taal: "" },
  { id: "11230", stamnummer: "7824", naam: "AS Gerouville", taal: "" },
  { id: "857", stamnummer: "7826", naam: "FC Warsage", taal: "" },
  { id: "858", stamnummer: "7835", naam: "Un Walhorn", taal: "" },
  { id: "859", stamnummer: "7839", naam: "FC Beclers", taal: "" },
  { id: "1670", stamnummer: "7840", naam: "US Bohannaise", taal: "" },
  { id: "99", stamnummer: "7850", naam: "SK Berlare", taal: "nl" },
  { id: "860", stamnummer: "7861", naam: "VK Nederhasselt", taal: "" },
  {
    id: "1671",
    stamnummer: "7908",
    naam: "US St-bern Waltzing-bonnert",
    taal: "",
  },
  { id: "863", stamnummer: "7919", naam: "Eendracht Termien", taal: "" },
  { id: "864", stamnummer: "7920", naam: "Sp Molenbeek", taal: "" },
  { id: "865", stamnummer: "7921", naam: "Deurne SK", taal: "" },
  { id: "1672", stamnummer: "7923", naam: "SV Grasheide", taal: "nl" },
  { id: "866", stamnummer: "7924", naam: "VW.Mollem", taal: "" },
  { id: "867", stamnummer: "7926", naam: "Grenstr Kol Lommel", taal: "" },
  { id: "868", stamnummer: "7928", naam: "FC Moorsel", taal: "" },
  { id: "1673", stamnummer: "7936", naam: "JS Wez-guignies", taal: "" },
  { id: "1674", stamnummer: "7937", naam: "VV Emelgem-kachtem", taal: "" },
  { id: "869", stamnummer: "7938", naam: "SK Aaigem", taal: "" },
  { id: "1675", stamnummer: "7941", naam: "VK Borchtlombeek", taal: "" },
  { id: "870", stamnummer: "7948", naam: "FC Brunehaut", taal: "" },
  { id: "871", stamnummer: "7951", naam: "Jong Male VV", taal: "" },
  { id: "1676", stamnummer: "7960", naam: "VV Kanne", taal: "" },
  { id: "872", stamnummer: "7961", naam: "Zennester Hombeek", taal: "" },
  { id: "1677", stamnummer: "7969", naam: "AC Anvaing", taal: "" },
  { id: "873", stamnummer: "7980", naam: "ES Gimnee-mazee", taal: "" },
  { id: "1678", stamnummer: "7999", naam: "Standario FC Onoz", taal: "" },
  { id: "874", stamnummer: "8000", naam: "RC Reppel", taal: "" },
  { id: "875", stamnummer: "8003", naam: "Lando Sport Merendree", taal: "" },
  { id: "876", stamnummer: "8004", naam: "SK Rooierheide", taal: "" },
  { id: "877", stamnummer: "8005", naam: "FC Schepdaal", taal: "" },
  { id: "878", stamnummer: "8026", naam: "KFC Anadol", taal: "" },
  { id: "879", stamnummer: "8074", naam: "Lindeboys SpLeut", taal: "" },
  {
    id: "880",
    stamnummer: "8083",
    naam: "Sporting Grote-heide Neerpelt",
    taal: "",
  },
  { id: "10011", stamnummer: "8089", naam: "FC Malonne 2000", taal: "" },
  { id: "882", stamnummer: "8098", naam: "US Mellier", taal: "" },
  { id: "883", stamnummer: "8101", naam: "VK White-boys St-niklaas", taal: "" },
  {
    id: "1679",
    stamnummer: "8102",
    naam: "KFC Juventus Schoonaarde",
    taal: "",
  },
  { id: "884", stamnummer: "8104", naam: "Ritterklub VSV Jette", taal: "" },
  { id: "885", stamnummer: "8105", naam: "Bonnerue", taal: "" },
  { id: "886", stamnummer: "8106", naam: "US Flavion-morialme", taal: "" },
  { id: "887", stamnummer: "8107", naam: "SK Moelingen", taal: "" },
  { id: "1680", stamnummer: "8109", naam: "ESC Poupehan", taal: "" },
  { id: "1681", stamnummer: "8111", naam: "FC Merksem", taal: "" },
  { id: "888", stamnummer: "8112", naam: "SK Reningelst", taal: "" },
  { id: "889", stamnummer: "8114", naam: "Sparta Kruiseke", taal: "" },
  { id: "1682", stamnummer: "8115", naam: "ES Des Frontieres", taal: "" },
  { id: "890", stamnummer: "8119", naam: "SV Breugel", taal: "" },
  { id: "891", stamnummer: "8121", naam: "A.C.Tervant", taal: "" },
  { id: "1683", stamnummer: "8122", naam: "FC Houthem", taal: "" },
  { id: "11231", stamnummer: "8125", naam: "FC Rumes-la Glanerie", taal: "" },
  { id: "100", stamnummer: "8126", naam: "Thor Kokerij-meldert", taal: "nl" },
  { id: "892", stamnummer: "8127", naam: "Sporting Aalst", taal: "" },
  { id: "893", stamnummer: "8128", naam: "Habo SK Borgloon", taal: "" },
  { id: "894", stamnummer: "8142", naam: "AS Pommeroeul-ville", taal: "" },
  { id: "895", stamnummer: "8143", naam: "SVV Damme", taal: "" },
  { id: "1684", stamnummer: "8152", naam: "Charneux FC", taal: "" },
  { id: "1685", stamnummer: "8171", naam: "Belgrade", taal: "" },
  { id: "896", stamnummer: "8175", naam: "Hoek Sp.Zaventem", taal: "" },
  { id: "1686", stamnummer: "8176", naam: "Diables Rouges Rongy", taal: "" },
  { id: "897", stamnummer: "8182", naam: "Sk Spermalie Middelkerke", taal: "" },
  { id: "898", stamnummer: "8195", naam: "Eendr Vinkt", taal: "" },
  { id: "900", stamnummer: "8208", naam: "SK Opbrakel", taal: "" },
  { id: "902", stamnummer: "8244", naam: "FCE Stembertoise", taal: "" },
  { id: "1688", stamnummer: "8248", naam: "US Ploegsteert-bizet", taal: "" },
  { id: "903", stamnummer: "8250", naam: "KVV Zepperen-brustem", taal: "" },
  {
    id: "1689",
    stamnummer: "8259",
    naam: "Amandina Vc Schakkebroek",
    taal: "",
  },
  { id: "1690", stamnummer: "8261", naam: "Sporting Keiem", taal: "" },
  { id: "1691", stamnummer: "8262", naam: "SV Voorde", taal: "" },
  { id: "1692", stamnummer: "8263", naam: "FC Smetlede", taal: "" },
  { id: "904", stamnummer: "8264", naam: "VK Dadizele", taal: "" },
  {
    id: "905",
    stamnummer: "8265",
    naam: "Renouveau US Tournai-warcoing",
    taal: "",
  },
  { id: "1693", stamnummer: "8266", naam: "RC Gouy", taal: "" },
  { id: "906", stamnummer: "8268", naam: "AC Soiron", taal: "" },
  { id: "907", stamnummer: "8270", naam: "FC Hermee", taal: "" },
  { id: "908", stamnummer: "8272", naam: "Sporting Heide Linter", taal: "" },
  { id: "909", stamnummer: "8273", naam: "VV Eendracht Brugge", taal: "" },
  { id: "910", stamnummer: "8276", naam: "CS Wepionnais", taal: "" },
  { id: "1695", stamnummer: "8278", naam: "Eynatten", taal: "" },
  { id: "911", stamnummer: "8280", naam: "VKSO Zerkegem", taal: "" },
  {
    id: "912",
    stamnummer: "8282",
    naam: "Entente Velaines Enclusienne",
    taal: "",
  },
  { id: "913", stamnummer: "8284", naam: "AC Hombourg", taal: "" },
  { id: "1696", stamnummer: "8286", naam: "FC Marquain", taal: "" },
  { id: "914", stamnummer: "8287", naam: "SK Munkzwalm", taal: "" },
  { id: "916", stamnummer: "8290", naam: "SK Nieuwkerke", taal: "" },
  { id: "1697", stamnummer: "8292", naam: "Dailly", taal: "" },
  { id: "917", stamnummer: "8299", naam: "FC Forest", taal: "" },
  { id: "1698", stamnummer: "8305", naam: "Willen Is Kunnen Boekel", taal: "" },
  { id: "10997", stamnummer: "8349", naam: "Vk Jong Geraardsbergen", taal: "" },
  {
    id: "1699",
    stamnummer: "8350",
    naam: "Union Famenne Waha Marche",
    taal: "",
  },
  { id: "923", stamnummer: "8352", naam: "Ass Sp Club Havinnes", taal: "" },
  {
    id: "924",
    stamnummer: "8363",
    naam: "Voorwaarts Gijzel-oosterzele",
    taal: "",
  },
  {
    id: "925",
    stamnummer: "8364",
    naam: "Football Club Etoiles D'ere",
    taal: "",
  },
  { id: "926", stamnummer: "8397", naam: "Sommi�re", taal: "" },
  { id: "1700", stamnummer: "8401", naam: "Fc Mesnilois", taal: "" },
  { id: "927", stamnummer: "8403", naam: "BS Geluveld", taal: "" },
  { id: "1701", stamnummer: "8405", naam: "Sparta Dikkebus", taal: "" },
  { id: "1702", stamnummer: "8406", naam: "Three Stars Club Proven", taal: "" },
  { id: "928", stamnummer: "8408", naam: "Sk Vlezenbeek", taal: "nl" },
  { id: "1703", stamnummer: "8410", naam: "WS Wommersom", taal: "" },
  { id: "1704", stamnummer: "8411", naam: "WS Zarren", taal: "" },
  { id: "1705", stamnummer: "8412", naam: "JS Ittroise", taal: "" },
  { id: "929", stamnummer: "8414", naam: "VV Leke-vladslo", taal: "" },
  { id: "930", stamnummer: "8416", naam: "Ap. Gellik", taal: "" },
  { id: "1706", stamnummer: "8419", naam: "Sv Kobbegem", taal: "" },
  { id: "931", stamnummer: "8420", naam: "Daring Brugge VV", taal: "" },
  { id: "1707", stamnummer: "8421", naam: "Andoy Wierde FC", taal: "" },
  { id: "1708", stamnummer: "8422", naam: "UCE De Liege", taal: "" },
  { id: "932", stamnummer: "8425", naam: "VK Eendr Eizer", taal: "" },
  { id: "933", stamnummer: "8441", naam: "AF Us St Amand-brye", taal: "" },
  { id: "1709", stamnummer: "8445", naam: "FC Westouter", taal: "" },
  { id: "934", stamnummer: "8450", naam: "SV Herkol Neerpelt", taal: "" },
  { id: "1710", stamnummer: "8461", naam: "Fraire", taal: "" },
  { id: "935", stamnummer: "8470", naam: "CS Entite Manageoise", taal: "" },
  { id: "936", stamnummer: "8471", naam: "VK Gestel", taal: "" },
  { id: "1711", stamnummer: "8472", naam: "FC Laplaigne", taal: "" },
  { id: "1712", stamnummer: "8512", naam: "Et Sp Brainoise", taal: "" },
  { id: "1713", stamnummer: "8513", naam: "SK Elverdinge", taal: "" },
  { id: "937", stamnummer: "8514", naam: "Groene Duivels Ingooigem", taal: "" },
  { id: "1714", stamnummer: "8522", naam: "VK Linden", taal: "" },
  {
    id: "938",
    stamnummer: "8523",
    naam: "Fc Dynamo Klein-gent Beervelde",
    taal: "",
  },
  { id: "11232", stamnummer: "8533", naam: "Wsac Fleurus", taal: "" },
  { id: "939", stamnummer: "8534", naam: "VJ Baardegem", taal: "" },
  { id: "1715", stamnummer: "8537", naam: "SC Mazycien", taal: "" },
  { id: "941", stamnummer: "8539", naam: "Oordegem", taal: "" },
  { id: "942", stamnummer: "8552", naam: "Avanti Stekene", taal: "" },
  { id: "943", stamnummer: "8588", naam: "Vrij Vooruit Voorshoven", taal: "" },
  { id: "944", stamnummer: "8591", naam: "WS Lovrienden Lotenhulle", taal: "" },
  { id: "1716", stamnummer: "8594", naam: "FC Casteau", taal: "" },
  { id: "945", stamnummer: "8601", naam: "Fc Lebbeke", taal: "" },
  { id: "946", stamnummer: "8603", naam: "Umitspor Maasmechelen", taal: "" },
  { id: "1718", stamnummer: "8605", naam: "WS Bulskamp", taal: "" },
  { id: "11233", stamnummer: "8612", naam: "Rood-wit Hollebeke", taal: "" },
  { id: "1719", stamnummer: "8621", naam: "HO Oostveld Oedelem", taal: "" },
  { id: "947", stamnummer: "8642", naam: "KFC Edeboys", taal: "" },
  { id: "1721", stamnummer: "8647", naam: "SV Sint-antelinks", taal: "" },
  { id: "948", stamnummer: "8652", naam: "VC Herzele-ressegem", taal: "" },
  { id: "1722", stamnummer: "8653", naam: "Wilskracht Idegem", taal: "" },
  { id: "1723", stamnummer: "8661", naam: "CS Biergeois", taal: "" },
  { id: "949", stamnummer: "8710", naam: "JS Hognouloise", taal: "" },
  { id: "950", stamnummer: "8713", naam: "SK Verbr Oostakker", taal: "" },
  { id: "133", stamnummer: "8715", naam: "Tempo Overijse", taal: "nl" },
  { id: "951", stamnummer: "8719", naam: "AS Vaudignies", taal: "" },
  { id: "952", stamnummer: "8721", naam: "Rc Hades Kiewit Hasselt", taal: "" },
  { id: "953", stamnummer: "8725", naam: "VC Eendracht Houtem", taal: "" },
  { id: "954", stamnummer: "8736", naam: "VV Sparta Ursel", taal: "" },
  { id: "1725", stamnummer: "8746", naam: "VC Zevergem Sp", taal: "" },
  { id: "955", stamnummer: "8752", naam: "Turkse FC Beringen", taal: "" },
  { id: "956", stamnummer: "8755", naam: "Ven Maaseik", taal: "" },
  { id: "1726", stamnummer: "8762", naam: "Houtain Genappe", taal: "" },
  { id: "957", stamnummer: "8765", naam: "FC Oppuurs", taal: "" },
  { id: "958", stamnummer: "8768", naam: "FC Montleban", taal: "" },
  {
    id: "1727",
    stamnummer: "8778",
    naam: "Fc Goalgetters St-laureins",
    taal: "",
  },
  { id: "959", stamnummer: "8780", naam: "SV Everbeek", taal: "" },
  { id: "1728", stamnummer: "8828", naam: "VK Tielrode", taal: "" },
  { id: "1729", stamnummer: "8832", naam: "Dosko Kanegem", taal: "" },
  { id: "1730", stamnummer: "8845", naam: "SK Peulis", taal: "" },
  {
    id: "961",
    stamnummer: "8850",
    naam: "Entente Sportive Elouges Dour",
    taal: "",
  },
  { id: "962", stamnummer: "8870", naam: "Jeunesse Turque", taal: "" },
  { id: "1731", stamnummer: "8887", naam: "JUS Maubray", taal: "" },
  { id: "963", stamnummer: "8889", naam: "Olympic Anderlecht", taal: "" },
  { id: "1732", stamnummer: "8893", naam: "Daring Maria-aalter", taal: "" },
  { id: "966", stamnummer: "8953", naam: "Excelsior Hamont", taal: "" },
  { id: "1733", stamnummer: "8959", naam: "CS Taintignies", taal: "" },
  { id: "1735", stamnummer: "8988", naam: "VV Volkegem", taal: "" },
  {
    id: "11234",
    stamnummer: "9022",
    naam: "ES Arquennes-familleureux",
    taal: "",
  },
  { id: "969", stamnummer: "9023", naam: "Racing Mater", taal: "" },
  { id: "11023", stamnummer: "9026", naam: "Bx Brussels", taal: "" },
  { id: "1737", stamnummer: "9027", naam: "JS Pierreuse", taal: "" },
  { id: "1738", stamnummer: "9028", naam: "SK Nieuwe Kempen", taal: "" },
  { id: "970", stamnummer: "9035", naam: "JS Kemexhe Crisnee", taal: "" },
  { id: "971", stamnummer: "9043", naam: "Gold Star Voormezele", taal: "" },
  {
    id: "1741",
    stamnummer: "9074",
    naam: "KVVHou Ende Trou Zwijnaarde",
    taal: "",
  },
  { id: "972", stamnummer: "9075", naam: "JS Du Thier A Liege", taal: "" },
  { id: "973", stamnummer: "9079", naam: "VSV Gent", taal: "" },
  { id: "1742", stamnummer: "9080", naam: "Union Hesbignonne", taal: "" },
  { id: "974", stamnummer: "9084", naam: "Bury Foot-club", taal: "" },
  { id: "975", stamnummer: "9085", naam: "FC Eendracht Houthalen", taal: "" },
  { id: "976", stamnummer: "9088", naam: "Statie Zolder", taal: "" },
  { id: "1744", stamnummer: "9125", naam: "FC Daknam", taal: "" },
  { id: "978", stamnummer: "9126", naam: "FC Horion", taal: "" },
  { id: "979", stamnummer: "9130", naam: "Melo Zonhoven", taal: "" },
  { id: "11235", stamnummer: "9146", naam: "F.c. Obourg", taal: "" },
  {
    id: "982",
    stamnummer: "9147",
    naam: "FC Turkse Rangers Waterschei",
    taal: "",
  },
  {
    id: "983",
    stamnummer: "9156",
    naam: "Verbr Beersel Drogenbos",
    taal: "nl",
  },
  { id: "1745", stamnummer: "9160", naam: "SK Vinderhoute", taal: "" },
  { id: "1746", stamnummer: "9165", naam: "FC Poesele", taal: "" },
  { id: "1747", stamnummer: "9166", naam: "FC Bleharies", taal: "" },
  { id: "984", stamnummer: "9174", naam: "Kadijk SK Overpelt", taal: "" },
  { id: "987", stamnummer: "9200", naam: "VV Mlk Lichtaart", taal: "" },
  { id: "989", stamnummer: "9212", naam: "FC Turk Sport Antwerpen", taal: "" },
  { id: "991", stamnummer: "9238", naam: "VV Westkapelle", taal: "" },
  {
    id: "10983",
    stamnummer: "9241",
    naam: "Fc Greunsjotters Vossem",
    taal: "",
  },
  { id: "1750", stamnummer: "9243", naam: "SV.Ressegem", taal: "" },
  { id: "992", stamnummer: "9244", naam: "SK Westrozebeke", taal: "" },
  {
    id: "1751",
    stamnummer: "9245",
    naam: "Cs Pays Vert Ostiches-ath",
    taal: "",
  },
  { id: "993", stamnummer: "9246", naam: "Leeuw Brucom", taal: "" },
  { id: "994", stamnummer: "9248", naam: "Miecroob Veltem", taal: "" },
  { id: "995", stamnummer: "9251", naam: "VK Akkers Middelburg", taal: "" },
  { id: "1752", stamnummer: "9252", naam: "JS Jamioulx", taal: "" },
  { id: "1753", stamnummer: "9253", naam: "VVG Alveringem", taal: "" },
  { id: "52", stamnummer: "9264", naam: "Sportkring Sint-niklaas", taal: "nl" },
  { id: "1755", stamnummer: "9267", naam: "FC Kosova Schaerbeek", taal: "" },
  { id: "998", stamnummer: "9270", naam: "Racing Butsel", taal: "" },
  { id: "1000", stamnummer: "9273", naam: "SK Zillebeke", taal: "" },
  { id: "1004", stamnummer: "9281", naam: "Standaard Michelbeke", taal: "" },
  { id: "1005", stamnummer: "9282", naam: "JS.Chaumont-Gistoux A", taal: "" },
  { id: "1006", stamnummer: "9283", naam: "VK Dudzele", taal: "" },
  { id: "1756", stamnummer: "9284", naam: "FC Entite Wasseiges", taal: "" },
  { id: "1008", stamnummer: "9304", naam: "Standaard Neerwinden", taal: "" },
  { id: "1471", stamnummer: "5359", naam: "K Eendr Machelen-a-leie", taal: "" },
  { id: "611", stamnummer: "5579", naam: "RFC Sart-lez-spa", taal: "" },
  { id: "623", stamnummer: "5648", naam: "KSC Wilskr Hofstade", taal: "" },
  { id: "726", stamnummer: "6576", naam: "Sporting Bruxelles", taal: "" },
  { id: "839", stamnummer: "7654", naam: "VK St-agatha-berchem", taal: "" },
  { id: "1659", stamnummer: "7734", naam: "FC Berlaar-heikant", taal: "" },
  { id: "11759", stamnummer: "1403", naam: "Ent.c.f.du Hainaut", taal: "fr" },
  {
    id: "11760",
    stamnummer: "1551",
    naam: "R. Ent. Prov. De Namur",
    taal: "fr",
  },
  { id: "430", stamnummer: "3558", naam: "SK.Lebbeke", taal: "" },
  {
    id: "1422",
    stamnummer: "4300",
    naam: "R Gr Corporatif Charleroi",
    taal: "",
  },
  {
    id: "11761",
    stamnummer: "4597",
    naam: "K Boomse Scheidsr Veren",
    taal: "nl",
  },
  {
    id: "11762",
    stamnummer: "5053",
    naam: "Oudenaardse Verstandhouding",
    taal: "nl",
  },
  {
    id: "11763",
    stamnummer: "5065",
    naam: "Verst Mandel-leie-schelde",
    taal: "nl",
  },
  {
    id: "11764",
    stamnummer: "5115",
    naam: "Ent Condruzienne Des Clubs",
    taal: "fr",
  },
  {
    id: "11765",
    stamnummer: "5275",
    naam: "R Gr Corp Centre Mons Bor",
    taal: "fr",
  },
  { id: "11766", stamnummer: "6338", naam: "K. Sch.vk. Turnhout", taal: "nl" },
  {
    id: "11767",
    stamnummer: "6715",
    naam: "K.v.k. Sch. V.h. Noorden",
    taal: "nl",
  },
  { id: "11768", stamnummer: "6784", naam: "K. Maaslandse Sch.v.", taal: "nl" },
  {
    id: "11769",
    stamnummer: "6920",
    naam: "R. Ent. Cl. Prov. Liege",
    taal: "fr",
  },
  {
    id: "11770",
    stamnummer: "7714",
    naam: "RGroupArbitMons Et Extens",
    taal: "fr",
  },
  { id: "1687", stamnummer: "8191", naam: "V.k. Veldkanteva's", taal: "" },
  { id: "11202", stamnummer: "8238", naam: "RC Genk Ladies", taal: "nl" },
  { id: "918", stamnummer: "8337", naam: "SK Opex Girls Oostende B", taal: "" },
  { id: "920", stamnummer: "8339", naam: "F�mina Antheit B", taal: "" },
  {
    id: "922",
    stamnummer: "8351",
    naam: "Football Club Menen United",
    taal: "",
  },
  { id: "1717", stamnummer: "8599", naam: "Lommel United Ws", taal: "" },
  { id: "1724", stamnummer: "8669", naam: "Sw Ladies Harelbeke", taal: "" },
  {
    id: "11772",
    stamnummer: "8701",
    naam: "K. Sch. Ieper/poperinge",
    taal: "nl",
  },
  { id: "11236", stamnummer: "8898", naam: "Coxy Ladies Wulpen", taal: "" },
  { id: "1736", stamnummer: "9024", naam: "Dames VK Egem", taal: "" },
  { id: "11773", stamnummer: "9025", naam: "Gewest Gent-eeklo", taal: "nl" },
  {
    id: "11774",
    stamnummer: "9034",
    naam: "Group Des Arb De La Dodaine",
    taal: "fr",
  },
  {
    id: "1740",
    stamnummer: "9040",
    naam: "Famkes Westhoek Diksmuide Merkem",
    taal: "nl",
  },
  {
    id: "11775",
    stamnummer: "9071",
    naam: "Federation NatDes Supporters",
    taal: "nl",
  },
  {
    id: "11776",
    stamnummer: "9119",
    naam: "Kempense Verstandhouding",
    taal: "nl",
  },
  {
    id: "11777",
    stamnummer: "9120",
    naam: "R.u.n.b.o.c. - K.n.u.c.",
    taal: "fr",
  },
  { id: "980", stamnummer: "9131", naam: "Gfa Sinaai", taal: "" },
  {
    id: "11778",
    stamnummer: "9135",
    naam: "IF Deutschprachigen Gem",
    taal: "fr",
  },
  {
    id: "11779",
    stamnummer: "9141",
    naam: "De Westhoek Verstandhouding",
    taal: "nl",
  },
  {
    id: "11780",
    stamnummer: "9142",
    naam: "Verst1ste ProvWest-vlaander",
    taal: "nl",
  },
  {
    id: "11781",
    stamnummer: "9145",
    naam: "VerstWestkust En Hinterland",
    taal: "nl",
  },
  {
    id: "11782",
    stamnummer: "9158",
    naam: "LimbVerstGewest Beringen",
    taal: "nl",
  },
  { id: "988", stamnummer: "9206", naam: "Ladies Oudenburg", taal: "" },
  { id: "1748", stamnummer: "9237", naam: "FC Antwerp Girls", taal: "" },
  { id: "996", stamnummer: "9265", naam: "Marsvlinders Kaulille", taal: "" },
  {
    id: "997",
    stamnummer: "9266",
    naam: "R Daring Club De Cointe-liege",
    taal: "",
  },
  { id: "999", stamnummer: "9271", naam: "Davo Puurs", taal: "" },
  { id: "1007", stamnummer: "9297", naam: "Leopold Club Ghlin", taal: "" },
  { id: "1758", stamnummer: "9302", naam: "Damesvoetbal Lot B", taal: "" },
  {
    id: "11812",
    stamnummer: "162",
    naam: "R Intercorporation Liegeoise",
    taal: "fr",
  },
  {
    id: "11815",
    stamnummer: "350",
    naam: "K W-vl Bedrijfssportbond",
    taal: "nl",
  },
  { id: "11816", stamnummer: "695", naam: "R.ent.caroloregienne", taal: "fr" },
  {
    id: "11817",
    stamnummer: "812",
    naam: "R. Ent.cl.mons/extens.",
    taal: "fr",
  },
  { id: "11818", stamnummer: "1010", naam: "Labvv", taal: "nl" },
  { id: "11819", stamnummer: "1163", naam: "R.ent.clubs Centre", taal: "fr" },
  {
    id: "11820",
    stamnummer: "1550",
    naam: "K. Sportverbond Doven Belgie",
    taal: "nl",
  },
  {
    id: "11821",
    stamnummer: "1564",
    naam: "KWestvlaamse Verstandhouding",
    taal: "nl",
  },
  {
    id: "11822",
    stamnummer: "1570",
    naam: "REntDes Clubs De WallPicard",
    taal: "fr",
  },
  { id: "11823", stamnummer: "1581", naam: "Ent.bxl.brab.foot.as", taal: "nl" },
  { id: "11824", stamnummer: "1773", naam: "K.s.o. Van Antwerpen", taal: "nl" },
  {
    id: "11825",
    stamnummer: "2097",
    naam: "K Limburgse Verstandhouding",
    taal: "nl",
  },
  { id: "11826", stamnummer: "2201", naam: "Royale A.b.s.s.a.", taal: "fr" },
  { id: "11827", stamnummer: "2487", naam: "Fed.sp. Police Belge", taal: "fr" },
  {
    id: "11828",
    stamnummer: "2810",
    naam: "Regio Noord-west Limburg",
    taal: "nl",
  },
  { id: "11829", stamnummer: "4007", naam: "Gr. Arb. Tournai-ath", taal: "fr" },
  {
    id: "11830",
    stamnummer: "4034",
    naam: "R. Am. Arb. Caroloreg.",
    taal: "fr",
  },
  { id: "11831", stamnummer: "4116", naam: "K.w.a.s.o.", taal: "nl" },
  {
    id: "11832",
    stamnummer: "4137",
    naam: "K.s.o. Lier En Omgeving",
    taal: "nl",
  },
  { id: "11833", stamnummer: "4339", naam: "K.mechelse Scheid.sv", taal: "nl" },
  {
    id: "11834",
    stamnummer: "4592",
    naam: "K Limburgse Bedrijfssportbond",
    taal: "nl",
  },
  {
    id: "11835",
    stamnummer: "4620",
    naam: "R Gr Namurois Foot Corp",
    taal: "fr",
  },
  { id: "11836", stamnummer: "4917", naam: "K. A.s.l.o.", taal: "nl" },
  { id: "11837", stamnummer: "5129", naam: "R.a.liegeoise Arb.", taal: "fr" },
  { id: "11838", stamnummer: "5277", naam: "LimbScheidBeringen", taal: "nl" },
  {
    id: "11839",
    stamnummer: "5321",
    naam: "K. Kemp. Sch. Westerlo",
    taal: "nl",
  },
  {
    id: "11840",
    stamnummer: "5340",
    naam: "K Scheidsrecht Gewest Mol",
    taal: "nl",
  },
  { id: "11841", stamnummer: "5413", naam: "K.v.s.g.g.", taal: "nl" },
  {
    id: "11842",
    stamnummer: "5435",
    naam: "K Kem Vr Sch Herentals",
    taal: "nl",
  },
  { id: "11843", stamnummer: "5445", naam: "U.r.s. Interbanques", taal: "fr" },
  {
    id: "11844",
    stamnummer: "5606",
    naam: "KV Sch Menen/omliggende",
    taal: "nl",
  },
  {
    id: "11845",
    stamnummer: "5731",
    naam: "Sp & Cult Soc La Poste F.c.",
    taal: "nl",
  },
  {
    id: "11846",
    stamnummer: "5810",
    naam: "Sportfederatie Belgacom",
    taal: "nl",
  },
  { id: "11847", stamnummer: "5936", naam: "B.u.s.f.", taal: "nl" },
  { id: "11848", stamnummer: "6299", naam: "Overeenk.wase Clubs", taal: "nl" },
  { id: "11849", stamnummer: "6312", naam: "ES Hesbaye-condroz", taal: "fr" },
  { id: "11850", stamnummer: "6314", naam: "Moev-schoolsport", taal: "nl" },
  {
    id: "11851",
    stamnummer: "6315",
    naam: "K Leuvens Scheidsrechtersv",
    taal: "nl",
  },
  {
    id: "11852",
    stamnummer: "6407",
    naam: "K. Vk Sch. Kortrijkse",
    taal: "nl",
  },
  {
    id: "11853",
    stamnummer: "6418",
    naam: "R Ent Sport Vervietoise",
    taal: "fr",
  },
  { id: "11854", stamnummer: "6419", naam: "K Vr Sch Demerstreek", taal: "nl" },
  {
    id: "11855",
    stamnummer: "6500",
    naam: "Amic. Des Arb. Centre",
    taal: "fr",
  },
  { id: "11856", stamnummer: "6505", naam: "Sch.ent.v.de Kust", taal: "nl" },
  {
    id: "11857",
    stamnummer: "6520",
    naam: "Scheidsr.verb.brab.kempen",
    taal: "nl",
  },
  {
    id: "11858",
    stamnummer: "6528",
    naam: "K.sch.ver. Geel/omstr.",
    taal: "nl",
  },
  {
    id: "11859",
    stamnummer: "6533",
    naam: "K.v.g.s. De Bremfluiters",
    taal: "nl",
  },
  { id: "11860", stamnummer: "6534", naam: "Sch.noordergouw Antw", taal: "nl" },
  {
    id: "11861",
    stamnummer: "6614",
    naam: "Houtlandse Verstandhouding",
    taal: "nl",
  },
  {
    id: "11862",
    stamnummer: "6622",
    naam: "VK Tiense Scheidsrechters",
    taal: "nl",
  },
  { id: "11863", stamnummer: "6703", naam: "N.v.l. - L.n.f.", taal: "nl" },
  {
    id: "11864",
    stamnummer: "6706",
    naam: "Regio Maas En Hoge Kempen",
    taal: "nl",
  },
  {
    id: "11865",
    stamnummer: "6740",
    naam: "Liga Amateurvoetbal Antwerpen",
    taal: "nl",
  },
  {
    id: "11866",
    stamnummer: "6780",
    naam: "Ent Clubs 1ste Prov O/vl",
    taal: "nl",
  },
  {
    id: "11867",
    stamnummer: "6785",
    naam: "Lig. Promotions/bevorderingen",
    taal: "nl",
  },
  {
    id: "11868",
    stamnummer: "6789",
    naam: "Liga Tweede Klasse Voetbal Vlaanderen",
    taal: "nl",
  },
  {
    id: "11869",
    stamnummer: "6793",
    naam: "KZuidlimbScheidsrechtersv",
    taal: "nl",
  },
  {
    id: "11870",
    stamnummer: "6871",
    naam: "Liga Amateurvb W-vlaanderen",
    taal: "nl",
  },
  { id: "11871", stamnummer: "6881", naam: "Meerhoutse Verstand.", taal: "nl" },
  { id: "11872", stamnummer: "7001", naam: "Ass Arb Brab.wallon", taal: "fr" },
  {
    id: "11873",
    stamnummer: "7007",
    naam: "K. Limb Sch.ov.gew.bree",
    taal: "nl",
  },
  { id: "11874", stamnummer: "7297", naam: "Gew. Midden Limburg", taal: "nl" },
  {
    id: "11875",
    stamnummer: "7438",
    naam: "Vk Scheids Hasselt-stTruiden",
    taal: "nl",
  },
  {
    id: "11876",
    stamnummer: "7546",
    naam: "KVK Sch Oudenaarde-ronse",
    taal: "nl",
  },
  {
    id: "11877",
    stamnummer: "7563",
    naam: "Prov. Studiecomm Oost-vl",
    taal: "nl",
  },
  { id: "11878", stamnummer: "7590", naam: "Sch.v.prov Antwerpen", taal: "nl" },
  { id: "11879", stamnummer: "7754", naam: "Ent. Du Sud-namur", taal: "fr" },
  { id: "11880", stamnummer: "7905", naam: "Noord.sch.g.neerpelt", taal: "nl" },
  {
    id: "11881",
    stamnummer: "7929",
    naam: "GewVerst Clubs Denderstreek",
    taal: "nl",
  },
  {
    id: "11882",
    stamnummer: "7987",
    naam: "Regio Zuid-west Limburg",
    taal: "nl",
  },
  {
    id: "11883",
    stamnummer: "8046",
    naam: "K Vr Brugse Scheidsrechters",
    taal: "nl",
  },
  {
    id: "11884",
    stamnummer: "8069",
    naam: "ENamNord-est Basse-sambre",
    taal: "fr",
  },
  {
    id: "11885",
    stamnummer: "8076",
    naam: "V.v.c.brugse Oostkust",
    taal: "nl",
  },
  { id: "11886", stamnummer: "8081", naam: "Ent Prov.cl. Luxemb", taal: "fr" },
  { id: "11887", stamnummer: "8093", naam: "Verb Sch. Oost-vl.", taal: "nl" },
  {
    id: "11888",
    stamnummer: "8230",
    naam: "KVK Sch Gistel/omliggende",
    taal: "nl",
  },
  {
    id: "11889",
    stamnummer: "8246",
    naam: "Sch.krg.noord-west Bt",
    taal: "nl",
  },
  {
    id: "11890",
    stamnummer: "8247",
    naam: "VK Sch Tielt/omliggende",
    taal: "nl",
  },
  {
    id: "11891",
    stamnummer: "8389",
    naam: "VK Sch Roeselare/izegem",
    taal: "nl",
  },
  {
    id: "11892",
    stamnummer: "8392",
    naam: "VK Sch Diksmuide-veurne",
    taal: "nl",
  },
  {
    id: "11893",
    stamnummer: "8400",
    naam: "V.k. Sch. Heist O/d Berg",
    taal: "nl",
  },
  { id: "11894", stamnummer: "8413", naam: "ProvLi Am V (fv)", taal: "nl" },
  {
    id: "11895",
    stamnummer: "8500",
    naam: "Belgian Football Coaches",
    taal: "nl",
  },
  {
    id: "11896",
    stamnummer: "8502",
    naam: "Liga Vr V-ligue F Fem",
    taal: "nl",
  },
  { id: "11897", stamnummer: "8506", naam: "G.a.f.o.a.", taal: "fr" },
  { id: "11898", stamnummer: "8507", naam: "Evergemse Verstandh.", taal: "nl" },
  { id: "11899", stamnummer: "8509", naam: "Deinzese Verstandh.", taal: "nl" },
  { id: "11900", stamnummer: "8562", naam: "Ass.arb.grande Gette", taal: "fr" },
  {
    id: "11901",
    stamnummer: "8587",
    naam: "Group Des Arbitres De Chimay",
    taal: "fr",
  },
  {
    id: "11902",
    stamnummer: "8593",
    naam: "Ent. Famenne Cl.foot.",
    taal: "fr",
  },
  { id: "11903", stamnummer: "8818", naam: "V.l.a.n.o.b.", taal: "nl" },
  { id: "11904", stamnummer: "8819", naam: "L.c.f.b.w.", taal: "fr" },
  {
    id: "11905",
    stamnummer: "8867",
    naam: "Verst.clubs 2 Pr. Ovl",
    taal: "nl",
  },
  {
    id: "11906",
    stamnummer: "8881",
    naam: "Beringse Verstandhouding",
    taal: "nl",
  },
  {
    id: "11907",
    stamnummer: "8922",
    naam: "Scheidsrechters Pajottenland",
    taal: "nl",
  },
  {
    id: "11908",
    stamnummer: "8937",
    naam: "Regio Zuid-oost Limburg",
    taal: "nl",
  },
  {
    id: "11909",
    stamnummer: "8965",
    naam: "Ass.prov.arb.du Hainaut",
    taal: "fr",
  },
  { id: "1734", stamnummer: "8978", naam: "Etoile Taminoise", taal: "" },
  { id: "374", stamnummer: "2917", naam: "RJS Cheneenne", taal: "" },
  { id: "1009", stamnummer: "9306", naam: "FC Ekeren", taal: "" },
  { id: "1010", stamnummer: "9307", naam: "Vc Wilrijk", taal: "" },
  { id: "10988", stamnummer: "9308", naam: "ASE De Chastre", taal: "" },
  {
    id: "11947",
    stamnummer: "99999",
    naam: "Clubs Inexistants Prairie",
    taal: "fr",
  },
  {
    id: "11949",
    stamnummer: "9996",
    naam: "Fonds Promotion Jeunes",
    taal: "fr",
  },
  { id: "11237", stamnummer: "9312", naam: "V.v. Gelrode", taal: "" },
  { id: "1011", stamnummer: "9314", naam: "Sp Espoir Jemeppe", taal: "" },
  { id: "1012", stamnummer: "9317", naam: "Ladies Oudenaarde", taal: "" },
  { id: "1013", stamnummer: "9318", naam: "FC Velzeke", taal: "" },
  { id: "1760", stamnummer: "9321", naam: "Tongeren DV", taal: "" },
  { id: "11958", stamnummer: "5211", naam: "Entente Du Sud", taal: "fr" },
  { id: "1761", stamnummer: "9322", naam: "E.S.J. Alken", taal: "" },
  {
    id: "1762",
    stamnummer: "9323",
    naam: "JS Meslin - Grand Marais",
    taal: "",
  },
  { id: "1015", stamnummer: "9330", naam: "Cerkelladies Brugge", taal: "" },
  {
    id: "1016",
    stamnummer: "9332",
    naam: "Stade Everois Racing Club",
    taal: "",
  },
  { id: "1765", stamnummer: "9335", naam: "SC Oneutois", taal: "" },
  { id: "1764", stamnummer: "9328", naam: "VC Poederlee", taal: "" },
  { id: "1018", stamnummer: "9339", naam: "JS Eghezee", taal: "" },
  {
    id: "11963",
    stamnummer: "5232",
    naam: "NWM Brabantse Verstandh",
    taal: "nl",
  },
  {
    id: "11966",
    stamnummer: "5263",
    naam: "A.c.f. Communaute Fr Et Germ",
    taal: "fr",
  },
  { id: "1019", stamnummer: "9341", naam: "SK.Kampelaar", taal: "" },
  { id: "1022", stamnummer: "9346", naam: "FC Avrasya Gent", taal: "" },
  { id: "1766", stamnummer: "9350", naam: "Standaard Muide Gent", taal: "" },
  { id: "10998", stamnummer: "9352", naam: "Sporting Kortenberg", taal: "" },
  {
    id: "1024",
    stamnummer: "9356",
    naam: "All Fexhe Et Slins - Fragnee",
    taal: "",
  },
  {
    id: "11974",
    stamnummer: "5285",
    naam: "Ent Clubs Bxl Et Peripherie",
    taal: "fr",
  },
  { id: "1770", stamnummer: "9360", naam: "Club Roeselare", taal: "" },
  { id: "1771", stamnummer: "9361", naam: "FC.Merchtem 2000", taal: "" },
  {
    id: "1768",
    stamnummer: "9358",
    naam: "FC Femina White Star Woluwe",
    taal: "",
  },
  { id: "1772", stamnummer: "9362", naam: "SVH Waasmunster", taal: "" },
  { id: "1773", stamnummer: "9363", naam: "ES Jamboise", taal: "" },
  { id: "1774", stamnummer: "9364", naam: "VC Herentals", taal: "" },
  { id: "1026", stamnummer: "9369", naam: "Racing ACS Couillet", taal: "" },
  { id: "1775", stamnummer: "9371", naam: "CS Feminin Auvelais", taal: "" },
  { id: "1028", stamnummer: "9376", naam: "VK Wikings Kortrijk", taal: "" },
  { id: "1777", stamnummer: "9377", naam: "Atlas Linter", taal: "" },
  { id: "1776", stamnummer: "9373", naam: "FC Gierle", taal: "" },
  {
    id: "1027",
    stamnummer: "9375",
    naam: "Jong Rita Lyra-lierse Berlaar",
    taal: "",
  },
  { id: "1778", stamnummer: "9379", naam: "Ellas Herstal", taal: "" },
  { id: "1029", stamnummer: "9380", naam: "Heidebloem Dilsen VV", taal: "" },
  { id: "1030", stamnummer: "9382", naam: "JVV Sint-andries", taal: "" },
  { id: "1779", stamnummer: "9384", naam: "FC Olympic Namur", taal: "" },
  { id: "1780", stamnummer: "9385", naam: "Jong Vijve", taal: "" },
  { id: "1031", stamnummer: "9386", naam: "FC Flenu", taal: "" },
  { id: "1781", stamnummer: "9388", naam: "SK Torhout", taal: "" },
  {
    id: "1783",
    stamnummer: "9390",
    naam: "La Louviere Centre Femina",
    taal: "",
  },
  { id: "1033", stamnummer: "9392", naam: "FC Havre", taal: "" },
  {
    id: "1784",
    stamnummer: "9393",
    naam: "Femina Sporting De Charleroi",
    taal: "",
  },
  { id: "1035", stamnummer: "9396", naam: "Eendracht Hekelgem", taal: "" },
  { id: "1786", stamnummer: "9398", naam: "FC Oxford Hemiksem", taal: "" },
  { id: "1785", stamnummer: "9397", naam: "VC Mortsel OG", taal: "" },
  {
    id: "12924",
    stamnummer: "9400",
    naam: "FC Jeunesse Molenbeek",
    taal: "fr",
  },
  { id: "1036", stamnummer: "9401", naam: "Rangers Opdorp", taal: "" },
  { id: "1782", stamnummer: "9389", naam: "JS Bois-de-villers", taal: "" },
  { id: "1207", stamnummer: "9394", naam: "FC Saint-josse", taal: "" },
  { id: "1788", stamnummer: "9404", naam: "MCS Sport Liege", taal: "" },
  { id: "1789", stamnummer: "9406", naam: "Jong Zulte", taal: "" },
  { id: "1037", stamnummer: "9408", naam: "Fosses A", taal: "" },
  { id: "1039", stamnummer: "9410", naam: "Stade Disonais", taal: "" },
  { id: "1040", stamnummer: "9411", naam: "Sporting Winterslag", taal: "" },
  { id: "1041", stamnummer: "9413", naam: "FC Suryoyes Bruxellois", taal: "" },
  { id: "1790", stamnummer: "9415", naam: "SK Denderhoutem", taal: "" },
  { id: "1043", stamnummer: "9419", naam: "Fc Gerda Sint-niklaas", taal: "" },
  { id: "1791", stamnummer: "9423", naam: "Voetbalclub Moldavo", taal: "" },
  { id: "1045", stamnummer: "9425", naam: "USF Montroeul-dergneau", taal: "" },
  { id: "1792", stamnummer: "9426", naam: "Solieres Sport", taal: "" },
  { id: "1046", stamnummer: "9428", naam: "Verbr Zwijndrecht", taal: "" },
  { id: "1047", stamnummer: "9433", naam: "SK Zandbergen", taal: "" },
  { id: "1794", stamnummer: "9438", naam: "WK Sint-goriks", taal: "" },
  { id: "1048", stamnummer: "9439", naam: "FC Anderlecht-milan", taal: "" },
  { id: "1795", stamnummer: "9441", naam: "OMS Ingelmunster", taal: "" },
  {
    id: "1793",
    stamnummer: "9434",
    naam: "Grupo Desportivo Poulseur",
    taal: "",
  },
  { id: "1796", stamnummer: "9442", naam: "VC Heuvelland", taal: "" },
  {
    id: "1798",
    stamnummer: "9447",
    naam: "VC.Dames Eendracht Aalst",
    taal: "nl",
  },
  { id: "1800", stamnummer: "9456", naam: "Leest United", taal: "" },
  { id: "1050", stamnummer: "9452", naam: "SC Montignies", taal: "" },
  { id: "1801", stamnummer: "9457", naam: "VK Jong Neigem", taal: "" },
  { id: "1051", stamnummer: "9463", naam: "FC Binkom", taal: "" },
  { id: "1802", stamnummer: "9465", naam: "Sporting Burcht FC", taal: "" },
  { id: "1803", stamnummer: "9466", naam: "Rac Voetbalclub Hoboken", taal: "" },
  { id: "10992", stamnummer: "9467", naam: "VK Liedekerke", taal: "" },
  { id: "1052", stamnummer: "9469", naam: "FC Jupille", taal: "" },
  { id: "1808", stamnummer: "9472", naam: "FC Moreda Uccle", taal: "" },
  { id: "1053", stamnummer: "9471", naam: "VS Destelbergen", taal: "" },
  { id: "1806", stamnummer: "9470", naam: "Sna Keiberg", taal: "" },
  { id: "1054", stamnummer: "9474", naam: "Union Sportive Walcourt", taal: "" },
  {
    id: "11238",
    stamnummer: "9476",
    naam: "F.c. Eendracht Onkerzele",
    taal: "",
  },
  { id: "11239", stamnummer: "9477", naam: "Sk Ooidonck Leerne", taal: "" },
  { id: "1810", stamnummer: "9478", naam: "Football Club Cheratte", taal: "" },
  { id: "1056", stamnummer: "9482", naam: "SK.Landskouter", taal: "" },
  { id: "1815", stamnummer: "9485", naam: "JV Lo-reninge", taal: "" },
  { id: "1813", stamnummer: "9483", naam: "SK Heusden 06", taal: "" },
  { id: "1816", stamnummer: "9486", naam: "FCE Kuurne", taal: "" },
  { id: "1817", stamnummer: "9487", naam: "FC United Richelle", taal: "" },
  { id: "1058", stamnummer: "9490", naam: "FC Harchies-bernissart", taal: "" },
  { id: "1821", stamnummer: "9494", naam: "FC Herderen-millen", taal: "" },
  { id: "1822", stamnummer: "9498", naam: "Voetbal Club Boekhoute", taal: "" },
  { id: "1823", stamnummer: "9499", naam: "Kfc Schoonbroek", taal: "" },
  { id: "1824", stamnummer: "9500", naam: "F.c. Mont De L'enclus", taal: "" },
  { id: "1059", stamnummer: "9501", naam: "FC.Borght", taal: "" },
  { id: "1826", stamnummer: "9502", naam: "Membruggen V&v", taal: "" },
  { id: "1828", stamnummer: "9504", naam: "Sporting Club Aarschot", taal: "" },
  { id: "1829", stamnummer: "9506", naam: "DV Kortrijk", taal: "" },
  { id: "11240", stamnummer: "9507", naam: "F.c. Peronnes", taal: "" },
  { id: "1830", stamnummer: "9508", naam: "VKS Hamme-zogge", taal: "" },
  { id: "1060", stamnummer: "9509", naam: "FC Torgny-rouvroy", taal: "" },
  { id: "1832", stamnummer: "9510", naam: "Football Club Bercheux", taal: "" },
  {
    id: "1833",
    stamnummer: "9511",
    naam: "Dames Football Club Ternat",
    taal: "",
  },
  {
    id: "1834",
    stamnummer: "9512",
    naam: "Football Club Gullegem",
    taal: "nl",
  },
  { id: "1835", stamnummer: "9513", naam: "Football Club Pieton", taal: "" },
  { id: "1836", stamnummer: "9514", naam: "FC Bosdam Beveren", taal: "" },
  { id: "1837", stamnummer: "9516", naam: "FC Geetbets", taal: "" },
  { id: "1838", stamnummer: "9517", naam: "Milanello Herstal", taal: "" },
  { id: "1839", stamnummer: "9518", naam: "VK Duffel", taal: "" },
  { id: "11241", stamnummer: "9521", naam: "A.s. Docherie", taal: "" },
  {
    id: "1840",
    stamnummer: "9522",
    naam: "Racing Club Vaux-chaudfontaine",
    taal: "",
  },
  { id: "12060", stamnummer: "5521", naam: "Cref", taal: "fr" },
  { id: "12062", stamnummer: "5000", naam: "Voetbal Vlaanderen", taal: "nl" },
  {
    id: "1841",
    stamnummer: "9524",
    naam: "Herleving Red Star Haasdonk",
    taal: "",
  },
  { id: "1842", stamnummer: "9526", naam: "Davo Torhout", taal: "" },
  { id: "1843", stamnummer: "9527", naam: "DVC Eva'S Tienen", taal: "nl" },
  {
    id: "1844",
    stamnummer: "9530",
    naam: "Zwarte Duivels Westmeerbeek",
    taal: "",
  },
  { id: "1845", stamnummer: "9531", naam: "Club Olympic Trivieres", taal: "" },
  { id: "1846", stamnummer: "9532", naam: "Damesvoetbal Leffinge", taal: "" },
  { id: "12925", stamnummer: "9535", naam: "FC Musson", taal: "fr" },
  { id: "1850", stamnummer: "9537", naam: "AS Fontainoise", taal: "" },
  { id: "1851", stamnummer: "9538", naam: "FC Bressoux", taal: "" },
  { id: "1852", stamnummer: "9539", naam: "Inter Barry", taal: "" },
  { id: "1853", stamnummer: "9540", naam: "Peruwelz Football Club", taal: "" },
  { id: "11242", stamnummer: "9542", naam: "Fc Wodecq", taal: "" },
  { id: "1854", stamnummer: "9543", naam: "Maccabi Brussels", taal: "" },
  { id: "1855", stamnummer: "9544", naam: "Foot Seraing Chatqueue", taal: "" },
  { id: "1856", stamnummer: "9546", naam: "Nielse SV", taal: "" },
  { id: "1857", stamnummer: "9547", naam: "RFC Barchon", taal: "" },
  {
    id: "1859",
    stamnummer: "9549",
    naam: "Racing Jeunesse Arlonaise",
    taal: "",
  },
  { id: "12083", stamnummer: "9553", naam: "Cosmos Laeken", taal: "fr" },
  {
    id: "1861",
    stamnummer: "9554",
    naam: "Renouveau Us Tournaisienne",
    taal: "",
  },
  { id: "11243", stamnummer: "9555", naam: "Athenes Sport Ressaix", taal: "" },
  { id: "1863", stamnummer: "9558", naam: "Afccm Braine Waterloo", taal: "" },
  { id: "1864", stamnummer: "9559", naam: "VK Berg-op", taal: "" },
  { id: "11244", stamnummer: "9560", naam: "Fc St. Jean Tournai", taal: "" },
  { id: "1865", stamnummer: "9561", naam: "Fc Sint-niklaas", taal: "" },
  { id: "1866", stamnummer: "9562", naam: "VK.Mechelsbroek", taal: "" },
  { id: "1869", stamnummer: "9565", naam: "Ertvelde United", taal: "" },
  {
    id: "1870",
    stamnummer: "9566",
    naam: "Red Star Ladies Denderhoutem",
    taal: "",
  },
  { id: "1871", stamnummer: "9567", naam: "Blauberg Sport", taal: "" },
  { id: "1873", stamnummer: "9570", naam: "Olympic Clabecq", taal: "" },
  { id: "1874", stamnummer: "9572", naam: "Kessel United", taal: "" },
  { id: "1875", stamnummer: "9573", naam: "FC Rosselaar Hulsen", taal: "" },
  {
    id: "1876",
    stamnummer: "9574",
    naam: "Willebroekse Sportvereniging",
    taal: "",
  },
  { id: "1878", stamnummer: "9576", naam: "FC Turkuaz Antwerpen", taal: "" },
  { id: "1879", stamnummer: "9577", naam: "Supporterskring Beveren", taal: "" },
  { id: "1880", stamnummer: "9578", naam: "Yildiz Gent", taal: "" },
  { id: "11245", stamnummer: "9579", naam: "Racing Club Marcinelle", taal: "" },
  { id: "1882", stamnummer: "9581", naam: "Sporting Calcio Genk", taal: "" },
  { id: "1884", stamnummer: "9584", naam: "FC Lesve-arbre", taal: "" },
  { id: "1886", stamnummer: "9586", naam: "Juventus Academy Shape", taal: "" },
  { id: "12124", stamnummer: "5540", naam: "Ga Condroz-hesbaye", taal: "fr" },
  { id: "1887", stamnummer: "9587", naam: "U.S. Neuville", taal: "" },
  { id: "1889", stamnummer: "9589", naam: "D Fufo-beringen", taal: "" },
  { id: "11246", stamnummer: "9590", naam: "RAJS Honnelloise", taal: "" },
  { id: "11247", stamnummer: "9591", naam: "F.c. Bouffioulx", taal: "" },
  { id: "12125", stamnummer: "5554", naam: "Players4contract", taal: "nl" },
  {
    id: "1890",
    stamnummer: "9592",
    naam: "Union Sporting Club Jemappes",
    taal: "",
  },
  { id: "12145", stamnummer: "5100", naam: "ACFF", taal: "fr" },
  {
    id: "11248",
    stamnummer: "9596",
    naam: "Nieuw Sterk Vlug Dapp Handzame",
    taal: "",
  },
  { id: "11249", stamnummer: "9597", naam: "Fc Racing Boxberg", taal: "" },
  { id: "11250", stamnummer: "9598", naam: "Fc Genc Turk Gent", taal: "" },
  { id: "11251", stamnummer: "9599", naam: "Aic Sports Grivegnee", taal: "" },
  { id: "11252", stamnummer: "9600", naam: "Jsn Alleur", taal: "" },
  { id: "11253", stamnummer: "9603", naam: "Etoile Vervietoise", taal: "" },
  { id: "11024", stamnummer: "9604", naam: "As Brussels City", taal: "" },
  { id: "11254", stamnummer: "9605", naam: "F.c. Enghiennois", taal: "" },
  { id: "11255", stamnummer: "9606", naam: "JS Aiseau-presles", taal: "" },
  { id: "11256", stamnummer: "9607", naam: "F.c. Colfontaine", taal: "" },
  { id: "11257", stamnummer: "9608", naam: "Jong Antwerpen Sport", taal: "" },
  { id: "11258", stamnummer: "9609", naam: "F.c. Achene", taal: "" },
  {
    id: "11259",
    stamnummer: "9610",
    naam: "R. Club Sportif Fragnee",
    taal: "",
  },
  { id: "11260", stamnummer: "9611", naam: "As Emul Liege", taal: "" },
  { id: "11261", stamnummer: "9612", naam: "RWD Molenbeek Girls", taal: "" },
  { id: "11262", stamnummer: "9613", naam: "F.c. Veldwezelt", taal: "" },
  {
    id: "11263",
    stamnummer: "9615",
    naam: "Project Dynamisch Kruibeke",
    taal: "",
  },
  { id: "11264", stamnummer: "9616", naam: "SA Juve Mollem Vw", taal: "" },
  { id: "11265", stamnummer: "9617", naam: "Infinity Fc Vilvoorde", taal: "" },
  { id: "11266", stamnummer: "9618", naam: "Sparta Schaffen", taal: "" },
  { id: "11267", stamnummer: "9619", naam: "F.c.l.c. Ronse", taal: "" },
  { id: "11268", stamnummer: "9620", naam: "US Grace-hollogne", taal: "" },
  { id: "11269", stamnummer: "9621", naam: "Vk Sjoeters Opwijk", taal: "" },
  {
    id: "11270",
    stamnummer: "9622",
    naam: "Academie Jeunesse Molenbeek",
    taal: "",
  },
  { id: "11271", stamnummer: "9623", naam: "Eskavee Zwevezele", taal: "" },
  { id: "11272", stamnummer: "9624", naam: "Vkw Vleteren", taal: "" },
  { id: "11273", stamnummer: "9626", naam: "E.s. Bleid", taal: "" },
  { id: "11274", stamnummer: "9625", naam: "Nseth Berchem", taal: "" },
  {
    id: "11275",
    stamnummer: "9627",
    naam: "Renaissance Sp Forestoise",
    taal: "",
  },
  { id: "11276", stamnummer: "9628", naam: "C.s. Juprelle", taal: "" },
  { id: "11277", stamnummer: "9629", naam: "Sparta Lombeek", taal: "" },
  { id: "11278", stamnummer: "9631", naam: "Anderlecht Scb", taal: "" },
  {
    id: "11279",
    stamnummer: "9632",
    naam: "Olympique Club Forestois",
    taal: "",
  },
  { id: "11280", stamnummer: "9633", naam: "Fusion Oostende", taal: "" },
  {
    id: "11281",
    stamnummer: "9634",
    naam: "U. Africa F.c. Bruxelles",
    taal: "",
  },
  { id: "11282", stamnummer: "9635", naam: "F.c. Houtaing", taal: "" },
  { id: "11283", stamnummer: "9636", naam: "Jago Sint-amandsberg", taal: "" },
  { id: "11284", stamnummer: "9637", naam: "Woluwe F.c.", taal: "" },
  {
    id: "11285",
    stamnummer: "9638",
    naam: "Racing Ans Montegnee F.c.",
    taal: "",
  },
  {
    id: "11286",
    stamnummer: "9639",
    naam: "Antwerp Piranhas Academy",
    taal: "",
  },
  { id: "11287", stamnummer: "9640", naam: "Fc Irlande Auderghem", taal: "" },
  { id: "11288", stamnummer: "9641", naam: "St. Pholien Lg", taal: "" },
  { id: "11289", stamnummer: "9642", naam: "F.c. Fontinois", taal: "" },
  { id: "11290", stamnummer: "9643", naam: "F.c. Berloz", taal: "" },
  {
    id: "12210",
    stamnummer: "9645",
    naam: "Gewest Schelde & Leie",
    taal: "nl",
  },
  { id: "11291", stamnummer: "9644", naam: "Olympique Romsee", taal: "" },
  {
    id: "11292",
    stamnummer: "9646",
    naam: "Juventus Academy Grivegnee",
    taal: "",
  },
  { id: "11293", stamnummer: "9647", naam: "Fc Polonia Boitsfort", taal: "" },
  { id: "11294", stamnummer: "9648", naam: "D.v. Bilzen United", taal: "" },
  { id: "11295", stamnummer: "9649", naam: "A.o.c. Buston", taal: "" },
  {
    id: "11296",
    stamnummer: "9650",
    naam: "Vk Langemark-poelkapelle",
    taal: "",
  },
  { id: "11297", stamnummer: "9651", naam: "Brussels Sport Afca", taal: "" },
  {
    id: "11298",
    stamnummer: "9652",
    naam: "Athletic Cl Quaregnon-wasmuel",
    taal: "",
  },
  { id: "11299", stamnummer: "9653", naam: "F.c. Ronvau Chaumont", taal: "" },
  { id: "11300", stamnummer: "9654", naam: "St. Guidon Anderlecht", taal: "" },
  { id: "11301", stamnummer: "9656", naam: "Entente Chapelloise", taal: "" },
  {
    id: "12226",
    stamnummer: "9655",
    naam: "Bel Beringen Fenerb Dernegi",
    taal: "nl",
  },
  { id: "11209", stamnummer: "9657", naam: "AS Verviers", taal: "" },
  { id: "11302", stamnummer: "9658", naam: "S.v. Wondelgem", taal: "" },
  {
    id: "12231",
    stamnummer: "5596",
    naam: "Overleg Orgaan Voetbal Vlaanderen",
    taal: "nl",
  },
  { id: "12335", stamnummer: "9659", naam: "Alberta Fc Schilde", taal: "nl" },
  { id: "12329", stamnummer: "9660", naam: "S.k. Plenke Werchter", taal: "nl" },
  { id: "12331", stamnummer: "9661", naam: "F.c. Dampoort Gent", taal: "nl" },
  { id: "12332", stamnummer: "9662", naam: "Fc Rooigem", taal: "nl" },
  { id: "12330", stamnummer: "9663", naam: "Jong Helkijn", taal: "nl" },
  { id: "12333", stamnummer: "9664", naam: "V.v. 9000 Gent", taal: "nl" },
  { id: "12326", stamnummer: "9665", naam: "Brussels United Fc", taal: "nl" },
  {
    id: "12336",
    stamnummer: "9666",
    naam: "Ascades Renaissance Evere",
    taal: "fr",
  },
  {
    id: "12334",
    stamnummer: "9667",
    naam: "Brussels Fire St-gilles",
    taal: "fr",
  },
  {
    id: "12338",
    stamnummer: "9668",
    naam: "Anneessens 25 Brussels",
    taal: "fr",
  },
  {
    id: "12339",
    stamnummer: "9669",
    naam: "Vilvoorde-diegem United",
    taal: "nl",
  },
  { id: "12337", stamnummer: "9670", naam: "Vilvoorde City", taal: "nl" },
  { id: "12340", stamnummer: "9671", naam: "Vise Bmfa", taal: "fr" },
  { id: "12364", stamnummer: "9672", naam: "Oranje Blauw Lebbeke", taal: "nl" },
  { id: "12365", stamnummer: "9673", naam: "Bufc Ladies Brussels", taal: "nl" },
  {
    id: "13655",
    stamnummer: "9674",
    naam: "Vc Den Boskant Peizegem",
    taal: "nl",
  },
  { id: "14015", stamnummer: "9675", naam: "Jong Sg Dendermonde", taal: "nl" },
  { id: "14033", stamnummer: "9676", naam: "As Montigny", taal: "fr" },
  {
    id: "14034",
    stamnummer: "9677",
    naam: "Celtic Denee Football",
    taal: "fr",
  },
  { id: "14035", stamnummer: "9678", naam: "Sportkring Kemzeke", taal: "nl" },
  { id: "14036", stamnummer: "9679", naam: "Rfc Syriana Deurne", taal: "nl" },
  {
    id: "14048",
    stamnummer: "9680",
    naam: "Fc Kortenberg Meerbeek United",
    taal: "nl",
  },
  {
    id: "14049",
    stamnummer: "9681",
    naam: "Football Academie D'engis",
    taal: "fr",
  },
  { id: "14050", stamnummer: "9682", naam: "Fc Rangers Merelbeke", taal: "nl" },
  { id: "14051", stamnummer: "9683", naam: "Fc Elephant Barry", taal: "fr" },
  {
    id: "14052",
    stamnummer: "9684",
    naam: "Jeunesse Sportive Liegeoise",
    taal: "fr",
  },
  { id: "14053", stamnummer: "9685", naam: "Fc Amicii Bxl Jette", taal: "fr" },
  { id: "14054", stamnummer: "9686", naam: "Efa Manhay", taal: "fr" },
  { id: "14056", stamnummer: "9687", naam: "ASA Molenbeek", taal: "fr" },
  {
    id: "14059",
    stamnummer: "9688",
    naam: "Vk Poreistampers Asse",
    taal: "nl",
  },
  { id: "14060", stamnummer: "9689", naam: "Fc Flaches", taal: "fr" },
  {
    id: "14065",
    stamnummer: "9690",
    naam: "Fc Marolles Bruxelles",
    taal: "fr",
  },
  {
    id: "14066",
    stamnummer: "9691",
    naam: "Divas Vooruit Denderhoutem",
    taal: "nl",
  },
  { id: "14067", stamnummer: "9692", naam: "Fc Antwerp Talents", taal: "nl" },
  {
    id: "14068",
    stamnummer: "9693",
    naam: "Fc Warriors Antwerpen",
    taal: "nl",
  },
  { id: "14110", stamnummer: "9694", naam: "Wapper Antwerpen", taal: "nl" },
  { id: "14111", stamnummer: "9695", naam: "Sportkring Aalst", taal: "nl" },
  {
    id: "18443",
    stamnummer: "9696",
    naam: "Fc Los Incas Antwerpen",
    taal: "nl",
  },
  { id: "224", stamnummer: "544", naam: "SC City Pirates Antwerpen", taal: "" },
  {
    id: "22844",
    stamnummer: "9697",
    naam: "U.s. Quievrainoise 70",
    taal: "fr",
  },
  { id: "23361", stamnummer: "9698", naam: "Fc Borina Quaregnon", taal: "fr" },
  {
    id: "29060",
    stamnummer: "9699",
    naam: "Skill Racing Union Verviers",
    taal: "fr",
  },
  { id: "29069", stamnummer: "9700", naam: "Vk Velle", taal: "nl" },
  {
    id: "29071",
    stamnummer: "9701",
    naam: "Vc Jekervallei Sluizen",
    taal: "nl",
  },
  { id: "29075", stamnummer: "9702", naam: "La Squadra Mouscron.", taal: "fr" },
  {
    id: "30777",
    stamnummer: "9703",
    naam: "Entente Jeunesse Fleron",
    taal: "fr",
  },
  {
    id: "30780",
    stamnummer: "9704",
    naam: "Fc Suraye United Mechelen",
    taal: "nl",
  },
  { id: "30781", stamnummer: "9705", naam: "Athletico Antwerpen", taal: "nl" },
  { id: "30845", stamnummer: "9706", naam: "Kalfort Puursica", taal: "nl" },
  { id: "30849", stamnummer: "66932", naam: "F.c. Cimbom", taal: "nl" },
  { id: "37", stamnummer: "6142", naam: "Oud-heverlee Leuven", taal: "nl" },
  { id: "30857", stamnummer: "66935", naam: "Union Malinese", taal: "nl" },
  { id: "30858", stamnummer: "66936", naam: "Genclerbirligi", taal: "nl" },
  {
    id: "30861",
    stamnummer: "9708",
    naam: "Fc Sainte-odile Elouges",
    taal: "fr",
  },
  { id: "30862", stamnummer: "9707", naam: "Fc Synergy Bruxelles", taal: "fr" },
  { id: "30863", stamnummer: "9709", naam: "G-sport Vorselaar", taal: "nl" },
  { id: "30865", stamnummer: "89938", naam: "Dwaasland-beveren", taal: "fr" },
  { id: "30866", stamnummer: "66934", naam: "F.c. Balkan", taal: "nl" },
  { id: "30869", stamnummer: "66937", naam: "Ultras Brussel", taal: "nl" },
  { id: "30870", stamnummer: "9710", naam: "Fc Antwerpen Noord", taal: "nl" },
  { id: "30871", stamnummer: "66938", naam: "Wit-rood Antwerpen", taal: "nl" },
  { id: "30873", stamnummer: "66939", naam: "Ata Spor", taal: "nl" },
  { id: "30874", stamnummer: "66933", naam: "F.c. Drakenhof", taal: "nl" },
  { id: "30877", stamnummer: "18", naam: "K. Stade Leuven", taal: "nl" },
  {
    id: "30878",
    stamnummer: "9711",
    naam: "Fc Inter United Maasmechelen",
    taal: "nl",
  },
  {
    id: "30879",
    stamnummer: "9712",
    naam: "Galatasaray Antwerpen",
    taal: "nl",
  },
  { id: "30880", stamnummer: "89939", naam: "Brantsandpatents", taal: "nl" },
  { id: "30882", stamnummer: "42449", naam: "Fc Varenwinkel", taal: "nl" },
  { id: "30883", stamnummer: "89940", naam: "Fc Den Uitgang", taal: "nl" },
  { id: "30884", stamnummer: "89941", naam: "Heusden United", taal: "fr" },
  {
    id: "30885",
    stamnummer: "89942",
    naam: "Franky Shotters Tielt",
    taal: "nl",
  },
  { id: "31045", stamnummer: "89943", naam: "Mvc Get Driven", taal: "nl" },
  { id: "31053", stamnummer: "89944", naam: "Mvc Sans Doute", taal: "nl" },
  { id: "31054", stamnummer: "89945", naam: "Los Pendejos", taal: "nl" },
  { id: "31056", stamnummer: "89946", naam: "Uustakker City", taal: "nl" },
  { id: "31057", stamnummer: "89947", naam: "Veezet 2", taal: "nl" },
  { id: "31058", stamnummer: "89948", naam: "Fc De Lesten", taal: "nl" },
  { id: "31059", stamnummer: "89949", naam: "'t Sloeberke", taal: "nl" },
  {
    id: "31060",
    stamnummer: "89950",
    naam: "De Voetballende Goden",
    taal: "nl",
  },
  { id: "31061", stamnummer: "89951", naam: "Mvc Bouncy King", taal: "nl" },
  { id: "31062", stamnummer: "89952", naam: "Mvc Domein Kluisbos", taal: "nl" },
  { id: "31063", stamnummer: "89953", naam: "Era Koop & Woon", taal: "fr" },
  { id: "31403", stamnummer: "20322", naam: "K.r.c. Genk", taal: "nl" },
  { id: "31459", stamnummer: "89998", naam: "Mvc The Ruby's", taal: "nl" },
  { id: "31463", stamnummer: "27526", naam: "De Plekkers", taal: "nl" },
  { id: "31488", stamnummer: "90002", naam: "Historic", taal: "nl" },
  { id: "31872", stamnummer: "66941", naam: "Jong Bevegem", taal: "fr" },
  { id: "31897", stamnummer: "9714", naam: "Sv Ingelmunster", taal: "nl" },
  { id: "31917", stamnummer: "9715", naam: "Vvc Brasschaat", taal: "fr" },
  { id: "32036", stamnummer: "66951", naam: "Fc Beton", taal: "nl" },
  { id: "32037", stamnummer: "66952", naam: "Cotanak Sk", taal: "nl" },
  { id: "32104", stamnummer: "9716", naam: "Fc Bertrix", taal: "fr" },
  { id: "32448", stamnummer: "9717", naam: "Ms Herstal Milmort", taal: "fr" },
  { id: "33147", stamnummer: "9718", naam: "Merchtem United", taal: "nl" },
  { id: "33722", stamnummer: "83040", naam: "Mvc De Hoofdzaak", taal: "nl" },
  { id: "33723", stamnummer: "90005", naam: "Mvt Koklikoo", taal: "nl" },
  { id: "33724", stamnummer: "83039", naam: "Mvv De Kickers", taal: "nl" },
  {
    id: "33738",
    stamnummer: "9719",
    naam: "Union Sportive Musson",
    taal: "fr",
  },
  { id: "33745", stamnummer: "9720", naam: "Fc Porto Brussels", taal: "fr" },
  { id: "33747", stamnummer: "9723", naam: "Racing Anderlecht", taal: "fr" },
  {
    id: "33748",
    stamnummer: "9724",
    naam: "Fc St-nicolas Tilleur",
    taal: "fr",
  },
  { id: "33753", stamnummer: "9722", naam: "Fc Strombeek 1932", taal: "nl" },
  {
    id: "33754",
    stamnummer: "9725",
    naam: "Dendermondse Jeugd 2020",
    taal: "nl",
  },
  {
    id: "33756",
    stamnummer: "9721",
    naam: "Nato Hq Brussels Youth Fa",
    taal: "fr",
  },
  { id: "33762", stamnummer: "5629", naam: "Recrearef Antwerpen", taal: "nl" },
  { id: "33784", stamnummer: "9726", naam: "Afc Evere", taal: "fr" },
  {
    id: "33810",
    stamnummer: "9727",
    naam: "Sporting Excel Jemeppe",
    taal: "fr",
  },
  {
    id: "33826",
    stamnummer: "9728",
    naam: "Union Sportive Sg Anderlecht",
    taal: "fr",
  },
  { id: "33829", stamnummer: "9729", naam: "Namur City", taal: "fr" },
  { id: "33834", stamnummer: "27538", naam: "Phoenix Forest", taal: "fr" },
  { id: "33836", stamnummer: "27537", naam: "Futsal Az Waregem", taal: "nl" },
  { id: "33852", stamnummer: "83076", naam: "Mvc Astromet", taal: "nl" },
  { id: "33946", stamnummer: "9732", naam: "Fc Grand-reng", taal: "fr" },
  { id: "33965", stamnummer: "9731", naam: "Jeunesse Docherie 61", taal: "fr" },
  { id: "34259", stamnummer: "83108", naam: "Fc Johanna", taal: "nl" },
  { id: "60733", stamnummer: "9733", naam: "Racing White Woluwe", taal: "fr" },
  { id: "60816", stamnummer: "9737", naam: "Fc Walhain", taal: "fr" },
  { id: "60817", stamnummer: "9736", naam: "Waterloo Lion'S Fc", taal: "fr" },
  {
    id: "60818",
    stamnummer: "9734",
    naam: "Rr Breivelde-zottegem",
    taal: "nl",
  },
  { id: "60820", stamnummer: "9742", naam: "Fc Inkad Diegem", taal: "nl" },
  { id: "60821", stamnummer: "9741", naam: "Fc Bomal", taal: "fr" },
  { id: "60831", stamnummer: "9735", naam: "Sporting Club Duffel", taal: "nl" },
  {
    id: "60832",
    stamnummer: "9738",
    naam: "Vc Immer Oost-oosterwijk",
    taal: "nl",
  },
  { id: "60833", stamnummer: "9739", naam: "Ac Barry-carrieres", taal: "fr" },
  {
    id: "60834",
    stamnummer: "9740",
    naam: "Sporting Club Farciennes",
    taal: "fr",
  },
  {
    id: "60835",
    stamnummer: "9743",
    naam: "Sporting Synergy Bruxelles",
    taal: "nl",
  },
  { id: "60836", stamnummer: "9746", naam: "Fa Nieuwpoort", taal: "nl" },
  {
    id: "60851",
    stamnummer: "9744",
    naam: "Foot Fun Family Brussels",
    taal: "fr",
  },
  {
    id: "60867",
    stamnummer: "9747",
    naam: "La Jeunesse Sclaynoise",
    taal: "fr",
  },
  { id: "60871", stamnummer: "9749", naam: "LIA Everbeur", taal: "nl" },
  { id: "60886", stamnummer: "9748", naam: "Orly Harelbeke", taal: "nl" },
  {
    id: "60899",
    stamnummer: "9750",
    naam: "Generation Fefa Anderlecht",
    taal: "fr",
  },
  { id: "60900", stamnummer: "9751", naam: "Jeunesse Trazegnies", taal: "fr" },
  { id: "60922", stamnummer: "9752", naam: "Fc Anatolia Gent", taal: "nl" },
  {
    id: "60930",
    stamnummer: "9753",
    naam: "Athl Cl Jeunesse Molenbeek",
    taal: "fr",
  },
  { id: "61014", stamnummer: "9755", naam: "Sv Blauw Wit Temse", taal: "nl" },
  { id: "61055", stamnummer: "9754", naam: "G-voetbal Marke", taal: "nl" },
  { id: "61076", stamnummer: "1610", naam: "RLeopClWalcourt", taal: "fr" },
  { id: "61085", stamnummer: "8756", naam: "Ass.d'arb.walcophil", taal: "fr" },
  { id: "61086", stamnummer: "6617", naam: "K. Sch.vk.'wetthra'", taal: "nl" },
  {
    id: "61087",
    stamnummer: "7720",
    naam: "Vk Sch. G'bergen-zottegem",
    taal: "nl",
  },
  { id: "61089", stamnummer: "2111", naam: "Gab-bsv", taal: "fr" },
  { id: "61102", stamnummer: "8948", naam: "Inter Kolderbos", taal: "nl" },
  { id: "61103", stamnummer: "8649", naam: "SK Beerse", taal: "nl" },
  { id: "61104", stamnummer: "8288", naam: "Driekoningen Torhout", taal: "nl" },
  { id: "61105", stamnummer: "7605", naam: "ES Frasnes-moustier", taal: "fr" },
  { id: "61107", stamnummer: "5926", naam: "OB Breendonk", taal: "nl" },
  { id: "61108", stamnummer: "5697", naam: "DES Leupegem", taal: "nl" },
  {
    id: "61135",
    stamnummer: "9372",
    naam: "Dames Voetbal Tessenderlo",
    taal: "nl",
  },
  { id: "61150", stamnummer: "9563", naam: "FC Turnhout", taal: "nl" },
  {
    id: "61157",
    stamnummer: "5599",
    naam: "Sixieme Province De L'acff",
    taal: "fr",
  },
  {
    id: "61158",
    stamnummer: "5602",
    naam: "Verst Vl Amat Hogere Afd",
    taal: "nl",
  },
  {
    id: "61159",
    stamnummer: "5601",
    naam: "3de Kl Amateurvoetb Vlaanderen",
    taal: "nl",
  },
  { id: "61177", stamnummer: "5623", naam: "Aseus", taal: "fr" },
  { id: "61198", stamnummer: "36", naam: "RRC Tournaisien", taal: "fr" },
  { id: "61199", stamnummer: "67", naam: "RFC Athois", taal: "fr" },
  { id: "61200", stamnummer: "70", naam: "RUS Quievrain", taal: "fr" },
  { id: "61201", stamnummer: "93", naam: "RAA Louvieroise", taal: "fr" },
  { id: "61202", stamnummer: "102", naam: "RUS Lessinoise", taal: "fr" },
  {
    id: "61203",
    stamnummer: "136",
    naam: "R Union Jemappes Flenu",
    taal: "fr",
  },
  { id: "61204", stamnummer: "224", naam: "R Excelsior Mouscron", taal: "fr" },
  {
    id: "61205",
    stamnummer: "278",
    naam: "RA Marchiennoise Des Sports",
    taal: "fr",
  },
  {
    id: "61206",
    stamnummer: "339",
    naam: "RFC Entite Enghien Sports",
    taal: "fr",
  },
  { id: "61207", stamnummer: "511", naam: "R Chatelineau Sp", taal: "fr" },
  { id: "61208", stamnummer: "528", naam: "RFC Ressaix", taal: "fr" },
  {
    id: "61209",
    stamnummer: "1604",
    naam: "R Etoile Boraine-quaregnon",
    taal: "fr",
  },
  { id: "61210", stamnummer: "1653", naam: "RUS Belstam", taal: "fr" },
  { id: "61211", stamnummer: "1905", naam: "RRC Estaimpuis", taal: "fr" },
  {
    id: "61212",
    stamnummer: "2154",
    naam: "RGrpArbitres Basse-sambre",
    taal: "fr",
  },
  {
    id: "61213",
    stamnummer: "2893",
    naam: "RFC Hainaut Sports Tertre",
    taal: "fr",
  },
  { id: "61214", stamnummer: "3193", naam: "RJS Fontainoise", taal: "fr" },
  { id: "61215", stamnummer: "4113", naam: "FC De Bray", taal: "fr" },
  { id: "61216", stamnummer: "4123", naam: "JS Heppignies", taal: "fr" },
  { id: "61217", stamnummer: "4247", naam: "ROCDN Bernissart", taal: "fr" },
  { id: "61218", stamnummer: "4293", naam: "FC Saint-vaast", taal: "fr" },
  { id: "61219", stamnummer: "4302", naam: "RCO Trivierois", taal: "fr" },
  { id: "61220", stamnummer: "4509", naam: "RSC Havre", taal: "fr" },
  { id: "61221", stamnummer: "5201", naam: "R.f.c. D'arquennes", taal: "fr" },
  { id: "61222", stamnummer: "5209", naam: "RFC Souvret", taal: "fr" },
  { id: "61223", stamnummer: "5408", naam: "Entente Pottoise", taal: "fr" },
  { id: "61224", stamnummer: "5438", naam: "FC Pl Aiseau", taal: "fr" },
  { id: "61225", stamnummer: "5509", naam: "FC Erquelinnois", taal: "fr" },
  { id: "61226", stamnummer: "5940", naam: "FC De Saint-ghislain", taal: "fr" },
  { id: "61227", stamnummer: "6131", naam: "CS Jemappes", taal: "fr" },
  { id: "61228", stamnummer: "6133", naam: "Marcinelle FC", taal: "fr" },
  { id: "61229", stamnummer: "6347", naam: "FCRVMacquenoise", taal: "fr" },
  { id: "61230", stamnummer: "6389", naam: "Cs Monceau-hameau", taal: "fr" },
  { id: "61231", stamnummer: "6627", naam: "US Riezoise", taal: "fr" },
  {
    id: "61232",
    stamnummer: "6628",
    naam: "JS Montigny-landelies",
    taal: "fr",
  },
  { id: "61233", stamnummer: "6717", naam: "US Maconaise", taal: "fr" },
  { id: "61234", stamnummer: "6737", naam: "F.c. Val D'heure", taal: "fr" },
  { id: "61235", stamnummer: "7016", naam: "UJS Charleroi", taal: "fr" },
  { id: "61236", stamnummer: "7033", naam: "Fc Petit-enghien", taal: "fr" },
  { id: "61237", stamnummer: "7094", naam: "FC De Wiheries", taal: "fr" },
  { id: "61238", stamnummer: "7165", naam: "Ransart Sp FC", taal: "fr" },
  { id: "61239", stamnummer: "7189", naam: "FC JS Bouffioulx", taal: "fr" },
  {
    id: "61240",
    stamnummer: "7194",
    naam: "Amicale Club Morlanwelz",
    taal: "fr",
  },
  { id: "61241", stamnummer: "7318", naam: "FC Fontaine-valmont", taal: "fr" },
  { id: "61242", stamnummer: "7430", naam: "FC Soleilmont", taal: "fr" },
  { id: "61243", stamnummer: "7448", naam: "FC Frasnois", taal: "fr" },
  { id: "61244", stamnummer: "7450", naam: "FC Baseclois", taal: "fr" },
  { id: "61245", stamnummer: "7462", naam: "StCl Biercee", taal: "fr" },
  {
    id: "61246",
    stamnummer: "7573",
    naam: "FC Standard De Chatelet",
    taal: "fr",
  },
  { id: "61247", stamnummer: "7611", naam: "US Estinnoise", taal: "fr" },
  { id: "61248", stamnummer: "7652", naam: "SC Vallois", taal: "fr" },
  { id: "61249", stamnummer: "7655", naam: "Racing Club Dourois", taal: "fr" },
  { id: "61250", stamnummer: "7676", naam: "FC Pavillon Dochard", taal: "fr" },
  { id: "61251", stamnummer: "7677", naam: "JS Gaurain", taal: "fr" },
  { id: "61252", stamnummer: "7737", naam: "AssHenn Div Inf", taal: "fr" },
  { id: "61253", stamnummer: "7970", naam: "FC Roucourtois", taal: "fr" },
  { id: "61254", stamnummer: "7998", naam: "FC La Glanerie", taal: "fr" },
  { id: "61255", stamnummer: "8100", naam: "AFC Peronnes", taal: "fr" },
  { id: "61256", stamnummer: "8110", naam: "EntSp Des Carrieres", taal: "fr" },
  { id: "61257", stamnummer: "8137", naam: "Fc SpLoisMontroeul", taal: "fr" },
  {
    id: "61258",
    stamnummer: "8141",
    naam: "Fc SJ Montignies-s-sambre",
    taal: "fr",
  },
  {
    id: "61259",
    stamnummer: "8193",
    naam: "Club Blandain Don Bosco",
    taal: "fr",
  },
  { id: "61260", stamnummer: "8194", naam: "FC Ramegnies-lamain", taal: "fr" },
  {
    id: "61261",
    stamnummer: "8277",
    naam: "Sporting Club De Tertre",
    taal: "fr",
  },
  { id: "61262", stamnummer: "8289", naam: "AS Chatelineau", taal: "fr" },
  { id: "61263", stamnummer: "8460", naam: "US Leersoise", taal: "fr" },
  { id: "61264", stamnummer: "8658", naam: "F.c. Etoiles D'ere", taal: "fr" },
  { id: "61265", stamnummer: "8665", naam: "FC College", taal: "fr" },
  {
    id: "61266",
    stamnummer: "8692",
    naam: "Fc Vellereille Bonne Esp",
    taal: "fr",
  },
  { id: "61267", stamnummer: "8786", naam: "SC De Pecq", taal: "fr" },
  {
    id: "61268",
    stamnummer: "8806",
    naam: "SC Tournai-vert Bocage",
    taal: "fr",
  },
  {
    id: "61269",
    stamnummer: "8954",
    naam: "Am Des ArbMouscron Et Envir",
    taal: "fr",
  },
  { id: "61270", stamnummer: "8966", naam: "Roux Sport", taal: "fr" },
  {
    id: "61271",
    stamnummer: "9029",
    naam: "ES Feminine Gerpinnes",
    taal: "fr",
  },
  {
    id: "61272",
    stamnummer: "9072",
    naam: "Racing Club Montagnard",
    taal: "fr",
  },
  { id: "61273", stamnummer: "9128", naam: "JS Orcq", taal: "fr" },
  { id: "61274", stamnummer: "9155", naam: "ASC Havinnes", taal: "fr" },
  {
    id: "61275",
    stamnummer: "9247",
    naam: "AS Strepy-bracquegnies",
    taal: "fr",
  },
  { id: "61276", stamnummer: "9262", naam: "FC Pieton Sport", taal: "fr" },
  {
    id: "61277",
    stamnummer: "9268",
    naam: "CRER Quaregnon-wasmuel",
    taal: "fr",
  },
  { id: "61278", stamnummer: "9269", naam: "Femina FC Tournai", taal: "fr" },
  {
    id: "61279",
    stamnummer: "9272",
    naam: "Un Sp Fdc Petit-enghien",
    taal: "fr",
  },
  {
    id: "61280",
    stamnummer: "9276",
    naam: "ASC Mont-sur-marchienne",
    taal: "fr",
  },
  { id: "61281", stamnummer: "9277", naam: "SC Lodelinsart", taal: "fr" },
  {
    id: "61282",
    stamnummer: "9278",
    naam: "Sporting Pont-de-loup",
    taal: "fr",
  },
  { id: "61283", stamnummer: "9280", naam: "FC Aldegondois", taal: "fr" },
  { id: "61284", stamnummer: "9286", naam: "FC Femina Braine", taal: "fr" },
  { id: "61285", stamnummer: "9287", naam: "JS Dampremy", taal: "fr" },
  { id: "61286", stamnummer: "9295", naam: "FC Ville-sur-haine", taal: "fr" },
  { id: "61287", stamnummer: "9354", naam: "ASD Ramegnies-chin", taal: "fr" },
  { id: "61288", stamnummer: "9435", naam: "FC Ath Sport", taal: "fr" },
  { id: "61289", stamnummer: "9436", naam: "Racing Saint-amand", taal: "fr" },
  {
    id: "61290",
    stamnummer: "9437",
    naam: "Jeunesse Sportive De Bray",
    taal: "fr",
  },
  { id: "61291", stamnummer: "9458", naam: "FC Centre Sport", taal: "fr" },
  {
    id: "61292",
    stamnummer: "9460",
    naam: "US Esperance Aldegonde",
    taal: "fr",
  },
  {
    id: "61293",
    stamnummer: "9479",
    naam: "Union Sportive Wodecq",
    taal: "fr",
  },
  { id: "61294", stamnummer: "9481", naam: "JS Ramecroix", taal: "fr" },
  { id: "61295", stamnummer: "9529", naam: "Femina Sp Charleroi", taal: "fr" },
  { id: "61297", stamnummer: "3440", naam: "Fc Brakel", taal: "nl" },
  {
    id: "61299",
    stamnummer: "9745",
    naam: "Belgian Deaf Sport Committee",
    taal: "nl",
  },
  { id: "61300", stamnummer: "9399", naam: "Excelsior Anderlecht", taal: "fr" },
  {
    id: "61301",
    stamnummer: "9402",
    naam: "FC Young Stars Antwerp",
    taal: "nl",
  },
  { id: "61351", stamnummer: "9407", naam: "Vurste' 92", taal: "nl" },
  { id: "61352", stamnummer: "9412", naam: "FC Diyanet Zaventem", taal: "fr" },
  { id: "61361", stamnummer: "9417", naam: "Gentse Rangers 2002", taal: "nl" },
  { id: "61368", stamnummer: "9420", naam: "SD Entente Jettoise", taal: "fr" },
  { id: "61369", stamnummer: "9421", naam: "FC Racing Molenbeek", taal: "fr" },
  {
    id: "61370",
    stamnummer: "9418",
    naam: "FC Pelgrim United Merksem",
    taal: "nl",
  },
  { id: "61376", stamnummer: "9422", naam: "US Nevraumont", taal: "fr" },
  {
    id: "61378",
    stamnummer: "9424",
    naam: "Sporting Club Hillegem",
    taal: "nl",
  },
  {
    id: "61406",
    stamnummer: "5383",
    naam: "WV Scheidsrechters W-vl",
    taal: "nl",
  },
  { id: "61426", stamnummer: "9427", naam: "Pamel 88", taal: "nl" },
  { id: "61427", stamnummer: "9429", naam: "United Gent", taal: "nl" },
  { id: "61428", stamnummer: "9430", naam: "Inter Gent", taal: "nl" },
  {
    id: "61431",
    stamnummer: "9432",
    naam: "Racing White De Woluwe",
    taal: "fr",
  },
  { id: "61445", stamnummer: "9443", naam: "FC Jong Merksem", taal: "nl" },
  {
    id: "61449",
    stamnummer: "9444",
    naam: "Football Club Charleroi",
    taal: "fr",
  },
  { id: "61450", stamnummer: "9445", naam: "Sporting Schaerbeek", taal: "fr" },
  { id: "61455", stamnummer: "9440", naam: "SV Koolkerke", taal: "nl" },
  { id: "61474", stamnummer: "9448", naam: "FC Ixelles", taal: "fr" },
  { id: "61513", stamnummer: "9451", naam: "FC Edegem United", taal: "nl" },
  {
    id: "61520",
    stamnummer: "9453",
    naam: "FC Genclerbirligi Zele",
    taal: "nl",
  },
  {
    id: "61521",
    stamnummer: "9455",
    naam: "Football Club Nandrin",
    taal: "fr",
  },
  { id: "61534", stamnummer: "9454", naam: "FC Molenbeek City", taal: "fr" },
  {
    id: "61538",
    stamnummer: "9462",
    naam: "Sporting Club Bon Air",
    taal: "fr",
  },
  {
    id: "61539",
    stamnummer: "9461",
    naam: "Jodoigne Football Club",
    taal: "fr",
  },
  { id: "61540", stamnummer: "9464", naam: "Dynamo Anderlecht", taal: "fr" },
  {
    id: "61591",
    stamnummer: "9473",
    naam: "RRC De Bruxelles 1891",
    taal: "fr",
  },
  { id: "61609", stamnummer: "9475", naam: "DHW Denderhoutem", taal: "nl" },
  { id: "61657", stamnummer: "9484", naam: "Sporting Ertvelde", taal: "nl" },
  { id: "61663", stamnummer: "9488", naam: "Ladies Merksem", taal: "nl" },
  { id: "61668", stamnummer: "9491", naam: "FC Dour", taal: "fr" },
  { id: "61671", stamnummer: "9493", naam: "VFC De Antuerpia", taal: "nl" },
  { id: "61679", stamnummer: "9496", naam: "Sport Haren", taal: "nl" },
  { id: "61680", stamnummer: "9495", naam: "FC Espoir Molenbeek", taal: "fr" },
  {
    id: "61694",
    stamnummer: "9497",
    naam: "Olympique Molenbeekois",
    taal: "fr",
  },
  { id: "61771", stamnummer: "9515", naam: "Dvc Veerle Zwart-wit", taal: "nl" },
  {
    id: "61779",
    stamnummer: "9520",
    naam: "Racing Club Nieuwenrode",
    taal: "nl",
  },
  { id: "61903", stamnummer: "9568", naam: "FC Zandvliet", taal: "nl" },
  { id: "61930", stamnummer: "9614", naam: "Sporting Club Kelmis", taal: "fr" },
  { id: "61931", stamnummer: "9630", naam: "VC Kessel", taal: "nl" },
  { id: "61942", stamnummer: "9730", naam: "Beerschot VAC", taal: "nl" },
  { id: "61989", stamnummer: "4060", naam: "CsInstScolPrBrb", taal: "nl" },
  { id: "R61013", stamnummer: "R61013", naam: "SVB Driehoek", taal: "nl" },
];
